{
  "LAST_EDITED": "Sist redigert",
  "VAT": "MVA",
  "CUSTOM": "Egendefinert",
  "LINE": "Linje",
  "ADD_REFERENCE_LINE": "Legg til en linje",
  "UNKNOWN": "Ukjent",
  "DISCARD_CHANGES": "Forkast endringer",
  "ON_BEHALF_OF": "på vegne av",
  "MORE_ALTERNATIVES": "Flere alternativer",
  "CREATE": "Opprett",
  "NO_PREFERENCE": "Ingen preferanse",
  "FILTER": "Filtrer",
  "NO_FILTERS_AVAILABLE": "Ingen filtre tilgjengelig",
  "NO_VALUE": "Ingen verdi",
  "HAS_VALUE": "Har verdi",
  "I_AM_DONE": "Jeg er ferdig",
  "VARIOUS": "Diverse",
  "NONE": "Ingen",
  "THE_DATE_OR_TIME": "Datoen eller tiden",
  "TO": "Til",
  "SERVICE_FEE": "Tjenestegebyr",
  "FREE_FOR_LIMITED_TIME": "Kostnadsfritt i en begrenset periode",
  "RESET": "Nullstill",
  "UPLOAD_FILE": "Last opp fil",
  "TABLE": {
    "COLUMN_PICKER": {
      "TITLE": "Kolonneinnstillinger",
      "SHOW_ALL": "Vis alle",
      "HIDE_ALL": "Skjul alle"
    }
  },
  "IS": "er",
  "WILL_BE": "blir",
  "WAS": "var",
  "TRANSLATE": "Oversett",
  "EXPAND_PARAGRAPH": "Les mer",
  "COLLAPSE_PARAGRAPH": "Skjul tekst",
  "THE_BUILDING": "Bygget",
  "SORTING_ORDER": "Rekkefølge",
  "CHRONOLOGICAL": "Kronologisk",
  "NEWEST": "Nyest",
  "OLDEST": "Eldst",
  "CALENDAR": {
    "VIEW": {
      "MONTH": "Måned",
      "WEEK": "Uke",
      "DAY": "Dag"
    }
  },
  "ENABLED": "Aktivert",
  "DISABLED": "Deaktivert",
  "COMING_SOON": "Kommer snart",
  "PRICE": "Pris",
  "STEP": "Steg",
  "NEXT_STEP": "Neste steg",
  "PREVIOUS_STEP": "Forrige steg",
  "CLOSED": "Stengt",
  "CLOSE": "Lukk",
  "ALL": "Alle",
  "SCHEDULER_FOLLOW_TIME": "Følg nåtiden",
  "EXCLUDING_VAT": "eks. MVA",
  "INCLUDING_VAT": "inkl. MVA",
  "LABEL": "Tekst",
  "NEW": "Nytt",
  "NEW_ALT": "Ny",
  "CHOOSE": "Velg",
  "ALL_DAYS": "Alle dager",
  "DAYS_one": "Dag",
  "DAYS_other": "Dager",
  "DAYS": "Dager",
  "GENERAL": "Generelt",
  "COMBINED": "Kombinert",
  "GENERAL_SETTINGS": "Generelle innstillinger",
  "DETAILS": "Detaljer",
  "OTHER": "Annen",
  "USER_one": "Bruker",
  "USER_other": "Brukere",
  "FILE": "Filen",
  "FLOOR": "Etasje",
  "PEOPLE_one": "Person",
  "PEOPLE_other": "Personer",
  "HOURS_one": "Time",
  "HOURS_other": "Timer",
  "RESULTS_one": "{{count}} resultat",
  "RESULTS_other": "{{count}} resultater",
  "ORDER": "Bestill",
  "PREVIOUS": "Forrige",
  "BACK": "Tilbake",
  "NEXT": "Neste",
  "DEFAULT_SELECT": {
    "PLACEHOLDER": "Valgmeny...",
    "START_SEARCH": "Begynn å skrive for å søke",
    "NO_RESULTS": "Ingen resultater",
    "SEARCHING": "Søker..."
  },
  "REDIRECT": {
    "HEADER": "Vi har byttet url!",
    "SUB_HEADER": "Vennligst gå til"
  },
  "TOTAL": "totalt",
  "LOGIN_TAGLINE": "Welcome Workdays brukes på {{buildingName}} for å forenkle din hverdag.",
  "EDIT": "Rediger",
  "DELETE": "Slett",
  "ADD": "Legg til",
  "UPDATE": "Oppdater",
  "USE_DEFAULT": "Bruk standard",
  "LANG_NO": "Norsk",
  "LANG_EN": "Engelsk",
  "YOUR_MAIN_ADMIN": "Ditt selskaps primære kontaktperson er <mailto>{{ companyContact }}</mailto>.",
  "SEARCH": "Søk",
  "VISIBLE": "Synlig",
  "HIDDEN": "Skjult",
  "HAS_NOT_LOGGED_IN": "Har ikke logget inn",
  "ROWS_PER_PAGE": "Rader per side",
  "OF": "av",
  "OR": "eller",
  "MISSING_COUNTRY_CODE": "Telefonnummer mangler landskode (eks. +47)",
  "REVERT_CHANGES": "Angre endringer",
  "SAVE_CHANGES": "Lagre endringer",
  "CANCEL": "Avbryt",
  "CONTINUE": "Fortsett",
  "SUBMIT": "Legg til",
  "EXIT": "Avslutt",
  "NUMBERS": "siffer",
  "CHARACTERS": "tegn",
  "THE_TEXT": "Teksten",
  "YES": "Ja",
  "NO": "Nei",
  "FROM": "fra",
  "NOW": "Nå",
  "JUST_NOW": "Nå nettopp",
  "MINUTES_one": "Minutt",
  "MINUTES_other": "Minutter",
  "MINUTES_AGO_one": "{{count}} minutt siden",
  "MINUTES_AGO_other": "{{count}} minutter siden",
  "TODAY": "I dag",
  "TOMORROW": "I morgen",
  "AT": "kl",
  "ARRIVED_one": "Ankom",
  "ARRIVED_other": "Ankommet",
  "ANSWER": "Svar",
  "LET_IN": "Slipp inn",
  "VISIBILITY_TOGGLE_DESCRIPTION": "Slå på for å gjøre navnet ditt synlig i besøksregistreringskiosken.",
  "ADMIN_VISIBILITY_TOGGLE_DESCRIPTION": "Slå på for å gjøre brukeren synlig i besøksregistreringskiosken.",
  "YOU": "Du",
  "COMPANY": "Selskapet",
  "PORTAL_VERSION": "Portal versjon: ",
  "SEND": "Send",
  "SMS_SEND": "SMS ble sendt",
  "OPTIONAL": " (valgfritt)",
  "NOT_INTEGRATED": "Bruker er ikke integrert med adgangskontrollsystem",
  "UNSAVED_CHANGES": {
    "TITLE": "Du har ikke lagret endringene dine!",
    "BODY": "Ved å fortsette mister du alle endringene som er gjort. Ønsker du å avbryte for å forbli på siden og beholde endringene?"
  },
  "ANSWER_VISITOR": {
    "ACCORDION_HEADER": "Send en melding",
    "QUICKLY": "Svar med ett klikk",
    "BE_THERE": "Jeg er der om",
    "PREDEFINED_MESSAGE_X_MIN": "Jeg kommer om {{minutes}} minutter",
    "CUSTOM_MESSAGE": "Eller skriv en egen beskjed",
    "NO_REPLY_INFO": "Den besøkende kan ikke svare",
    "PREFERS_ENGLISH": "Den besøkende foretrekker engelsk og kan ikke svare",
    "LABEL": "Egendefinert melding",
    "PLACEHOLDER": "Vent på meg ved",
    "DISABLED_DESCRIPTION": "Det er utenfor bygningens åpningstider, du kan fortsatt hente din besøkende selv.",
    "REPLY": "{{ name }} svarte",
    "ANOTHER_MESSAGE": "Send en melding til",
    "SEND_MESSAGE_TOO": "Send en melding i tillegg",
    "TIMED_OUT": "Dette besøket var for mer enn 1 time siden",
    "NO_REPLY": "Du sendte ikke noe svar",
    "NO_REPLY_COMPANY": "Ingen sendte noe svar",
    "WAS_LET_IN": "Du slapp den besøkende inn kl.",
    "WAS_LET_IN_COMPANY": "Den besøkende ble sluppet inn kl.",
    "LET_IN_VISITOR": "Slipp inn besøkende",
    "SEND_ACCESS_CODE": "Send adgangskode som åpner portene",
    "CODE_ALREADY_SENT": "Du har allerede sendt en adgangskode kl.",
    "LET_IN": "Slipp inn",
    "LET_IN_SUCCESS": "Sendte adgangskode til den besøkende",
    "LET_IN_ERROR": "Kunne ikke sende adgangskode. Prøv igjen senere!",
    "ERROR_SENDING_MESSAGE": "Vi kunne ikke sende en adgangskode til den besøkende. Vennligst ta kontakt direkte.",
    "ERROR_HEADER": "Noe gikk galt",
    "CODE_GENERATION_FAILED": "Vi kunne ikke lage en adgangskode til den besøkende. Du kan prøve igjen én gang.",
    "SMS_SEND_FAILED": "Vi kunne ikke sende adgangskoden til den besøkende på SMS. Sjekk telefonnummeret og ta kontakt med den besøkende direkte.",
    "TRY_AGAIN": "Prøv igjen",
    "ALREADY_LET_IN": "Denne besøkende er allerede sluppet inn.",
    "ALREADY_CHECKED_IN": "Denne deltakeren er allerede sjekket inn.",
    "LET_IN_IN_PROGRESS": "En adgangskode sendes allerede til den besøkende. Vent litt.",
    "LET_IN_RESULT_NOT_SAVED": "Vi kunne ikke bekrefte at adgangskoden ble sendt. Vennligst ta kontakt med den besøkende direkte.",
    "LET_IN_PROGRESS": {
      "GENERATING": "Lager adgangskoden…",
      "ACTIVATING": "Aktiverer adgangskoden…",
      "SENDING": "Sender koden til den besøkende…",
      "TAKING_LONGER": "Dette tar litt lengre tid enn vanlig, vent litt…"
    }
  },
  "MESSAGE_BODY": "Melding fra {{hostName}}: {{message}}",
  "IMAGE": {
    "LABEL": "Bilde",
    "THUMBNAIL": "Miniatyrbilde",
    "NUMBERED": "Bilde {{number}}",
    "UPLOAD_FAILED_CONFIRM": {
      "TITLE_one": "1 bilde kunne ikke lastes opp",
      "TITLE_other": "{{count}} bilder kunne ikke lastes opp",
      "BODY": "Du kan lagre uten dem, eller gå tilbake og bytte dem ut.",
      "DISCARD": "Lagre uten disse bildene",
      "GO_BACK": "Gå tilbake"
    },
    "PLACEHOLDER": {
      "LOGO": "Logo har ikke blitt lastet opp",
      "TEAM": "Gruppebilde har ikke blitt lastet opp",
      "BANNER": "Bannerbilde har ikke blitt lastet opp",
      "PROFILE": "Profilbilde mangler",
      "OWNER_LOGO": "Byggeiers logo mangler",
      "GENERIC": "Legg til bilde(r)"
    },
    "UPLOAD": "Last opp bilde",
    "REPLACE": {
      "ARIA_LABEL": "Bytt ut nåværende bilde",
      "TEXT": "Last opp nytt bilde"
    },
    "BACKGROUND_TOGGLE_TEXT": "Bakgrunn",
    "UNDO": "Angre endring",
    "DONE": "Ferdig",
    "CANCEL": "Avbryt",
    "FILE_TOO_LARGE": "Filen er for stor, velg en annen",
    "DROP_ZONE_TEXT": "Slipp bildet her for å laste opp",
    "ROTATE_CW": "Roter med klokken",
    "ROTATE_CCW": "Roter mot klokken",
    "PROFILE_TIPS": "Vennligst påse at bildet...<ul><li>Passer i 4:3 formatet</li><li>Har hvit/lys bakgrunn</li><li>Viser hele ansiktet tydelig, vendt forover, øyne åpne, ingen solbriller</li></ul>",
    "PROFILE_TIPS_EXTRA": "<ul><li>Vennligst plasser ansiktet ditt inne i ovalen</li><li>Se rett frem med åpne øyne</li><li>Sørg for at hele ansiktet er synlig (ingen solbriller)</li></ul>",
    "GENERATE_WITH_AI": "Generer bilde med KI",
    "GENERATE_MORE": "Generer flere bilder"
  },
  "PAGES": {
    "NEWS": {
      "HEADER": "Nyheter",
      "SUBHEADER": "Her er en oversikt over nyheter i {{buildingName}}. Dette inkluderer alt fra kritiske driftsmeldinger til tilbud for deg som jobber i bygget.",
      "PLACEHOLDER": "Ingen nyheter her enda!",
      "NEW": {
        "HEADER": "Ny nyhet",
        "SUBHEADER": "Her kan du opprette en ny nyhet. For å tilrettelegge for brukere som ikke snakker norsk må alt innhold oversettes til engelsk."
      },
      "EDIT_UNPUBLISHED": {
        "HEADER": "Rediger utkast",
        "SUBHEADER": "Siden nyheten ikke er publisert enda, kan du redigere den fritt. Legg merke til at ved publisering vil redigeringsmuligheten reduseres."
      },
      "EDIT_PUBLISHED": {
        "HEADER": "Rediger publisert nyhet",
        "SUBHEADER": "Siden nyheten er publisert er det noen detaljer som ikke kan redigeres."
      }
    },
    "WELCOME": {
      "HEADER": "Velkommen til <highlight>{{ buildingName }}</highlight>",
      "GREETING": "<paragraph>Hei <bold>{{ userName }}</bold>,</paragraph><paragraph>{{buildingName}} eies og driftes av {{ownerName}}. Her har vi tatt i bruk Welcome Workdays for å gjøre din arbeidsdag litt enklere – og med det forhåpentligvis litt bedre.</paragraph><paragraph>Med Welcome Workdays gir vi de besøkende en smidigere besøksopplevelse, og du kan kommunisere med dem via SMS. Du kan dessuten holde deg oppdatert om eiendommen og se ukens meny i kantina. Welcome Workdays vil utvikle mer funksjonalitet i tiden som kommer.</paragraph><paragraph>For å holde deg oppdatert, trenger vi ditt samtykke slik at du kan motta relevant informasjon fra oss. Du kan når som helst administrere ditt samtykke via \"Min profil\".</paragraph><paragraph>Ha en fin arbeidsdag!</paragraph><regards><paragraph>Vennlig hilsen,<linebreak /><bold>{{ buildingAdminName }}</bold><linebreak />{{ jobTitle }} i {{ companyName }}</paragraph><signature>{{ signature }}</signature></regards>",
      "CONSENTS": {
        "HEADER": "Samtykker",
        "GENERAL": "Samtykke til kommunikasjon <bold>Motta nyheter og informasjon om bygget.</bold><paragraph> Vi ønsker å holde deg oppdatert om hva som skjer på din arbeidsplass. Ved å gi oss ditt samtykke, tillater du oss å sende deg informasjon, oppdateringer og tilbud via e-post, SMS og andre kanaler, fra oss, gårdeier eller andre leverandører på bygget slik som kantinedriver. Du kan administrere dine samtykker via «Profilinnstillinger».</paragraph>",
        "DISCLAIMER": "Ved å fortsette godtar du våre <terms>brukervilkår</terms> og bekrefter at du har lest vår <policy>personvernserklæring</policy>."
      },
      "DECLINE": "Avvis",
      "ACCEPT": "Aksepter",
      "YOUR_CHOICE": "Du kan til enhver tid trekke tilbake et samtykke",
      "YOU_LOSE": "men vær oppmerksom på at det vil kunne gi deg mindre tilgang til tilbud knyttet til bygget. Vi gjør oppmerksom at Welcome Workdays og gårdeier er svært opptatt av personvern og datasikkerhet, og bruker til enhver tid de ledende standardene til dette.",
      "MODAL": {
        "HEADER": "Er du sikker?",
        "BODY": "Du kan fritt avvise samtykke",
        "DECLINE": "Avvis likevel"
      },
      "ACTIVATION_SUCCESS": "Brukerkontoen din ble aktivert. Velkommen!",
      "ACTIVATION_ERROR": "Klarte ikke å aktivere brukerkontoen din. Last inn siden på nytt og prøv igjen!"
    },
    "LUNCH": {
      "TOPUP": {
        "ERROR_CREATING_PAYMENT": "Klarte ikke å opprette betaling. Prøv igjen senere!",
        "QUICK_LUNCHES": "Et par raske lunsjer",
        "RECOMMENDED": "Anbefalt!",
        "AUTOPILOT": "Lunsj på autopilot",
        "GOOD_FLOW": "God flyt i lunsjen",
        "CUSTOM_AMOUNT": "Egendefinert beløp",
        "AMOUNT": "Beløp",
        "MIN_AMOUNT": "Minstebeløp er 50 kr",
        "TOP_UP": "Fyll på",
        "REDIRECTING": "Du blir snart omdirigert til betalingssiden..."
      },
      "SUBHEADER": "Her kan du se og administrere din saldo og transaksjoner i personalrestauranten.",
      "NO_DEAL_HEADER": "Vi fant ikke din lunsjavtale!",
      "NO_DEAL_BODY": "Be din administrator om å gi deg en ny lunsjavtale.",
      "LUNCH_CARD": "Lunsjkort",
      "BALANCE": "Saldo",
      "TOP_UP": "Fyll på",
      "BALANCE_TOOLTIP": "Det kan ta noen sekunder før saldoen oppdateres etter påfyll!",
      "CREDIT": {
        "LABEL": "Kreditt",
        "TOOLTIP": "Din arbeidsgiver dekker et månedlig beløp du kan bruke i personalrestauranten. Den fornyes automatisk på starten av hver måned. Når du har brukt opp kreditten din, må du betale for lunsj fra egen saldo.",
        "REMAINING": "Gjenstående kreditt",
        "RENEWAL_TOMORROW": "Fornyes i morgen",
        "RENEWAL_IN_X_DAYS": "Fornyes om {{count}} dager"
      },
      "PRICE_PER_LUNCH": "Din pris per lunsj",
      "WITH_DEAL": "Med avtale",
      "WITH_SUBSIDY": "* Din arbeidsgiver subsidierer <bold>{{subsidyPercentage}}%</bold> av den faktiske lunsjprisen",
      "SUBSIDY_MESSAGE": "Din arbeidsgiver <bold>subsidierte {{subsidyPercentage}}%</bold> av lunsjprisen.",
      "COST_DISTRIBUTION": "Kostnadsfordeling",
      "DEDUCTED_FROM": "trukket fra {{source}}",
      "TRANSACTIONS": "Transaksjoner",
      "NO_TRANSACTIONS": "Du har ingen transaksjoner enda",
      "DOWNLOAD_RECEIPT": "Last ned kvittering",
      "TOPUP_MODAL_HEADER": "Fyll på saldo",
      "QR_MODAL_HEADER": "Personlig lunsjkort",
      "QR_MODAL_BODY_1": "Når du vil spise lunsj,",
      "QR_MODAL_BODY_2": "skanner du QR-koden på vei inn i personalrestauranten",
      "QR_MODAL_BODY_3": ". Vi trekker automatisk prisen fra saldoen din.",
      "QR_MODAL_WARNING": "Ikke del din QR-kode med andre. Den er personlig, og er knyttet til din saldo.",
      "QR_MODAL_WARNING_FREE_DEAL": "Ikke del din QR-kode med andre. Den er personlig, og er knyttet til din bruker.",
      "ADD_TO_WALLET": "Legg til i lommebok",
      "CLICK_TO_EXPAND": "Trykk for å se full størrelse",
      "WALLET_MODAL": {
        "HEADER": "Legg til lunsjkortet i din digitale lommebok",
        "BODY": "Skann QR-koden under med kameraet på mobilen for å legge til lunsjkortet i den digitale lommeboken på mobilen din. Vi støtter både Apple Wallet og Google Wallet.",
        "QR_ERROR": "Noe gikk galt. Prøv igjen senere!"
      },
      "ONBOARDING": {
        "HEADER": "Du er nesten klar til å spise lunsj!",
        "SUBHEADER": "Her er en kort innledning til hvordan det funker...",
        "STEP_1_TITLE": "Saldo",
        "STEP_1_BODY_BOLD": "Ved behov fyller du på din saldo her",
        "STEP_1_BODY": ", i Welcome Workdays. Hvor ofte og hvor mye du fyller på er helt opp til deg - jo høyere beløp du fyller på jo mindre trenger du å tenke på det!",
        "STEP_1_CREDIT_BOLD": "Din arbeidsgiver dekker også en månedlig kreditt på {{amount}}.",
        "STEP_1_CREDIT": "Dine lunsjkostnader trekkes fra kreditten først. Du bruker kun din egen saldo dersom du går tom for kreditt for måneden!",
        "STEP_2_TITLE": "Lunsjkort",
        "STEP_2_BODY_BOLD": "Du har nå et personlig lunsjkort",
        "STEP_2_BODY": " knyttet til din konto. Vi anbefaler at du legger til kortet i den digitale lommeboken på mobilen din for enklere adgang ved lunsjtid.",
        "STEP_3_TITLE": "Spise lunsj",
        "STEP_3_BODY_1": "Når du vil spise lunsj,",
        "STEP_3_BODY_BOLD": " skanner du QR-koden på lunsjkortet ditt",
        "STEP_3_BODY_2": " ved skjermen i restauranten. Vi trekker prisen fra saldoen din - ingen app, betaling eller mas!",
        "STEP_3_BODY_2_FREE_DEAL": ". Det er alt - ingen app, betaling eller mas!",
        "STEP_3_BODY_MULTI_VARIANT": "Personalrestauranten har 2 valg ved lunsjtid; \"{{variant1}}\" og \"{{variant2}}\". ",
        "STEP_3_BODY_MULTI_VARIANT_BOLD": "velger du den du vil ha og ",
        "STEP_3_PS_BOLD": "PS!",
        "STEP_3_PS": "Lunsjen koster deg {{price}} per gang",
        "STEP_3_PS_TWO_VARIANTS": "Lunsjen koster deg {{price}} for \"{{variant1}}\" og {{price2}} for \"{{variant2}}\"",
        "STEP_3_PS_FREE_DEAL": "Din lunsj er helt subsidiert og koster deg derfor ingenting.",
        "STEP_4_TITLE": "Kom i gang!",
        "STEP_4_HEADER": "Så enkelt er det!",
        "STEP_4_BODY": "Kom i gang ved å fylle på din saldo.",
        "STEP_4_BODY_FREE_DEAL": "Gjør deg klar for lunsj! Bon appétit.",
        "DISMISS_BUTTON": "Jeg fyller på senere",
        "DISMISS_BUTTON_FREE_DEAL": "Jeg er klar"
      },
      "TRANSACTION_TYPES": {
        "LUNCH_EATEN": "Lunsj i personalrestaurant",
        "GUEST_LUNCH_EATEN": "{{guestCount}}x gjestelunsj i personalrestaurant",
        "TOPUP": "Påfyll av saldo",
        "REFUND": "Saldo tilbakebetaling",
        "WAITING_CONFIRMATION": "(venter på bekreftelse på godkjent betaling",
        "LINK_EXPIRED": "betalingslenke utløpt",
        "CANCELLED": "betaling avbrutt",
        "FAILED": "betaling feilet"
      }
    },
    "DASHBOARD": {
      "GREETING": {
        "MORNING": "God morgen, {{name}}",
        "DAY": "God dag, {{name}}",
        "EVENING": "God kveld, {{name}}"
      },
      "FOOD_WIDGET": {
        "MODAL": {
          "HEADER": "Lunsjmenyen denne uken",
          "SUBHEADER": "Uke {{weekNumber}}",
          "EARLIER": "Tidligere i uken"
        }
      },
      "MEET_THE_TEAM": "Bli kjent med teamet i <nowrap>{{buildingName}}</nowrap>",
      "TODAY": {
        "LUNCH": "Lunsj i dag",
        "NEXT_BOOKING": "Neste reservasjon",
        "VISITORS": "Besøkende i dag",
        "UNREAD_NEWS": "Uleste nyheter",
        "EXPECTED": "{{count}} forventet",
        "NEXT_ARRIVAL": "Neste ankomst {{time}}",
        "NEW_COUNT": "{{count}} nye",
        "MORE_DISHES": "og {{count}} til",
        "HEADER": "For deg i dag",
        "SCAN_TO_PAY": "Skann QR-koden når du går inn",
        "OPEN_UNTIL": "Kantinen er åpen til {{time}}",
        "VISITOR_NOW": "Besøk nå",
        "VISITOR_ARRIVED": "{{name}} har ankommet",
        "VISITORS_WAITING": "{{count}} besøkende venter på deg",
        "ARRIVED_AT": "Ankom {{time}}. Slipp inn eller svar i Welcome Visit."
      },
      "EVERYTHING_IN": "Alt i {{buildingName}}",
      "MODULES": {
        "VISITORS": "Forhåndsregistrer og følg gjestene dine",
        "ACCESS": "Adgangskortet og PIN-koden din",
        "INFO": "Praktisk informasjon om {{buildingName}}",
        "BOOKINGS": "Møterom og ressurser",
        "LUNCH": "Meny, saldo og lunsjkort",
        "MY_ORDERS": "Bestillinger av møtemat",
        "CUSTOM": "Åpnes i ny fane"
      },
      "UNREAD": "Ulest",
      "NEWS_FROM_BUILDING": "Nytt fra {{buildingName}}",
      "ALL_NEWS": "Se alle nyheter",
      "HELP": {
        "HEADER": "Trenger du hjelp?",
        "IN_BUILDING": "Kontaktpersoner for {{buildingName}}",
        "YOUR_ACCOUNT": "Kontaktperson for {{companyName}}",
        "SCOPE_BUILDING": "Hjelper deg med alt som gjelder bygget og tjenestene i det.",
        "SCOPE_ACCOUNT": "Start her om det gjelder kontoen din, adgangskort eller tilgang til et område.",
        "ROLE_COMPANY_CONTACT": "Kontaktperson, {{companyName}}",
        "SHOW_ALL_TEAM": "Vis hele teamet",
        "NO_CONTACT": "Ingen kontaktperson registrert ennå"
      },
      "HELP_CENTRE": {
        "HEADER": "Hjelpesenter",
        "BLURB": "Veiledninger og svar på alt i Welcome Workdays.",
        "OPEN": "Åpne hjelpesenteret",
        "NEW_TAB": "Åpnes i ny fane"
      },
      "TABS": {
        "LABEL": "Hovedmeny",
        "HOME": "Hjem",
        "VISITORS": "Besøkende",
        "MORE": "Mer"
      },
      "SHORTCUTS": {
        "TOP_UP_LUNCH": "Fyll på lunsjkort",
        "NEW_BOOKING": "Ny reservasjon",
        "ORDER_FOOD": "Bestill møtemat"
      },
      "NEWS_DATE": {
        "TODAY": "I dag {{time}}",
        "YESTERDAY": "I går"
      }
    },
    "VISITORS": {
      "HEADER": "Besøkende",
      "SUBHEADER": "Her finner du en liste over alle dine besøk for i dag. Du blir varslet på SMS eller epost når en besøkende ankommer. Les mer om <1>Welcome Visit</1>.",
      "PLACEHOLDER": "{{ entity }} har ingen besøkende så langt i dag!",
      "PREREGISTRATION": "Forhåndsregistrering",
      "PREREGISTRATION_DESCRIPTION": "Her finner du dine kommende besøkende. Du kan også forhåndsregistrere nye besøkende.",
      "VIEW_FUTURE_PREREGISTRATIONS": "Fremtidige forhåndsregistreringer",
      "CREATE_PREREGISTRATION": "Ny forhåndsregistrering"
    },
    "BOOKING": {
      "HEADER": "Reservasjoner",
      "SUBHEADER": "Se og administrer dine reservasjoner og utforsk rommene i {{buildingName}}. Les mer om <1>Welcome Booking her</1>.",
      "PLACEHOLDER": "Du har ingen reservasjoner!",
      "BOOK": "Reserver et rom",
      "SUB_ROUTES": {
        "ALL_ROOMS": "Alle rom",
        "SEARCH": "Søk etter rom"
      },
      "HISTORY": {
        "HEADER": "Reservasjonshistorikk",
        "SUBHEADER": "Her finner du en oversikt over alle dine tidligere reservasjoner, inkludert kansellerte reservasjoner."
      }
    },
    "MY_ORDERS": {
      "LIFECYCLE_DATA_UNAVAILABLE": "Noen bestillingsdetaljer er utilgjengelige. Kontakt restauranten.",
      "ORDER_UNAVAILABLE": "Denne bestillingen er ikke tilgjengelig for kontoen din.",
      "HEADER": "Mine bestillinger",
      "SUBHEADER": "Her er en liste over alle dine matbestillinger i {{buildingName}}.",
      "TABLE": {
        "ORDER_NUMBER": "Ordrenummer",
        "TIME": "Leveres/Hentes kl.",
        "LOCATION": {
          "HEADER": "Sted",
          "PICKUP": "Hentes på <bold>{{supplierName}}</bold>",
          "DELIVERY": "Leveres til <bold>egendefinert sted</bold>",
          "SOON": "snart"
        },
        "TOTAL": "Totalt",
        "NO_DATA": "Ingen bestillinger å vise"
      },
      "ORDER_DETAILS": {
        "HEADER": "Bestilling #{{orderNumber}}",
        "CANCEL": "Kanseller bestilling",
        "PAID_BY_INVOICE": "Betalt med faktura",
        "WILL_NOT_BE_INVOICED": "Bestillingen vil ikke bli fakturert"
      },
      "STATUS": {
        "PENDING": "Ubehandlet",
        "ORDERED": "Bestilt",
        "CONFIRMED": "Bekreftet",
        "PREPARING": "Forberedes",
        "DELIVERED": "Levert",
        "CLOSED": "Lukket",
        "CANCELLED": "Kansellert",
        "DENIED": "Avslått",
        "COMPLETED": "Fullført"
      },
      "STATUS_TEXT": {
        "ORDERED": "Kjøkkenpersonalet har mottatt bestillingen din og vil bekrefte den så snart som mulig",
        "CONFIRMED": "Bestillingen din har blitt bekreftet av kjøkkenet og vil bli oppfylt på valgt tid og sted",
        "PREPARING": "Kjøkkenet forbereder bestillingen din",
        "DELIVERED": "Bestillingen er merket som levert eller hentet",
        "CANCELLED": "Du har valgt å kansellere denne bestillingen - den vil ikke bli fakturert",
        "DENIED": "Kjøkkenet har avslått bestillingen din av følgende grunn:"
      }
    },
    "ORDER_FOOD": {
      "SUBHEADER": "Her kan du bestille mat og drikke for å nyte i {{buildingName}}.",
      "CONTACT": "Lurer du på noe eller trenger hjelp? Kontakt restauranten på <firstMethod>{{firstMethod}}</firstMethod><secondMethod> eller <phone>{{phone}}</phone></secondMethod>.",
      "STEPS": {
        "DELIVERY": "Velg levering",
        "PRODUCTS": "Velg produkter",
        "CHECKOUT": "Se over & bestill"
      },
      "DELIVERY_METHOD": {
        "PICKUP": {
          "LABEL": "Hente selv",
          "BUTTON": "Velg henting",
          "UNAVAILABLE": "Henting er ikke tilgjengelig",
          "TITLE": "Når ønsker du å hente bestillingen?",
          "NO_CUTOFF": "Bestillingen din kan tidligst hentes om 1 time.",
          "CUTOFF": "Bestillinger gjort etter kl. {{orderCutoffTime}} kan tidligst hentes kl. {{pickupOpensAt}} i morgen. Det er foreløpig ikke mulig å bestille mindre enn 1 time frem i tid.",
          "CUTOFF_PLUS_DAYS": "Bestillinger gjort etter kl. {{orderCutoffTime}} kan tidligst hentes kl. {{pickupOpensAt}}, {{daysToWait}} dager frem i tid. Det er foreløpig ikke mulig å bestille mindre enn 1 time frem i tid.",
          "CUTOFF_24H": "Bestillingen din kan tidligst hentes om 24 timer.",
          "LOCATION": "Du må hente bestillingen din selv i <bold>{{location}}</bold>",
          "INSTRUCTIONS": {
            "LABEL": "Kommentar",
            "PLACEHOLDER": "Noe kjøkkenet trenger å vite angående hentingen?"
          }
        },
        "DELIVERY": {
          "LABEL": "Levert",
          "BUTTON": "Velg levering",
          "UNAVAILABLE": "Levering er ikke tilgjengelig",
          "TITLE": "Når ønsker du å motta bestillingen?",
          "NO_CUTOFF": "Bestillingen din kan tidligst leveres om 1 time.",
          "CUTOFF": "Bestillinger gjort etter kl. {{orderCutoffTime}} kan tidligst leveres kl. {{deliveryOpensAt}} i morgen. Det er foreløpig ikke mulig å bestille mindre enn 1 time frem i tid.",
          "CUTOFF_PLUS_DAYS": "Bestillinger gjort etter kl. {{orderCutoffTime}} kan tidligst leveres kl. {{deliveryOpensAt}}, {{daysToWait}} dager frem i tid. Det er foreløpig ikke mulig å bestille mindre enn 1 time frem i tid.",
          "CUTOFF_24H": "Bestillingen din kan tidligst leveres om 24 timer.",
          "LOCATION": {
            "TITLE": "Hvor ønsker du å få den levert?",
            "DESCRIPTION": "Bestillingen din kan leveres til alle fellesområder i {{buildingName}}."
          },
          "INSTRUCTIONS": {
            "LABEL": "Leveringsinstruksjoner",
            "PLACEHOLDER": "Beskriv hvor bestillingen skal leveres..."
          },
          "ERROR": "Instruksjonene må være minst 3 tegn i lengde når bestillingen skal leveres"
        },
        "PICKUP_WITH_SERVICE": {
          "LABEL": "Henting med servering"
        },
        "PICKUP_WITHOUT_SERVICE": {
          "LABEL": "Henting uten servering"
        },
        "DELIVERY_WITH_SERVICE": {
          "LABEL": "Levering med servering"
        },
        "DELIVERY_WITHOUT_SERVICE": {
          "LABEL": "Levering uten servering"
        },
        "WITH_SERVICE_DESCRIPTION": "F.eks. vanlig servise, opprydding, oppvask. Nøyaktige tjenester kan variere.",
        "WITHOUT_SERVICE_DESCRIPTION": "F.eks. engangsservise, ingen opprydding eller servering.",
        "AVAILABLE": "Tilgjengelig",
        "BACK": "Tilbake til leveringsmetoder",
        "CHOSEN": "Valgt"
      },
      "MENU": {
        "SEARCH": "Søk etter produkter",
        "NO_ITEMS": {
          "SEARCH": "Ingen produkter matcher søket ditt",
          "DEFAULT": "Ingen produkter å vise"
        },
        "CREATE_WITH_AI_DESCRIPTION": "Prøv å opprette menypunktet med kunstig intelligens (KI)",
        "CREATE_WITH_AI": "Opprett med KI",
        "AI_MODAL": {
          "HEADER": "Opprett menypunktet med KI",
          "DESCRIPTION": "Her kan du opprette menypunktet ved hjelp av kunstig intelligens (KI). Du trenger kun å beskrive menypunktet kort, så vil KI generere all teksten på både norsk og engelsk, samt et apetittvekkende bilde!",
          "PROMPT": {
            "LABEL": "Hva ønsker du å legge til i menyen?",
            "PLACEHOLDER": "Beskriv menypunktet kort"
          },
          "TOOLTIP": {
            "GENERATING_TEXT": "Generer tekst...",
            "GENERATING_IMAGE": "Generer bilde...",
            "FINISHED_SOON": "Snart ferdig..."
          }
        },
        "ALLERGENS": "Allergener",
        "IMAGE_IS_ILLUSTRATIVE": "Bildet er kun en illustrasjon"
      },
      "CART": {
        "HEADER": "Handlekurv",
        "IN_CART": "i handlekurven",
        "ADD": "Legg til i handlekurv",
        "ADD_SHORT": "Legg til",
        "REMOVE": "Fjern fra handlekurv",
        "MIN_QTY_REACHED": "Minst {{minQuantity}} per bestilling",
        "MAX_QTY_REACHED": "Maks {{maxQuantity}} per bestilling",
        "BOTH_QTY_LIMIT": "Minst {{minQuantity}}, maks {{maxQuantity}} per bestilling",
        "DONE": "Bekreft",
        "ADD_ITEM_COMMENT": "Legg til kommentar",
        "ITEM_COMMENT": {
          "LABEL": "Kommentar",
          "PLACEHOLDER": "Noe kjøkkenet må ta hensyn til?"
        },
        "QUANTITY": "Antall",
        "QUANTITY_SHORT": "Stk.",
        "EMPTY": "Handlekurven er tom!"
      },
      "CHECKOUT": {
        "COMMENT": {
          "LABEL": "Spesielle instruksjoner",
          "PLACEHOLDER": "Noen ønsker eller beskjeder til kjøkkenet?"
        },
        "PARTICIPANTS_COUNT": {
          "LABEL": "Hvor mange skal spise?",
          "INFO_TEXT": "Indikerer hvor mye servise som trengs.",
          "LABEL_ALT": "Antall personer som skal spise"
        },
        "CONFIRM_COST": "Jeg bekrefter at jeg er autorisert til å pådra {{companyName}} en kostnad på {{cost}} (eks. MVA) for denne bestillingen",
        "PAY_WITH_INVOICE": "Betal med faktura",
        "INVALID_FORM_TOOLTIP": "Én eller flere trinn er ugyldige!"
      },
      "AVAILABILITY": {
        "HELP": "Noen produkter har egne bestillingsfrister. Vi viser hva som kan bestilles til tidspunktet du velger.",
        "HELP_CLOSED_ON_WEEKENDS": "Restauranten er stengt i helgene, så frister som er oppgitt i dager hopper over lørdager og søndager. Noen produkter har egne bestillingsfrister. Vi viser hva som kan bestilles til tidspunktet du velger.",
        "TIME_PROBLEMS": {
          "DELIVERY_TIME_IN_PAST": "Det valgte tidspunktet har allerede passert.",
          "OUTSIDE_OPERATING_HOURS": "Restauranten har ikke åpent på det valgte tidspunktet.",
          "DELIVERY_TYPE_UNSUPPORTED": "Restauranten tilbyr ikke lenger denne leveringsmåten.",
          "SUPPLIER_CLOSED": "Restauranten er stengt i helgene. Velg en ukedag."
        },
        "ITEM_PROBLEMS": {
          "CUTOFF_PASSED": "Produktet kan ikke bestilles til valgt tidspunkt. Fristen var {{orderBy}}.",
          "CUTOFF_PASSED_NO_TIME": "Produktet kan ikke bestilles til valgt tidspunkt.",
          "ITEM_UNAVAILABLE": "Ikke tilgjengelig for øyeblikket.",
          "ITEM_NOT_FOUND": "Finnes ikke lenger på menyen."
        },
        "ORDER_BY": "Må bestilles innen {{time}}",
        "ORDER_BY_WEEKDAY": "Må bestilles innen {{weekday}} kl. {{time}}",
        "UNKNOWN_ITEM": "Ukjent produkt",
        "NO_ITEMS": "Ingen produkter kan bestilles til valgt tidspunkt. Prøv et annet tidspunkt.",
        "CHECK_FAILED": "Vi kunne ikke sjekke hvilke produkter som kan bestilles til valgt tidspunkt. Handlekurven er uendret.",
        "REFRESH_FAILED": "Vi kunne ikke sjekke produktene på nytt, så det du ser kan være utdatert. Handlekurven er uendret.",
        "MENU_FAILED": "Menyen kunne ikke lastes inn. Handlekurven er uendret.",
        "SETUP_FAILED": "Vi kunne ikke sjekke hvilke produkter som kan bestilles på grunn av et problem med restaurantens bestillingsoppsett. Ta kontakt med din administrator. Handlekurven er uendret.",
        "CHECKOUT_WARNING": "Noen av produktene kan ikke bestilles til valgt tidspunkt. <remove>Fjern de markerte produktene</remove> eller <changeTime>endre tidspunktet</changeTime>, og prøv igjen.",
        "CHECKOUT_WARNING_REMOVE_ONLY": "Noen av produktene kan ikke bestilles. <remove>Fjern de markerte produktene</remove>, og prøv igjen.",
        "COUNTDOWN": "Fullfør bestillingen innen {{time}}. Etter det kan noen av produktene i handlekurven ikke lenger bestilles til ønsket tidspunkt.",
        "COUNTDOWN_ANNOUNCEMENT_one": "{{count}} minutt igjen til å fullføre bestillingen før noen produkter ikke lenger kan bestilles.",
        "COUNTDOWN_ANNOUNCEMENT_other": "{{count}} minutter igjen til å fullføre bestillingen før noen produkter ikke lenger kan bestilles."
      },
      "NOTIFICATIONS": {
        "ORDER_NOT_ORDERABLE": "Bestillingen ble ikke sendt. Noen av produktene kan ikke bestilles til valgt tidspunkt.",
        "ORDERING_MODE_CHANGED": "Bestillingsreglene er endret. Sjekk bestillingen og prøv igjen.",
        "QUANTITY_EXCEEDS_LIMIT": "Du har lagt til flere av et produkt enn restauranten tillater. Juster antallet og prøv igjen.",
        "ORDERING_UNAVAILABLE": "Bestilling er midlertidig utilgjengelig. Prøv igjen om litt.",
        "TIME_NOT_ORDERABLE": "Bestillingen ble ikke sendt. {{reason}} Endre tidspunktet eller leveringsmåten og prøv igjen.",
        "TIME_REJECTED": "Bestillingen ble ikke sendt. Valgt tidspunkt eller leveringsmåte kan ikke lenger brukes, for eksempel fordi bestillingsfristen har passert. Endre det og prøv igjen.",
        "ITEM_NO_LONGER_AVAILABLE": "Bestillingen ble ikke sendt. Et produkt i handlekurven er ikke lenger tilgjengelig. Sjekk handlekurven og prøv igjen.",
        "INVALID_CART": "Bestillingen ble ikke sendt. Noe i handlekurven er ugyldig. Sjekk produktene, og prøv igjen.",
        "ORDERING_MISCONFIGURED": "Bestillingen ble ikke sendt på grunn av et problem med restaurantens bestillingsoppsett. Ta kontakt med din administrator.",
        "CART_ITEM_NOT_FOUND": "Et produkt i handlekurven din finnes ikke lenger i menyen og ble fjernet fra handlekurven din.",
        "CART_UPDATED": "Handlekurven ble oppdatert",
        "DELIVERY_TIME_UPDATED": "Leveringstiden ble oppdatert",
        "ORDER_CREATED": "Bestillingen er sendt! Venter på bekreftelse fra kjøkkenet.",
        "ORDER_FAILED": "Det oppstod en feil under oppretting av bestillingen. Vennligst prøv igjen senere!",
        "CANCELLED": "Bestillingen har blitt kansellert. Den vil ikke bli fakturert.",
        "DENIED": "Bestillingen har blitt avslått. Kunden vil bli varslet.",
        "DENIAL_FAILED": "Kunne ikke avslå bestillingen. Vennligst prøv igjen senere!",
        "STATUS_UPDATED": "Bestillingens status har blitt oppdatert.",
        "STATUS_UPDATE_FAILED": "Kunne ikke oppdatere statusen til bestillingen. Vennligst prøv igjen senere!",
        "ORDER_LIFECYCLE_CONFLICT": "Bestillingen har endret seg siden siden ble lastet, så handlingen ble ikke utført. Bestillingen er oppdatert.",
        "ORDER_CLOSED_ON_SAVE": "Tidspunktet for lukking av bestillingen hadde passert, så lagringen lukket den også. Den er nå klar til fakturering og kan ikke lenger redigeres.",
        "CANCELLATION_FAILED": "Det oppstod en feil under kansellering av bestillingen. Vennligst prøv igjen senere!"
      }
    },
    "SNACK_ADMIN": {
      "HEADER": "Bestillingsoversikt",
      "SUBHEADER": "Her kan du se og administrere alle matbestillinger i {{buildingName}}."
    },
    "COMPANY_BOOKING": {
      "HEADER": "Reservasjoner i selskapet",
      "SUBHEADER": "Her finner du en oversikt over alle reservasjoner gjort internt i {{companyName}}. Les mer om <1>Welcome Booking her</1>."
    },
    "BUILDING_BOOKING": {
      "HEADER": "Alle reservasjoner",
      "SUBHEADER": "Her finner du en oversikt over alle reservasjoner gjort i {{buildingName}}. Les mer om <1>Welcome Booking her</1>.",
      "PLACEHOLDER": "Ingen reservasjoner å vise!",
      "VIEWS": {
        "CALENDAR": "Kalendervisning",
        "LIST": "Listevisning"
      },
      "FILTERS": {
        "ROOM": {
          "LABEL": "Filtrer på rom",
          "PLACEHOLDER": "Alle rom"
        },
        "DATE": {
          "LABEL": "Filtrer på tid",
          "PLACEHOLDER": "Kommende reservasjoner",
          "CURR_MONTH": "Denne måneden",
          "LAST_MONTH": "Forrige måned",
          "PAST_90_DAYS": "Siste 90 dager"
        },
        "STATUS": {
          "LABEL": "Filtrer på status",
          "PLACEHOLDER": "Alle statuser"
        },
        "EXPORT": "Eksporter {{count}} reservasjoner"
      },
      "BOOKING_DETAILS_ERROR": "Kunne ikke laste inn reservasjonsdetaljer. Vennligst rapporter denne feilen via chatten i nedre høyre hjørne.",
      "BOOKINGS_ON_DAY_one": "<bold>{{count}} reservasjon</bold> på denne dagen",
      "BOOKINGS_ON_DAY_other": "<bold>{{count}} reservasjoner</bold> på denne dagen",
      "NEW": {
        "HEADER": "Ny reservasjon",
        "SUBHEADER": "Her kan du reservere et rom på vegne av en annen bruker i {{buildingName}}.",
        "ON_BEHALF_OF": {
          "LABEL": "Reserver på vegne av",
          "INFO": "Vennligst skriv inn hele e-postadressen til brukeren",
          "NO_RESULTS": "Dobbeltsjekk at e-posten er skrevet riktig"
        },
        "NO_USER_SELECTED": {
          "HEADER": "Velg en bruker",
          "BODY": "Du må velge en bruker før du kan reservere et rom på deres vegne."
        }
      }
    },
    "ACCESS": {
      "HEADER": "Adgang",
      "SUBHEADER": "Her finner du adgangskortene og rollene dine i {{building}}. Har du mistet eller blitt frastjålet et adgangskort kan du rapportere det her. Les mer om <1>Welcome Access her</1>. Hvis du mangler et adgangskort eller rolle, ta kontakt med din administrator.",
      "PLACEHOLDER": {
        "HEADER": "Du har ingen adgangskort ennå!",
        "DIGITAL_BODY": "Last ned Welcome Access-appen og generer ditt eget digitale adgangskort. Logg inn med e-postadressen din <bold>{{email}}</bold>.",
        "APP_STORE": "Last ned fra App Store",
        "GOOGLE_PLAY": "Last ned fra Google Play",
        "LEARN_MORE": "Les mer om digitale adgangskort",
        "PHYSICAL_BODY": "Du har ikke et adgangskort til {{building}} ennå. Kontakt administratoren i bedriften din for å be om et.",
        "PHYSICAL_CARD_HINT": "Trenger du et fysisk adgangskort? Kontakt administratoren i bedriften din."
      },
      "PIN_MANAGEMENT": "Administrer PIN",
      "PIN_MANAGEMENT_DESCRIPTION": "PIN-koden brukes til alle dine adgangskort i bygget, både fysiske og digitale. Hold det trygt og ikke del det med noen. Vi lagrer ikke PIN-koden din, så husk den eller lagre den.",
      "CHANGE_PIN": "Endre PIN"
    },
    "USERS": {
      "HEADER": "Brukere",
      "SUBHEADER": "Se og administrer brukere i din bedrift. Du kan endre profilinnstillinger, synlighet, og tilgangsrettigheter. Les mer om <1>brukeradministrasjon</1>. Last ned <3>xlsx</3> eller <5>csv</5> malfilen for brukeropplasting.",
      "SUB_ROUTES": {
        "SETTINGS": "Brukerinnstillinger",
        "ACCESS": "Adgang",
        "FOOD": "Mat"
      }
    },
    "SETTINGS": {
      "HEADER": "Min profil",
      "SUBHEADER": "Se og oppdater profilinnstillingene dine her. Ønsker du å slette din profildata kan du også ta kontakt med din administrator.",
      "MANAGE_CONSENTS": "Administrer samtykker",
      "DISCLAIMER": "Ved å bruke tjenesten har du godtatt våre <terms>brukervilkår</terms> og bekreftet at du har lest vår <policy>personvernserklæring</policy>.",
      "VISIT_SETTINGS": "Welcome Visit innstillinger",
      "VISIT_SETTINGS_DESCRIPTION": "Welcome Visit er løsningen for besøksregistrering, her kan du administrere dine relaterte innstillinger. Finn ut mer om Welcome Visit <1>her</1>.",
      "NOTIFICATION_PREFERENCE": "Varslingspreferanse",
      "NOTIFICATION_SETTINGS": "Varslingsinnstillinger",
      "NOTIFICATION_PREFERENCE_DESCRIPTION": "Velg varslingsinnstillingene dine, som vil gjelde for besøksregistrering og møteromreservasjoner (når de er aktivert). Vær oppmerksom på at enkelte varsler kun sendes via e-post, uavhengig av de valgte innstillingene dine.",
      "SMS": "SMS"
    },
    "COMPANY_SETTINGS": {
      "HEADER": "Selskapsinnstillinger",
      "SUBHEADER": "Administrer selskapsopplysningene dine her. Du kan også se SSO-domenet og SSO-leverandøren som er konfigurert for selskapet. For mer informasjon, besøk våre <1>Hjelpesider</1>.",
      "GOOGLE_SSO_HELP_TEXT": "Domene lagt til! Merk at det kan ta opp til 24 timer for det nye domene å bli satt opp."
    },
    "COMPANY_VISITORS": {
      "HEADER": "Besøkende til selskap i dag",
      "SUBHEADER": "Her finner du en liste over alle besøk til selskapet for i dag. Alle administratorer i selskapet blir varslet på SMS eller epost når en besøkende uten vert ankommer. Les mer om <1>Welcome Visit</1>."
    },
    "FUTURE_COMPANY_VISITORS": {
      "HEADER": "Fremtidige besøkende til selskap",
      "SUBHEADER": "Her finner du en oversikt over alle fremtidige forhåndsregstrerte besøk til selskapet. Les mer om <1>Welcome Visit</1>."
    },
    "BUILDING_SETTINGS": {
      "HEADER": "Bygginnstillinger",
      "SUBHEADER": "Administrer bygningsopplysningene her. For mer informasjon, besøk våre <1>Hjelpesider</1>.",
      "MODULE_DESCRIPTIONS": {
        "VISIT": "Besøksregistrering",
        "BOOKING": "Møteromsbooking",
        "ACCESS": "Adgangskontroll",
        "COMMUNICATION": "Kommunikasjon til leietakere",
        "FOOD": "Møtemat og personalrestaurant",
        "COMPLIANCE": "Håndtering av kontrakter"
      }
    },
    "FOOD_SETTINGS": {
      "LINK_COMPANY_TO": "Lenke selskap til",
      "AVAILABLE_DEALIDS": "Tilgjengelige Deal Ids",
      "NOT_CONNECTED": "Denne brukeren er ikke enda integrert med restaurantsystemet.",
      "CONNECT_USER": "Integrer bruker med restaurantsystemet",
      "NO_ACCESS_CARD": "Brukeren trenger et adgangskort før hen kan integreres med restaurantsystemet.",
      "WILL_BE_CONNECTED_WITH": "Brukeren vil bli integrert med",
      "IS_CONNECTED_WITH": "Brukeren er integrert med",
      "ACCESS_CARD_NUMBER": "Adgangskortnummer",
      "CONNECT_BUTTON_TEXT": "Integrer bruker",
      "UPDATE_TEXT": "Det ser ut til at dataen til brukeren ikke er synkronisert med restaurantsystemet.",
      "UPDATE_BUTTON_TEXT": "Synkroniser data",
      "MUNU_USER_DETAILS": "Brukerdetaljer fra <emphasize>restaurantsystemet</emphasize>",
      "WELCOME_USER_DETAILS": "Brukerdetaljer fra <emphasize>Welcome Workdays</emphasize>",
      "USER_CONNECTED": "Brukeren er koblet til restaurantsystemet",
      "USER_DISABLED": "Denne brukeren er sperret",
      "USER_DISABLED_INFO": "Brukeren er sperret i restaurantsystemet.",
      "PLEASE_LINK_FIRST": "Selskapet er ikke enda lenket til restaurantsystemet. Be en byggadministrator lenke det.",
      "USER_HAS_NO_PHONE_NUMBER": "Brukeren trenger et gyldig telefonnummer for å integreres med restaurantsystemet.",
      "AVAILABLE_DEALS": "Tilgjengelige avtaler",
      "SELECT_DEAL": "Velg en avtale",
      "ACCOUNT_TYPE": "Kontotype",
      "DEAL_ID": "Avtale ID",
      "BENEFIT_NAME": "Avtale",
      "DISABLE_USER": "Deaktiver bruker",
      "REACTIVATE_USER": "Aktiver på nytt",
      "TIMESTAMP": "Tidspunkt",
      "DESCRIPTION": "Beskrivelse",
      "AMOUNT": "Beløp",
      "USER_HAS_DEAL": "Brukeren har lunsjavtale:",
      "CHANGE": "Endre",
      "LUNCHES_EATEN": "Lunsjer spist så langt",
      "PRICE_PER_LUNCH": "Pris per lunsj",
      "LUNCH_HISTORY": "Lunsj historikk",
      "NO_TRANSACTIONS": "Brukeren har ingen transaksjoner enda",
      "USER_HAS_NO_DEAL": "Brukeren har ingen lunsjavtale",
      "USER_IS_DEACTIVATED": "Brukeren er deaktivert",
      "DEACTIVATED_USER_INFO": "Denne brukeren er deaktivert og har derfor ikke lenger tilgang til Welcome Workdays-tjenester.",
      "COMPANY_HAS_NOD_DEALS": "{{companyName}} har ingen lunsjavtaler",
      "ASSIGN_DEAL_INFO": "Du må tildele brukeren en lunsjavtale før de kan ta i bruk personalrestauranten.",
      "LUNCH_DEAL": "Lunsjavtale",
      "SELECT_LUNCH_DEAL": "Velg lunsjavtale",
      "SELECTED_LUNCH_PRICE": "Pris per lunsj: {{price}}",
      "ASSIGN_LUNCH_DEAL": "Tildel lunsjavtale",
      "ASSIGN": "Tildel",
      "NEW_LOWER": "ny",
      "CHANGE_DEAL_INFO": "Ved å endre lunsjavtalen til brukeren endrer du umiddelbart prisen brukeren betaler for lunsj i personalrestauranten.",
      "ASSIGN_DEAL_INFO_MODAL": "Ved tildeling av lunsjavtale vil brukerene umiddelbart få tilgang til personalrestauranten. Eventuelle brukere som allerede har en lunsjavtale vil bli flyttet over til den valgte lunsjavtalen. Lunsjavtalen kan endres eller trekkes tilbake når som helst.",
      "DEAL_UPDATED": "Brukerens lunsjavtale ble oppdatert.",
      "USERS_ASSIGNED_DEAL": "{{successful}} av {{total}} brukere ble tildelt lunsjavtale \"{{dealName}}\".",
      "USERS_ASSIGNED_MULTI_DEALS": "{{successful}} av {{total}} brukere ble tildelt lunsjavtaler.",
      "USERS_UPDATE_FAILED": "{{failed}} brukere kunne ikke oppdateres. Prøv igjen senere.",
      "THE_USER": "brukeren",
      "USERS_LOWER": "brukere",
      "DEACTIVATE_USER": "Deaktiver brukerens lunsjavtale",
      "DEACTIVATE_USER_MESSAGE": "Brukeren vil umiddelbart miste adgang til personalrestauranten. All historikk og eventuell gjenstående saldo forblir derimot lagret og vil gjenopprettes hvis brukeren blir aktivert igjen.",
      "USER_DEACTIVATION_SUCCESS": "Brukerens lunsjavtale ble deaktivert, og hen har ikke lenger adgang til personalrestauranten.",
      "REFUND": {
        "REFUND_BALANCE": "Refunder saldo",
        "REMAINING_BALANCE": "Gjenstående saldo",
        "PANEL_TITLE": "Gjenstående saldo: {{amount}}",
        "PANEL_INFO": "Dette er brukerens egen påfylte saldo. Refusjon returnerer beløpet til deres opprinnelige betalingsmåte. Reaktivering av brukeren beholder saldoen på lommeboken deres i stedet.",
        "SUMMARY": "Du er i ferd med å refundere {{amount}} til brukerens opprinnelige betalingsmåte. Dette kan ikke angres.",
        "INFO": "Refusjonen behandles av betalingsleverandøren og kan ta noen dager å fullføre. Kunden mottar vanligvis refusjonen innen 3 virkedager etter at den er utstedt. Brukerens lommebok må forbli deaktivert til refusjonen er fullført.",
        "AMOUNT": "Refusjonsbeløp",
        "MAX_REFUNDABLE": "Du kan refundere inntil {{amount}}",
        "EXCEEDS_BALANCE": "Beløpet kan ikke overstige tilgjengelig saldo på {{amount}}",
        "DESCRIPTION": "Beskrivelse",
        "DESCRIPTION_PLACEHOLDER": "Årsak til refusjonen",
        "CONFIRM": "Behandle refusjon",
        "PROCESSING": "Starter refusjonen. Dette kan ta et øyeblikk…",
        "SUCCESS": "Refunderte {{amount}} til brukeren.",
        "FAILED": "Refusjonen kunne ikke behandles. Vennligst prøv igjen senere eller kontakt support.",
        "PENDING_BLOCKS_REACTIVATION": "En refusjon behandles fortsatt for denne brukeren. Du kan reaktivere dem når refusjonen er fullført."
      },
      "USER_WAS_ACTIVE": "Denne brukeren har tidligere hatt en aktiv lunsjavtale. Ved å reaktivere dem gjenoppretter du deres tidligere transaksjonshistorikk og saldo.",
      "SELECTED_USERS": "valgte brukere",
      "HAVE_NO_DEAL": "har ingen avtale",
      "FROM_BEFORE": "fra før av",
      "WILL_GET_ACCESS": "vil få tilgang",
      "TO_EMPLOYEE_RESTAURANT": "til personalrestauranten",
      "ALREADY_HAVE_LUNCH_DEAL": "har allerede lunsjavtale",
      "WILL_BE_MOVED_TO_SELECTED_DEAL": "og vil flyttes over til valgt avtale",
      "ALREADY_HAVE_SELECTED_DEALS": "har allerede denne lunsjavtalen",
      "WILL_BE_IGNORED_ON_SUBMIT": "og vil derfor bli ignorert",
      "HAS_REACHED_LIMIT": "<bold>{{dealName}} har en grense på {{maxUsers}} brukere</bold>",
      "HAS_LIMIT_OF": "har en grense på",
      "ACTIVE_USERS": "aktive brukere",
      "USING_THIS_DEAL": "med denne avtalen",
      "WITH_DEAL": "med lunsjavtale \"{{dealName}}\"",
      "BUT_YOU_HAVE_SELECTED": ", men du har valgt {{count}} brukere",
      "AND_ALREADY_HAS": "og har allerede",
      "WITH_DEAL_AND_HAS_REACHED": "med lunsjavtale \"{{dealName}}\" og har allerede nådd denne grensen.",
      "YOU_MUST_DESELECT": "Du må derfor velge bort",
      "USERS_TO_CONTINUE": "brukere for å fortsette.",
      "CANNOT_ASSIGN_MORE_DEALS": "Du kan derfor ikke tildele denne lunsjavtalen til flere brukere.",
      "DEAL_AT_LIMIT": "Denne avtalen har nådd sin brukergrense. Du kan ikke tildele flere brukere til denne avtalen.",
      "COMPANY_NOT_INTEGRATED": "Selskapet har ingen tildelte lunsjavtaler.",
      "ASSIGN_AT_LEAST_ONE_DEAL": "Tildel minst én avtale for å integrere selskapet.",
      "SUBDIVISION_LINKS": "Underavdelinger",
      "SUBDIVISION_LINKED": "{{subdivisionName}} er lenket til restaurantsystemet med ID: {{munuId}}",
      "LIMIT_APPLIES_TO_ALL_SUBDIVISIONS": "Grensen du setter nedenfor gjelder for alle underavdelingene i selskapet.",
      "USER_MUST_HAVE_SUBDIVISION": "Brukeren må være tildelt en underavdeling for å integreres restaurantsystemet.",
      "SUBDIVISION_NOT_LINKED": "Underavdelingen '{{subdivisionName}}' er ikke lenket til restaurantsystemet. Be en byggadministrator konfigurere den."
    },
    "COMPANIES": {
      "HEADER": "Selskaper",
      "SUBHEADER": "Her finner du en liste over alle selskapene med tilknytning til bygget. Dette inkluderer alt fra leietakere til tjenesteleverandører.",
      "SEARCH": "Søk etter selskapsnavn",
      "ADD": "Inviter selskap til bygget",
      "NOT_COMPANY_ADMIN": "Som bygningsadministrator har du tilgang til å se selskapets informasjon. For å redigere generelle selskapsdetaljer, vennligst gjør deg selv til administrator for dette selskapet."
    },
    "BUILDING_VISITORS": {
      "HEADER": "Besøkende i bygget i dag",
      "SUBHEADER": "Her finner du en liste over alle besøkende i bygningen for i dag, inkludert forhåndsregistreringer. Finn ut mer om <1>Welcome Visit</1>."
    },
    "FUTURE_BUILDING_VISITORS": {
      "HEADER": "Fremtidige besøkende i bygget",
      "SUBHEADER": "Her finner du en oversikt over alle fremtidige forhåndsregstrerte besøk i bygningen. Les mer om <1>Welcome Visit</1>."
    },
    "BUILDING_ACCESS": {
      "HEADER": "Adgangskort",
      "SUBHEADER": "Her finner du en liste over alle aktive forespørsler angående adgangskort. Dette inkluderer bestillinger samt forespørsler om deaktivering av adgangskort. Lengre nede finner du også en oversikt oversikt over aktive og deaktiverte adgangskort.",
      "REQUESTS_PLACEHOLDER": "Ingen aktive forespørsler",
      "ALL_PLACEHOLDER": "Ingen adgangskort å vise"
    },
    "BUILDING_ACCESS_ROLE_MANAGEMENT": {
      "SUBHEADER": "Her kan du se og administrere adgangsgrupper som er hentet fra byggets adgangskontrollsystem."
    }
  },
  "ACCESS_ROLE_MANAGEMENT": {
    "TABLE": {
      "NAME": "Navn på adgangsgruppe",
      "ASSIGNED_TO": "Kan bli tildelt brukere i",
      "ASSIGNED_BY": "Kan administreres av",
      "NO_DATA": "Ingen adgangsgrupper å vise",
      "VISITORS": "besøkende",
      "ALL_INTEGRATED_COMPANIES": "Alle integrerte selskaper",
      "PLUS_MORE": "til",
      "SEARCH_PLACEHOLDER": "Søk etter adgangsgruppe eller selskapsnavn..."
    },
    "ADD_ROLE": "Legg til ny adgangsgruppe",
    "DEFAULT_ROLE": "Standard adgangsgrupper blir automatisk tildelt alle nye brukere i selskapet.",
    "ADD_VISITOR_ROLE": "Legg til ny adgangsgruppe for besøkende",
    "EDIT_ROLE_HEADER": "Rediger adgangsgruppe",
    "SET_AS_DEFAULT": "Angi som standard adgangsgruppe",
    "SET_AS_DEFAULT_INFO": "Blir automatisk tildelt alle nye brukere i selskapet.",
    "CREATE_SUCCESS": "Adgangsgruppe opprettet",
    "UPDATE_SUCCESS": "Adgangsgruppe oppdatert",
    "SAME_AS_TARGETED": "Kun valgte 'kan bli tildelt brukere i'",
    "AT_LEAST_ONE_ASSIGNMENT_TYPE": "Minst én tildelingstype må velges",
    "SEPARATE_ROLES_INFO": "To separate grupper vil bli opprettet — én for ansatte og én for besøkende.",
    "DELETE_ROLE_HEADER": "Slett adgangsgruppe",
    "DELETE_ROLE_MESSAGE": "Er du sikker på at du vil slette denne adgangsgruppen? Gruppen vil bli fjernet fra alle brukere den er tildelt til. Denne handlingen kan ikke angres.",
    "DELETE_SUCCESS": "Adgangsgruppe slettet",
    "CANNOT_DELETE_ROLE_HEADER": "Kan ikke slette adgangsgruppe",
    "CANNOT_DELETE_ROLE_MESSAGE": "Adgangsgruppen '{{roleName}}' er for tiden tildelt bruker(e). Vennligst fjern gruppen fra alle brukere før du sletter den. Følgende brukere har denne gruppen:",
    "STARWATCH_GROUP_REMOVED": "Fjernet i Starwatch",
    "STARWATCH_GROUP_REMOVED_INFO": "Denne gruppen finnes ikke lenger i Starwatch. Adgangsgruppen beholdes, men gis ikke til noen før gruppen er tilbake.",
    "ALL_COMPANIES_INCLUDING_FUTURE": "Alle integrerte selskaper, også fremtidige",
    "ENTITY": "adgangsgruppen",
    "CANNOT_DELETE_ROLE_MORE_USERS": "…og {{count}} til"
  },
  "PHONE_VALIDATION": {
    "HEADER": "Bekreft telefonnummeret ditt",
    "SUBHEADER": "Welcome Workdays bruker ditt telefonnummer til mange nyttige funksjoner, som å varsle deg når noen kommer for å besøke deg. Vi trenger derfor et telefonnummer vi kan nå deg på.",
    "OTP_LABEL": "Bekreftelseskode fra SMS",
    "OTP_LABEL_EMAIL": "Bekreftelseskode fra Epost",
    "OTP_ERROR": "Koden var ikke riktig eller noe gikk galt",
    "OTP_INFO": "Det kan ta noen minutter før du mottar SMSen. Dersom du fortsatt ikke har mottatt den<remaining> om <highlight>{{remainingTime}} sekunder</highlight></remaining> kan du <button>be om en ny kode</button>.",
    "OTP_LIMIT_REACHED": "Du har nådd grensen for tillatte bekreftelsesforsøk. Dersom du enda ikke har fått SMSen ber vi deg påse at telefonnummeret er korrekt, prøve igjen senere eller ta kontakt.",
    "SMS_SENT_TO": "SMSen ble sendt til <highlight>{{ phone }}</highlight>. <button>Feil nummer?</button>",
    "MAX_ATTEMPTS_REACHED": "Du har nådd grensen for tillatte bekreftelsesforsøk for i dag. Vennligst prøv igjen i morgen eller ta kontakt med din selskapsadministrator.",
    "SEND_OTP": "Send bekreftelseskode",
    "VALIDATED_TOOLTIP": "Telefonnummeret er bekreftet"
  },
  "FOOD_ADMIN": {
    "RESTAURANT": "Personalrestaurant",
    "DEALS": {
      "SUBHEADER": "Her kan du se og administrere alle restaurantavtaler per selskap i {{buildingName}}.",
      "SEARCH": "Søk etter selskap eller avtale...",
      "DEAL": "Avtale",
      "DEALS": "Avtaler",
      "NEW": "Ny avtale",
      "NO_DEALS": "Bygget har ingen avtaler enda",
      "NO_DEALS_INFO": "Du må opprette minst 1 avtale før du kan integrere selskapet",
      "NOT_INTEGRATED": "Selskapet har ingen tildelte lunsjavtaler",
      "DEAL_NAME": "Avtalenavn",
      "DEAL_PRICE": "Avtalepris",
      "COMPANIES_USING": "Brukes av selskaper",
      "PICK_COMPANIES": "Velg selskaper",
      "ASSIGN_TO_COMPANIES": "Gjør tilgjengelig for selskap",
      "ASSIGN_LATER": "Du kan også opprette avtalen nå, og tilordne selskaper senere.",
      "EDIT_DEAL": "Rediger avtale \"{{dealName}}\"",
      "CREATE": "Opprett avtale",
      "MODAL_WARNING": "Det er for øyeblikket ikke mulig å redigere eller slette avtaler når de er opprettet. Du kan imidlertid tilordne avtalen til selskaper fritt når den er opprettet.",
      "COMPANY_DEALS": "Selskapets avtaler",
      "WARNING_BANNER_TITLE": "Pass på at alt ser riktig ut!",
      "WARNING_BANNER_TEXT": "Så fort du lagrer endringene vil du ikke kunne ta vekk avtalene igjen.",
      "NO_DEALS_ADDED": "Ingen avtaler lagt til enda",
      "MAKE_DEFAULT": "Gjør til standard",
      "USERS_USING": "{{value}} / {{total}} ({{percentage}}%) avtalelisenser er i bruk",
      "USERS_USING_SIMPLE": "{{value}} / {{total}} avtalelisenser er i bruk",
      "USERS_USING_NO_LIMIT": "{{value}} / ubegrenset antall avtalelisenser er i bruk",
      "SET_LIMIT": "Sett grense",
      "CHANGE_LIMIT": "Endre grense",
      "OTHER_DEALS": "Andre avtaler i bygget",
      "NO_MORE_DEALS": "Ingen flere avtaler tilgjengelig",
      "GUEST_DEAL": "Gjesteavtale",
      "GUEST_DEAL_INFO": "Gjesteavtaler er ikke underlagt brukergrenser. Selskaper kan tildele ubegrensede gjesteavtaler.",
      "GUEST": "Gjest",
      "TYPE": "Type",
      "MAX_USERS": "Maks antall lisenser",
      "UNLIMITED": "Ubegrenset",
      "LUNCH_CREDIT": {
        "HEADER": "Månedlig lunsjkreditt per bruker",
        "DESCRIPTION": "Lunsjkreditten gjelder alle brukere i selskapet som har lunsjavtale (utenom de med gjesteavtaler). Kredittbeløpet fornyes i brukerens lommebok månedlig. Ubrukt kreditt ruller ikke over til neste måned - men går tapt. Dersom brukeren bruker opp all kreditten sin, betaler de for lunsj fra egen saldo.",
        "LABEL": "Kredittbeløp (månedlig, per bruker)",
        "NO_CREDIT": "Ingen kreditt",
        "EDIT": "Rediger kredittbeløp",
        "WARNING_BOLD": "Dobbeltsjekk at beløpet stemmer. ",
        "WARNING_TEXT": "Det er foreløpig ikke mulig å redigere beløpet etter at det er lagret for første gang.",
        "COLUMN_HEADER": "Kredittbeløp"
      },
      "NO_MATCHING_DEALS": "Ingen avtaler passer søket ditt",
      "CHOOSE_VARIANT": "Velg lunsjproduktet avtalen skal gjelde for",
      "CHOOSE_OTHER_VARIANT": "Velg annet produkt",
      "PRICE_PER_LUNCH": "Pris per lunsj",
      "PRICE_INFO": "Dette er den fulle prisen for én lunsj, uten subsidier.",
      "CUSTOMER_PAYS": "<blue>Kunden</blue> betaler (%)",
      "EMPLOYER_SUBSIDIZES": "<green>Arbeidsgiver</green> subsidierer (%)",
      "COST_DISTRIBUTION": "Kostnadsfordeling",
      "DEDUCTED_FROM_WALLET": "Trekkes fra brukerens lommebok",
      "INVOICED_TO_EMPLOYER": "Faktureres til arbeidsgiver",
      "IS_GUEST_DEAL": "Dette er en lunsjavtale for gjester",
      "IS_GUEST_DEAL_INFO": "Lunsjavtaler for gjester kan ikke begrenses per selskap. Det vil si at selskaper med denne avtalen kan tildele avtalen til så mange brukere de ønsker.",
      "NOT_CONFIGURED_TITLE": "Lunsj er ikke ferdig konfigurert",
      "NOT_CONFIGURED_INFO": "Før du kan opprette en lunsjavtale må du konfigurere lunsj produktene for restauranten. Dette gjøres i ",
      "RESTAURANT_SETTINGS_LINK": "restaurantinnstillingene",
      "SUBSIDY": "Subsidie"
    },
    "SETTINGS": {
      "ADMINS": {
        "HEADER": "Lunsj-administratorer",
        "DESCRIPTION": "Disse brukerne kan administrere restaurantens Welcome Food-innstillinger og lunsjavtaler. Legg til eller fjern personer fra leverandørselskapet nedenfor.",
        "ADD": "Legg til lunsj-administrator",
        "NO_DATA": "Ingen lunsj-administratorer ennå",
        "ADD_MODAL": {
          "HEADER": "Legg til lunsj-administrator",
          "BODY": "Søk etter en person fra leverandørselskapet for å gi dem lunsj-administratortilgang.",
          "NO_RESULTS": "Ingen brukere funnet",
          "ALREADY_ADMIN": "{{userName}} er allerede lunsj-administrator",
          "SUCCESS": "{{userName}} ble lagt til som lunsj-administrator",
          "ERROR": "Kunne ikke legge til {{userName}} som lunsj-administrator"
        },
        "REMOVE_SUCCESS": "Mat-administrator fjernet",
        "REMOVE_ERROR": "Kunne ikke fjerne lunsj-administrator"
      },
      "LUNCH_HOURS": "Lunsjtider",
      "LUNCH_HOURS_DESCRIPTION": "Lunsjtidene vises på skjermen i kantina og bestemmer tidsrommet kunder er velkomne til lunsj.",
      "COMPLETE_SETUP_HEADER": "Du må fullføre oppsettet for restauranten",
      "COMPLETE_SETUP_BODY": "For å fullføre oppsettet til restauranten og begynne å ta i bruk Welcome Food, må du sette opp din Mollie konto og knytte denne til Welcome Workdays. Oppsettet må kun gjennomføres en gang og tar bare noen få minutter.",
      "CONNECT_MOLLIE": "Sett opp din Mollie betalingskonto",
      "MOLLIE_ALREADY_CONNECTED": "Din Mollie-konto er allerede koblet til. Welcome er satt opp som din partner.",
      "MOLLIE_CONNECT_SUCCESS": "Din Mollie-konto er koblet til. Welcome vil nå fungere som din partner.",
      "CONNECTING_MOLLIE": "Kobler til Mollie-kontoen din…",
      "MOLLIE_CONNECTION_FAILED": "Kunne ikke koble til Mollie-kontoen din. Vennligst prøv igjen eller kontakt Welcome Workdays Support.",
      "LUNCH_HOURS_INVALID_OPENING": "Åpningstid må være før stengetid",
      "LUNCH_HOURS_INVALID_CLOSING": "Stengetid må være etter åpningstid",
      "GUEST_LUNCH": "Gjestelunsj",
      "GUEST_LUNCH_DESCRIPTION": "Dersom du skrur på gjestelunsj vil alle gjester, uavhengig av lunsjavtale eller brukerkonto, kunne kjøpe én-gangs lunsj.",
      "GUEST_LUNCH_TOGGLE": "Skru på gjestelunsj?",
      "GUEST_LUNCH_PRICE": "Totalpris (inkl. MVA)",
      "GUEST_LUNCH_QR_HEADER": "QR-kode for gjestelunsj",
      "GUEST_LUNCH_QR_DESCRIPTION": "Skriv ut denne plakaten og plasser den i restauranten. Gjester skanner QR-koden for å kjøpe lunsj i dette bygget.",
      "GUEST_LUNCH_QR_COPY": "Kopier lenke",
      "GUEST_LUNCH_QR_COPIED": "Lenke kopiert",
      "GUEST_LUNCH_QR_PRINT": "Skriv ut plakat",
      "GUEST_LUNCH_QR_POSTER_HEADLINE": "<b>Er du gjest?</b> Kjøp <b>lunsj</b> rett fra mobilen.",
      "GUEST_LUNCH_QR_POSTER_STEP_1": "Skann QR-koden",
      "GUEST_LUNCH_QR_POSTER_STEP_2": "Velg antall gjester",
      "GUEST_LUNCH_QR_POSTER_STEP_3": "Betal",
      "GUEST_LUNCH_QR_POSTER_STEP_4": "Last ned kvitteringen, eller få den på e-post",
      "GUEST_LUNCH_QR_POSTER_NOTE": "Du trenger <b>ingen app</b> eller <b>konto</b>.",
      "GUEST_LUNCH_QR_POSTER_CANT_SCAN": "Fungerer ikke skanningen? Gå til",
      "LUNCH_PRODUCTS": "Lunsjprodukter",
      "LUNCH_PRODUCTS_DESCRIPTION": "Lunsjproduktene vises på skjermen i personalrestauranten slik at kundene kan velge hvilket produkt de ønsker å kjøpe.",
      "LUNCH_PRODUCTS_INFO": "Disse kan foreløpig ikke redigeres fra portalen. Dersom det kreves endringer, ta kontakt med Welcome Workdays support.",
      "EXTERNAL_LOCATION_ID": "Ekstern lokasjons-ID",
      "EXTERNAL_LOCATION_ID_DESCRIPTION": "Din egen identifikator for denne lokasjonen, brukt i rapporter og ERP-eksporter."
    },
    "OVERVIEW": {
      "SUBSIDY_MESSAGE": "Selskapet <bold>subsidierte {{subsidyPercentage}}%</bold> av lunsjprisen.",
      "SUBHEADER": "Her kan du se og eksportere data og tall tilhørende personalrestauranten.",
      "TRANSACTION_ID": "Transaksjon ID",
      "TIMESTAMP": "Tidspunkt",
      "DESCRIPTION": "Beskrivelse",
      "AMOUNT": "Beløp",
      "SEE_DETAILS": "Se detaljer",
      "BACK_TO_CURRENT_MONTH": "Tilbake til nåværende måned",
      "EXPORT_TO_ACCOUNTING": "Eksporter til regnskap",
      "SALES_IN_PERIOD": "Salg i perioden",
      "AVERAGE_LUNCH_PRICE": "Snittpris per lunsj",
      "TOTAL_UNUSED_BALANCE": "Totalt ubrukt saldo",
      "SEARCH_IN_TRANSACTIONS": "Søk i transaksjoner",
      "SEARCH_IN_COMPANIES": "Søk i selskaper",
      "NO_TRANSACTIONS": "Ingen transaksjoner å vise",
      "NO_COMPANIES": "Ingen selskap å vise",
      "COMPANIES_TABLE_INFO": "Kun selskap med minst én transaksjon i perioden er synlig i denne tabellen.",
      "TRANSACTION_DETAILS": "Transaksjondetaljer",
      "TRANSACTION_PERFORMED_BY_USER": "Transaksjon utført av bruker",
      "INSPECT_USER": "Inspiser bruker",
      "COMPANIES": {
        "COMPANY_NAME": "Selskap",
        "TOTAL_SALES": "Totalt salg",
        "SPENT_BALANCE": "Brukt saldo",
        "SPENT_CREDIT": "Brukt kreditt",
        "AMOUNT_SUBSIDIZED": "Subsidiert beløp",
        "TOTAL_INVOICEABLE": "Totalt fakturerbart",
        "TOTAL_INVOICEABLE_INFO": "Summen av brukt kreditt og subsidiert beløp"
      }
    },
    "USERS": {
      "SEARCH_PLACEHOLDER": "Søk blant brukere...",
      "SUBHEADER": "Her kan du inspisere og administrere lunsjavtaler, transaksjoner og saldo for alle brukere i bygget.",
      "FILTER_COMPANY_LABEL": "Filtrer på selskap",
      "FILTER_COMPANY_PLACEHOLDER": "Filtrer på selskap",
      "EXPORT": "Eksporter ubrukt saldo",
      "EXPORT_MODAL_TITLE": "Eksporter brukersaldo",
      "EXPORT_DATE_LABEL": "Saldo ved slutten av",
      "EXPORT_DATE_HELPER": "Eksporterer alle brukere med saldo på valgt dato. Brukere som ikke hadde noen saldo vil ikke bli med i eksporten.",
      "EXPORT_DATE_TODAY_HELPER": "Å eksportere dagens dato kan gi misvisende resultater fordi flere transaksjoner kan skje etter eksporten",
      "DISABLED_WALLETS": {
        "BANNER": "Disse brukerne har deaktiverte lunsjlommebøker med gjenstående saldo eller en refusjon under behandling. Refusjon kan startes her og fullføres i løpet av noen virkedager. Når refusjonen er fullført, fjernes brukeren automatisk fra denne listen.",
        "TITLE": "Deaktiverte lommebøker",
        "NO_WALLETS": "Ingen deaktiverte lommebøker med saldo eller ventende refusjon",
        "CURRENT_BALANCE": "Gjeldende saldo",
        "REFUNDABLE_AMOUNT": "Refunderbart beløp",
        "STATUS_NONE": "Ikke startet",
        "PENDING_TOOLTIP": "Venter hos PSP",
        "REQUIRES_SUPPORT": "Kontakt support",
        "VIEW_USER": "Vis bruker",
        "DELETED_LABEL": "Slettet",
        "DELETED_TOOLTIP": "Denne brukeren er slettet fra systemet, men har fortsatt lommebok med gjenstående saldo."
      }
    },
    "INSIGHTS": {
      "ADD_TILE": "Legg til flis",
      "EDIT_TILE": "Rediger flis",
      "REMOVE_TILE": "Fjern flis",
      "NO_TILES": "Ingen fliser ennå — legg til en for å komme i gang.",
      "NO_DATA": "Ingen data for denne perioden",
      "TILE_TYPE": "Flis-type",
      "STAT_COUNTER": "Statistikk",
      "CHART": "Diagram",
      "LABEL": "Etikett",
      "LABEL_PLACEHOLDER": "f.eks. Totalt antall lunsjer",
      "METRIC": "Måling",
      "METRIC_PLACEHOLDER": "Velg en måling",
      "FORMAT": "Format",
      "NUMBER": "Tall",
      "CURRENCY_NOK": "Valuta (NOK)",
      "CHART_TITLE": "Diagramtittel",
      "CHART_TITLE_PLACEHOLDER": "f.eks. Lunsjer per dag",
      "CHART_TYPE": "Diagramtype",
      "BAR": "Søyle",
      "LINE": "Linje",
      "AREA": "Område",
      "PIE": "Sektor",
      "GROUP_BY": "Grupper etter (X-akse)",
      "GROUP_BY_PLACEHOLDER": "Velg gruppering",
      "BREAK_DOWN_BY": "Bryt ned etter (valgfritt)",
      "BREAK_DOWN_BY_PLACEHOLDER": "Ingen",
      "VALUE": "Verdi (Y-akse)",
      "VALUE_PLACEHOLDER": "Velg verdi",
      "DATA_SCOPE": "Data",
      "DATA_SCOPE_ALL": "Alle lunsjer",
      "DATA_SCOPE_LUNCH": "Ansattlunsj",
      "DATA_SCOPE_GUEST": "Gjestelunsj",
      "SUMMARY_KEYS": {
        "LUNCH_COUNT": "Antall lunsjer",
        "AVERAGE_DEAL_PRICE": "Gjennomsnittlig avtalepris",
        "TOTAL_SALES": "Totalt salg",
        "TOTAL_COMPANY_SUBSIDY": "Bedriftssubsidier",
        "TOTAL_PAID_FROM_CREDIT": "Betalt fra kreditt",
        "TOTAL_PAID_FROM_BALANCE": "Betalt fra saldo",
        "TOTAL_COMPANY_SHARE": "Bedriftens andel",
        "TOTAL_EMPLOYEE_SHARE": "Ansattes andel",
        "TOPUP_COUNT": "Antall påfyllinger",
        "TOTAL_AMOUNT_TOPUP": "Totalt påfylt",
        "TOTAL_UNUSED_BALANCE": "Ubrukt saldo",
        "GUEST_LUNCH_PAYMENT_COUNT": "Gjestelunsj-betalinger",
        "GUEST_LUNCH_GUEST_COUNT": "Gjestelunsj-kuverter",
        "TOTAL_GUEST_LUNCH_REVENUE": "Gjestelunsj-omsetning"
      },
      "GROUP_BY_OPTIONS": {
        "DATE": "Dato",
        "COMPANY": "Bedrift",
        "VARIANT": "Lunsjvariant",
        "PAYMENT_TYPE": "Betalingstype"
      },
      "VALUE_KEYS": {
        "COUNT": "Antall",
        "TOTAL_AMOUNT": "Totalbeløp (NOK)",
        "SUBSIDY": "Subsidiebeløp (NOK)"
      },
      "PAYMENT_TYPE": {
        "CREDIT": "Kreditt",
        "BALANCE": "Saldo",
        "SUBSIDY": "Subsidie"
      }
    }
  },
  "SNACK_ADMIN": {
    "LIFECYCLE": {
      "HEADER": "Lukking",
      "DEADLINE": "Lukkes automatisk: {{deadline}} (Oslo).",
      "MANUAL": "Manuell levering og lukking. Ingen automatisk frist for endringer.",
      "CLOSED": "Lukket for vanlige endringer; klar for fakturering.",
      "AWAITING_CLOSURE": "Fristen for endringer har passert. Bestillingen venter på lukking.",
      "INVALID_SCHEDULE": "Leveringstidspunktet mangler eller er ugyldig. Handlinger er utilgjengelige. Kontakt administratoren din.",
      "READ_FAILED": "Kunne ikke laste bestillingene. Prøv igjen.",
      "REFRESH_FAILED": "Kunne ikke oppdatere. Viser sist innlastede data; ulagrede endringer er beholdt.",
      "REFRESH_FAILED_NO_DRAFT": "Kunne ikke oppdatere. Viser sist innlastede data.",
      "RETRY": "Prøv igjen"
    },
    "ORDER": "Bestilling",
    "TIMEFRAME_FILTER": {
      "LABEL": "Tidsramme",
      "ALL": "Alle",
      "TODAY": "I dag",
      "TOMORROW": "I morgen",
      "THIS_WEEK": "Denne uken",
      "CURR_MONTH": "Gjeldende måned",
      "LAST_MONTH": "Forrige måned",
      "PAST": "Alle tidligere",
      "LAST_30_DAYS": "Siste 30 dager",
      "LAST_90_DAYS": "Siste 90 dager",
      "NEXT_30_DAYS": "Neste 30 dager",
      "FUTURE": "Alle fremtidige"
    },
    "STATUS_FILTER_ALL": "Alle statuser",
    "TABLE": {
      "SEARCH": "Søk etter kunde eller selskap...",
      "CUSTOMER": "Kunde",
      "COMPANY": "Selskap",
      "PRODUCTS": "Produkter",
      "PARTICIPANTS_COUNT": "Gjester"
    },
    "EXPORT_ORDERS": "Eksporter {{count}} bestillinger",
    "NEW_ORDER": {
      "HEADER": "Ny bestilling",
      "SUBHEADER": "Her kan du opprette en ny bestilling på vegne av en annen bruker i {{buildingName}}.",
      "ADMIN_PRIVILEGES": "Som administrator er du fri fra begrensningene for vanlige brukere ved bestilling, og du kan også se og bestille skjulte menypunkter.",
      "ON_BEHALF_OF": {
        "LABEL": "Bestilling på vegne av",
        "INFO": "Skriv inn brukerens e-post for å hente resultater",
        "NO_RESULTS": "Dobbeltsjekk at e-posten er korrekt"
      },
      "NO_USER_SELECTED": {
        "HEADER": "Velg en bruker for å begynne",
        "BODY": "Du må velge en bruker før du oppretter en bestilling på deres vegne."
      }
    },
    "ORDER_DETAILS": {
      "ACTIONS": {
        "EDIT": "Rediger bestilling",
        "CONFIRM": "Aksepter bestilling",
        "DENY": "Avslå bestilling",
        "PREPARING": "Bestillingen forberedes",
        "CANCEL": "Kanseller bestilling",
        "DELIVERED": "Bestillingen er levert",
        "PICKED_UP": "Bestillingen er hentet",
        "CLOSE": "Lukk bestilling",
        "PRINT": "Skriv ut bestilling"
      },
      "RESET_MODAL": {
        "HEADER": "Er du sikker?",
        "BODY": "Du er i ferd med å nullstille alle endringene dine."
      },
      "DELIVERY_INFO": {
        "PICKUP": "Bestillingen <bold>hentes {{time}}</bold>",
        "DELIVERY": "Bestillingen <bold>leveres {{time}}</bold>",
        "PICKUP_WITH_SERVICE": "Bestillingen <bold>hentes {{time}}</bold>",
        "PICKUP_WITHOUT_SERVICE": "Bestillingen <bold>hentes {{time}}</bold>",
        "DELIVERY_WITH_SERVICE": "Bestillingen <bold>leveres {{time}}</bold>",
        "DELIVERY_WITHOUT_SERVICE": "Bestillingen <bold>leveres {{time}}</bold>"
      },
      "PARTICIPANTS_COUNT": "Antall gjester",
      "DENY_MODAL": {
        "TITLE": "Er du sikker?",
        "BODY": "Bestillingen vil bli kansellert og kan ikke gjenåpnes. Vennligst oppgi begrunnelsen for å avslå bestillingen - slik at vi kan informere kunden.",
        "REASON_LABEL": "Begrunnelse",
        "REASON_PLACEHOLDER": "Vi gikk tom for...",
        "CUSTOMER_PREFERRED_LANGUAGE": "Kunden foretrekker {{language}}"
      },
      "CANCELLED_BY_USER": "Bestillingen ble kansellert av kunden",
      "DENIED_BY_ADMIN": "Bestillingen ble avslått av kjøkkenet",
      "WITH_REASON": "med begrunnelse: <itallic>\"{{reason}}\"</itallic>",
      "SAVE_MODAL": {
        "TITLE": "Bekreft endringer",
        "INFO": "Vi vil varsle kunden med en gang du har bekreftet endringene.",
        "DELIVERED_MAY_CLOSE": "Denne bestillingen er allerede levert. Hvis tidspunktet for automatisk lukking for den lagrede leveringstiden har passert, vil lagring også lukke bestillingen. Blir bestillingen lukket i mellomtiden, lagres ikke endringene dine. Lukkede bestillinger kan ikke lenger redigeres."
      },
      "MARK_DELIVERED_MODAL": {
        "TITLE": "Dette vil også lukke bestillingen",
        "BODY": "Tidspunktet for automatisk lukking av denne bestillingen har allerede passert. Markerer du den som levert eller hentet, blir den også lukket, og lukkede bestillinger kan ikke lenger redigeres. Gjør eventuelle rettelser i bestillingen først."
      },
      "CLOSE_MODAL": {
        "TITLE": "Lukke bestillingen?",
        "BODY": "Når bestillingen lukkes, er den klar til fakturering. En lukket bestilling kan ikke lenger redigeres.",
        "CORRECT_FIRST": "Gjør eventuelle rettelser i bestillingen først."
      }
    },
    "ORDER_HISTORY": {
      "HEADER": "Redigeringslogg",
      "CREATED_ORDER": "opprettet bestillingen",
      "MADE_CHANGES": "endret bestillingen",
      "ACTIONS": {
        "ITEMS_UPDATED": "Handlekurven",
        "DELIVERY_TYPE_UPDATED": "Betjening",
        "DELIVERY_TIME_UPDATED": "Leveringstid",
        "PARTICIPANTS_COUNT_UPDATED": "Antall gjester",
        "INVOICE_REFERENCE_UPDATED": "Fakturareferanse"
      }
    },
    "SETTINGS": {
      "ADMINS": {
        "HEADER": "Snack-administratorer",
        "DESCRIPTION": "Disse brukerne kan administrere restaurantens Welcome Snack-innstillinger og bestillinger. Legg til eller fjern personer fra leverandørselskapet nedenfor.",
        "ADD": "Legg til snack-administrator",
        "NO_DATA": "Ingen snack-administratorer ennå",
        "ADD_MODAL": {
          "HEADER": "Legg til snack-administrator",
          "BODY": "Søk etter en person fra leverandørselskapet for å gi dem snack-administratortilgang.",
          "NO_RESULTS": "Ingen brukere funnet",
          "ALREADY_ADMIN": "{{userName}} er allerede snack-administrator",
          "SUCCESS": "{{userName}} ble lagt til som snack-administrator",
          "ERROR": "Kunne ikke legge til {{userName}} som snack-administrator"
        },
        "REMOVE_SUCCESS": "Snack-administrator fjernet",
        "REMOVE_ERROR": "Kunne ikke fjerne snack-administrator"
      },
      "HEADER": "Restaurantinnstillinger",
      "SUBHEADER": "Her kan du se og administrere innstillingene for restauranten tilknyttet {{companyName}}.",
      "DELIVERY_METHODS": "Leveringsmetoder",
      "DELIVERY_METHODS_DESCRIPTION": "Velg om du vil tilby henting/levering, når det skal være tilgjengelig og hvor mye det skal koste. Eventuelle endringer vil ikke påvirke eksisterende bestillinger.",
      "CLOSED_ON_WEEKENDS": {
        "LABEL": "Stengt i helgene",
        "DESCRIPTION": "Kunder kan ikke legge inn bestillinger til lørdager eller søndager, og faste tidsfrister teller bare hverdager. Endrer du dette, flyttes alle tidsfrister, også de som er satt på produkter. Eksisterende bestillinger beholdes slik de er."
      },
      "VAT_UPDATE_BANNER": {
        "TITLE": "Her har vi gjort endringer!",
        "TEXT": "Møtemat har nå innebygd MVA funksjonalitet. For å begynne å ta det i bruk må du ta stilling til hvilke typer servering du ønsker å tilby. Frem til du har lagret de nye innstillingene vil modulen fortsette å fungere akkurat som før, uten noen MVA."
      },
      "OFFER_PICKUP": "Tilby henting?",
      "PICKUP_WITH_SERVICE": "Henting med servering (25% MVA)",
      "PICKUP_WITHOUT_SERVICE": "Henting uten servering (15% MVA)",
      "DELIVERY_WITH_SERVICE": "Levering med servering (25% MVA)",
      "DELIVERY_WITHOUT_SERVICE": "Levering uten servering (15% MVA)",
      "OFFER_DELIVERY": "Tilby levering?",
      "DURING": "I tidsrom",
      "FEE": "Gebyr",
      "PICKUP_LOCATION": "Hentested",
      "CUTOFF_ORDER_TIME": "Begrens når bestillinger kan gjøres",
      "CUTOFF_ORDER_TIME_DESCRIPTION": "Her kan du velge å sette en tidsfrist til når bestillinger må gjøres. Du kan også velge å ha frie bestillinger uten restriksjon, eller en konstant 24 timers frist.",
      "WITH_CUTOFF": "Med tidsfrist",
      "CUTOFF_24H": "24 timer før",
      "NO_CUTOFF": "Ingen begrensning",
      "CUTOFF_TIME": "Sperretid",
      "CUTOFF_OPTIONS": {
        "SAME_DAY": "... maten leveres i dag",
        "NEXT_DAY": "... maten leveres i morgen",
        "EVERY_DAY_LABEL": "Bestillingsfrist hver dag",
        "DROPDOWN_LABEL": "Før tidsfristen kan..."
      },
      "CONTACT_DETAILS": {
        "LABEL": "Kontaktinformasjon",
        "DESCRIPTION": "Kontaktinformasjonen vil være synlig for kundene dine dersom de har spørsmål eller problemer med bestillinger. Du kan legge til opptil 5 e-poster. Alle vil motta varsler ved nye bestillinger, men bare den første e-posten i listen vil vises til kundene.",
        "CHOSEN_PERSON": "Valgt kontaktperson",
        "FIND_USER": "Finn bruker",
        "ADD_EMAIL_LABEL": "Legg til e-post",
        "PROMOTE_HINT": "Klikk på en e-post for å gjøre den til hovedkontakt. Bare den første vises til kundene.",
        "MAX_REACHED": "Maks antall e-poster lagt til",
        "NO_EMAILS": "Ingen e-poster er lagt til enda",
        "MODAL": {
          "HEADER": "Legg til e-poster",
          "SUBHEADER": "Søk etter brukere for å legge til e-posten deres som mottaker. Alle e-poster som legges til vil motta varsler ved nye bestillinger.",
          "EMAILS_HEADER": "E-poster som er lagt til"
        }
      },
      "AUTOMATION": {
        "HEADER": "Automatisering",
        "AUTO_ACCEPT_ORDERS": {
          "LABEL": "Aksepter bestillinger automatisk",
          "DESCRIPTION": "Når aktivert, vil alle nye bestillinger bli automatisk akseptert uten manuell handling."
        },
        "AUTO_PREPARE_ORDERS": {
          "LABEL": "Sett status til \"Forberedes\" automatisk",
          "DESCRIPTION": "Når aktivert, vil bestillinger automatisk få statusen \"Forberedes\" på morgenen dagen de skal leveres/hentes."
        },
        "AUTO_COMPLETE_ORDERS": {
          "LABEL": "Fullfør bestillinger automatisk",
          "DESCRIPTION": "Når aktivert, vil bestillinger automatisk bli markert som fullført på tidspunktet de skal leveres/hentes."
        },
        "AUTO_DELIVER_AND_CLOSE_ORDERS": {
          "LABEL": "Marker levering og lukk bestillinger automatisk",
          "DESCRIPTION": "Markerer bestillinger under forberedelse som levert ved avtalt leverings-/hentetid og lukker leverte bestillinger ved slutten av neste virkedag (mandag–fredag, Oslo-tid). Endringer gjelder åpne bestillinger. Når dette slås på, kan leverte bestillinger med passert lukkefrist bli lukket ved neste automatiske kjøring. Når det slås av, må levering og lukking gjøres manuelt. Lukkede bestillinger åpnes aldri igjen."
        }
      }
    },
    "MENU": {
      "HEADER": "Administrer meny",
      "SUBHEADER": "Her kan du se og redigere menyen til {{supplierName}}.",
      "ADD_ITEM": "Nytt produkt",
      "ADD_CATEGORY": "Ny kategori",
      "TABLE": {
        "NAME": "Produktnavn",
        "CATEGORY": "Kategori",
        "PRICE": "Pris",
        "IMAGE": "Bilde",
        "CUTOFF": "Bestillingsfrist",
        "CUTOFF_OVERRIDE": "Egen",
        "CUTOFF_DEFAULT": "Standard",
        "CUTOFF_OVERRIDE_INFO": "Varens egne frist gjelder",
        "CUTOFF_DEFAULT_INFO": "Restaurantens standard frist gjelder",
        "CUTOFF_MIXED": "Blandet",
        "CUTOFF_MIXED_COUNT_one": "{{count}} produkt",
        "CUTOFF_MIXED_COUNT_other": "{{count}} produkter",
        "ALLERGENS": "Allergener"
      },
      "ITEM": {
        "VARIOUS": "Diverse",
        "SHOULD_BE_AVAILABLE": "Er produktet tilgjengelig?",
        "IS_AVAILABLE": "Produktet er tilgjengelig og <bold>synlig</bold> i menyen",
        "IS_NOT_AVAILABLE": "Produktet er ikke tilgjengelig og er derfor <bold>skjult</bold> i menyen",
        "ALLERGENS": "Allergener",
        "NO_ALLERGENS": "Ingen allergener",
        "LIMITATIONS": "Begrensninger",
        "LIMITATIONS_DESCRIPTION": "Sett en minimum- og maksimumsgrense på hvor stor mengde av produktet kan legges til i handlekurven per bestilling.",
        "MIN_ORDER_QTY": "Min. bestillingsmengde",
        "MIN_ORDER_QTY_PLACEHOLDER": "Ingen minimum",
        "MAX_ORDER_QTY": "Maks. bestillingsmengde",
        "MAX_ORDER_QTY_PLACEHOLDER": "Ingen maksimum",
        "CREATE": "Opprett produkt"
      },
      "CATEGORY": {
        "NAME": "Kategori navn",
        "SORT_ORDER": "Plassering",
        "CANNOT_DELETE": "Du kan ikke slette kategorier med produkter i.",
        "MAKE_VISIBLE": {
          "TOOLTIP": "Gjør kategori synlig for alle brukere",
          "MODAL_CONTENT": "Ved å gjøre kategorien synlig, vil alle produkter i kategorien bli synlige for brukere og tilgjengelige for bestilling."
        },
        "MAKE_HIDDEN": {
          "TOOLTIP": "Skjul kategori for vanlige brukere",
          "MODAL_CONTENT": "Ved å skjule kategorien, vil alle produkter i kategorien bli skjult for vanlige brukere og kun synlig og tilgjengelig for bestilling av administratorer."
        },
        "VISIBILITY_SUCCESS": "Alle produkter i \"{{categoryName}}\" er nå {{isHidden}}",
        "BUMP_VAT_LABEL": "Sett alltid MVA til 25% dersom kunden bestiller noen varer fra denne kategorien (f.eks. alkohol)",
        "FORCED_VAT": "Høyere MVA"
      }
    },
    "PRINT": {
      "GENERATED": "Generert",
      "HEADER": "Bestilling <grey>#{{orderNumber}}</grey>",
      "PRODUCTS": "Bestilte produkter",
      "PRICE_VAT_DISCLAIMER": "* alle priser er eksl. MVA",
      "PRICE_PER_ITEM": "Pris stk.",
      "NUMBER_OF_ORDERS": "Antall bestillinger",
      "SERVICE": "Betjening",
      "LOCATION": {
        "PICKUP": "<grey>Hentes på</grey> {{location}}",
        "DELIVERY": "<grey>Leveres til</grey> \"{{location}}\""
      },
      "TIME": {
        "PICKUP": "Hentetidspunkt",
        "DELIVERY": "Leveringstidspunkt",
        "PICKUP_WITH_SERVICE": "Hentetidspunkt",
        "PICKUP_WITHOUT_SERVICE": "Hentetidspunkt",
        "DELIVERY_WITH_SERVICE": "Leveringstidspunkt",
        "DELIVERY_WITHOUT_SERVICE": "Leveringstidspunkt"
      },
      "COMPLETED": {
        "PICKUP": "Bestillingen er hentet",
        "DELIVERY": "Bestillingen er levert",
        "PICKUP_WITH_SERVICE": "Bestillingen er hentet",
        "PICKUP_WITHOUT_SERVICE": "Bestillingen er hentet",
        "DELIVERY_WITH_SERVICE": "Bestillingen er levert",
        "DELIVERY_WITHOUT_SERVICE": "Bestillingen er levert"
      }
    }
  },
  "ALLERGENS": {
    "CEREALS_CONTAINING_GLUTEN": {
      "LABEL": "Gluten",
      "DESCRIPTION": "Korn som inneholder gluten (f.eks. hvete, rug, bygg, havre)"
    },
    "WHEAT": {
      "LABEL": "Hvete",
      "DESCRIPTION": "Hvete og produkter laget av hvete"
    },
    "RYE": {
      "LABEL": "Rug",
      "DESCRIPTION": "Rug og produkter laget av rug"
    },
    "BARLEY": {
      "LABEL": "Bygg",
      "DESCRIPTION": "Bygg og produkter laget av bygg"
    },
    "OATS": {
      "LABEL": "Havre",
      "DESCRIPTION": "Havre og produkter laget av havre"
    },
    "CORN": {
      "LABEL": "Mais",
      "DESCRIPTION": "Mais og produkter laget av mais"
    },
    "CRUSTACEANS": {
      "LABEL": "Skalldyr",
      "DESCRIPTION": "Skalldyr (f.eks. krabbe, hummer, reker)"
    },
    "CRAB": {
      "LABEL": "Krabbe",
      "DESCRIPTION": "Krabbe og produkter laget av krabbe"
    },
    "LOBSTER": {
      "LABEL": "Hummer",
      "DESCRIPTION": "Hummer og produkter laget av hummer"
    },
    "SHRIMP": {
      "LABEL": "Reker",
      "DESCRIPTION": "Reker og produkter laget av reker"
    },
    "EGGS": {
      "LABEL": "Egg",
      "DESCRIPTION": "Egg og produkter laget av egg"
    },
    "FISH": {
      "LABEL": "Fisk",
      "DESCRIPTION": "Fisk og produkter laget av fisk"
    },
    "SALMON": {
      "LABEL": "Laks",
      "DESCRIPTION": "Laks og produkter laget av laks"
    },
    "TUNA": {
      "LABEL": "Tunfisk",
      "DESCRIPTION": "Tunfisk og produkter laget av tunfisk"
    },
    "PEANUTS": {
      "LABEL": "Peanøtter",
      "DESCRIPTION": "Peanøtter og produkter laget av peanøtter"
    },
    "SOYBEANS": {
      "LABEL": "Soya",
      "DESCRIPTION": "Soya og produkter laget av soya"
    },
    "MILK": {
      "LABEL": "Melk",
      "DESCRIPTION": "Melk og produkter laget av melk"
    },
    "TREE_NUTS": {
      "LABEL": "Nøtter",
      "DESCRIPTION": "Nøtter (f.eks. mandler, hasselnøtter, valnøtter, cashewnøtter, pekannøtter, paranøtter, pistasjnøtter, macadamianøtter)"
    },
    "ALMONDS": {
      "LABEL": "Mandler",
      "DESCRIPTION": "Mandler og produkter laget av mandler"
    },
    "HAZELNUTS": {
      "LABEL": "Hasselnøtter",
      "DESCRIPTION": "Hasselnøtter og produkter laget av hasselnøtter"
    },
    "WALNUTS": {
      "LABEL": "Valnøtter",
      "DESCRIPTION": "Valnøtter og produkter laget av valnøtter"
    },
    "CASHEWS": {
      "LABEL": "Cashewnøtter",
      "DESCRIPTION": "Cashewnøtter og produkter laget av cashewnøtter"
    },
    "PECANS": {
      "LABEL": "Pekannøtter",
      "DESCRIPTION": "Pekannøtter og produkter laget av pekannøtter"
    },
    "BRAZIL_NUTS": {
      "LABEL": "Paranøtter",
      "DESCRIPTION": "Paranøtter og produkter laget av paranøtter"
    },
    "PISTACHIOS": {
      "LABEL": "Pistasjnøtter",
      "DESCRIPTION": "Pistasjnøtter og produkter laget av pistasjnøtter"
    },
    "MACADAMIA_NUTS": {
      "LABEL": "Macadamianøtter",
      "DESCRIPTION": "Macadamianøtter og produkter laget av macadamianøtter"
    },
    "CELERY": {
      "LABEL": "Selleri",
      "DESCRIPTION": "Selleri og produkter laget av selleri"
    },
    "MUSTARD": {
      "LABEL": "Sennep",
      "DESCRIPTION": "Sennep og produkter laget av sennep"
    },
    "SESAME_SEEDS": {
      "LABEL": "Sesam",
      "DESCRIPTION": "Sesamfrø og produkter laget av sesam"
    },
    "SULPHUR_DIOXIDE_AND_SULPHITES": {
      "LABEL": "Sulfitter",
      "DESCRIPTION": "Svoveldioksid og sulfitter"
    },
    "LUPIN": {
      "LABEL": "Lupin",
      "DESCRIPTION": "Lupin og produkter laget av lupin"
    },
    "MOLLUSCS": {
      "LABEL": "Bløtdyr",
      "DESCRIPTION": "Bløtdyr (f.eks. blåskjell, muslinger, østers, blekksprut)"
    },
    "MUSSELS": {
      "LABEL": "Blåskjell",
      "DESCRIPTION": "Blåskjell og produkter laget av blåskjell"
    },
    "CLAMS": {
      "LABEL": "Muslinger",
      "DESCRIPTION": "Muslinger og produkter laget av muslinger"
    },
    "OYSTERS": {
      "LABEL": "Østers",
      "DESCRIPTION": "Østers og produkter laget av østers"
    },
    "SQUID": {
      "LABEL": "Blekksprut",
      "DESCRIPTION": "Blekksprut og produkter laget av blekksprut"
    },
    "KIWI": {
      "LABEL": "Kiwi",
      "DESCRIPTION": "Kiwi og produkter laget av kiwi"
    },
    "STRAWBERRIES": {
      "LABEL": "Jordbær",
      "DESCRIPTION": "Jordbær og produkter laget av jordbær"
    }
  },
  "NEWS": {
    "CATEGORIES": {
      "DEFAULT": "Nyheter",
      "OPERATIONAL": "Driftsmeldinger"
    },
    "MARK_ALL_AS_READ": "Merk alle som lest"
  },
  "BUILDING_ADMIN": {
    "COLUMNS": {
      "ACCESS_ADMIN": "Adgangsadministrator"
    },
    "ACCESS_ADMIN": {
      "TOOLTIP": "Adgangsadministratorer kan administrere adgangsrelaterte moduler i dette bygget."
    }
  },
  "COMPANY_ADMIN": {
    "COLUMNS": {
      "ACCESS_ADMIN": "Adgangsadministrator"
    },
    "ACCESS_ADMIN": {
      "TOOLTIP": "Adgangsadministratorer kan administrere adgangsrelatert funksjonalitet for bedriftens ansatte."
    }
  },
  "ACCESS_ADMIN": {
    "INVITE": {
      "DESCRIPTION": "Kan administrere adgangsrelatert funksjonalitet",
      "TOOLTIP_DISABLED": "Kun adgangsadministratorer kan tildele adgangsadministratorrettigheter.",
      "ASSIGN_WARNING": "Administrator ble lagt til, men adgangsadministratorrettigheter kunne ikke tildeles."
    }
  },
  "BOOKINGS": {
    "THIS_IS_A_COMBINATION": "Dette er en kombinasjon av",
    "EVENT_FROM_COMBINED": "Reservasjon fra et lenket rom",
    "YOUR_EVENT_FROM_COMBINED": "Din reservasjon fra et lenket rom",
    "EVENTS_FROM_COMBINED": "{{count}} reservasjoner fra lenkede rom",
    "YOUR_EVENTS_FROM_COMBINED": "Dine {{count}} reservasjoner fra lenkede rom",
    "BUFFER_TIME": "{{buffer}} buffertid mellom reservasjoner",
    "HISTORY_TABLE": {
      "STATUS": {
        "CONFIRMED": "Fullført",
        "CANCELLED": "Kansellert"
      }
    },
    "BUILDING_TABLE": {
      "CREATED_TIME": "Reservert",
      "UPDATED_TIME": "Oppdatert",
      "NO_BOOKINGS": "Ingen reservasjoner å vise",
      "STATUS": {
        "CONFIRMED": "Bekreftet",
        "CANCELLED": "Kansellert"
      },
      "TOTAL_COST": "Totalkostnad"
    },
    "COST_BREAKDOWN": {
      "LABEL": "Kostnaden er regnet ut slik:",
      "FIXED_FEE": "Fast avgift: {{fixedFee}}.",
      "RATE_AND_DURATION": "Timepris: {{hourlyRate}} i {{duration}}.",
      "SUBTOTAL": "Delsum: {{subtotal}}.",
      "SUBTOTAL_CAPPED": "Delsum: {{subtotal}}, redusert til maksprisen på {{maxPrice}}.",
      "DISCOUNT": "Rabatt: {{percentage}}, {{amount}}.",
      "TOTAL": "Totalt: {{total}} eks. MVA."
    },
    "BOOKING": "Reservasjon",
    "BOOKING_DETAILS": "Reservasjonsdetaljer",
    "TOGGLE_SHOW_ALL": {
      "SHOW": "Vis {{count}} reservasjoner til",
      "HIDE": "Skjul {{count}} reservasjoner"
    },
    "NO_ROOMS": {
      "HEADER": "Ingen rom enda",
      "BODY": "Når felles ressurser er konfigurert, vil du se dem her!",
      "ADMIN_BODY": "Når de er opprettet vil du kunne se og administrere dem her!"
    },
    "FILTERS": {
      "DATE": "Dato",
      "START_TIME": "Klokkeslett",
      "DURATION": "Varighet",
      "CAPACITY": {
        "LABEL": "Kapasitet",
        "PLACEHOLDER": "Uansett kapasitet..."
      },
      "FEATURES": {
        "LABEL": "Fasiliteter",
        "PLACEHOLDER": "Uansett fasiliteter..."
      }
    },
    "RESULTS": "Tilgjengelige rom som passer dine søkekriterier",
    "NO_RESULTS": {
      "HEADER": "Ingen rom er tilgjengelige",
      "BODY": "Prøv å endre søkekriterier som tid eller dato."
    },
    "INVALID_FILTERS": "Ugyldige filtere",
    "ROOM_FEATURES": {
      "SPEAKER": "Høyttalere",
      "TV": "Skjerm",
      "WHITEBOARD": "Whiteboard",
      "WEBCAM": "Kamera",
      "DUAL_MONITORS": "Flere skjermer",
      "WIRELESS_SCREENSHARE": "Trådløs skjermdeling",
      "PROJECTOR": "Projektor",
      "MIC": "Mikrofon",
      "COFFEE": "Kaffe",
      "HEARING_LOOP": "Teleslynge"
    },
    "MORE_DETAILS": "Les mer om rommet",
    "CHECK_AVAILABILITY": "Sjekk tilgjengelighet",
    "BOOK": "Reserver rom",
    "CANCEL": "Kanseller",
    "ADD_TO_CALENDAR": {
      "LABEL": "Legg til i kalender",
      "GOOGLE": "Google Kalender"
    },
    "DETAILS": "Se detaljer",
    "MODAL": {
      "HEADER": "Bekreft din reservasjon",
      "DEFAULT_MEETING_NAME": "Ny Reservasjon",
      "LABELS": {
        "OPENING_HOURS": "Åpent",
        "TIME": "Tid",
        "BOOKED_BY": "Reservert av",
        "COMPANY": "Selskap",
        "MEETING_TITLE": "Tittel på reservasjon",
        "MEETING_TITLE_PLACEHOLDER": "Bruk en kort og beskrivende tittel",
        "INVOICE_REFERENCE": "Fakturareferanse",
        "NOTES": "Kommentar",
        "NOTES_PLACEHOLDER": "Noe personalet bør vite om reservasjonen?",
        "ROOM": "Rom",
        "TOTAL_COST": "Totalkostnad for reservasjon",
        "DISCOUNT": "Rabatt",
        "PARTICIPANTS_COUNT": "Antall deltakere"
      },
      "PARTICIPANTS_INFO": "Denne informasjonen hjelper personalet med å forberede rommet.",
      "MEETING_TITLE_WARNING": "Ikke bruk sensitiv informasjon. Møtetittelen blir offentlig synlig.",
      "INVOICE_REFERENCE_INFO": "Referansen vil være synlig på faktura for reservasjonen.",
      "EDIT_TIMES": "Rediger starttid og varighet",
      "CONFIRM_COST": "Jeg bekrefter at jeg er autorisert til å pådra {{companyName}} en kostnad på {{cost}} (eks. MVA) for denne reservasjonen",
      "CONFIRM": "Bekreft reservasjon",
      "SNACK": {
        "HEADER": "Møterommet er reservert!",
        "WANT_FOOD": "Ønsker du å bestillte møtemat?",
        "DESCRIPTION": "Velg blant {{count}} produkter - <bold>levert rett til møterommet ditt!</bold>",
        "AND_MORE_PRODUCTS": "og {{count}} produkter til",
        "DECLINE": "Nei takk, kanskje senere",
        "SEE_MENU": "Se hele menyen"
      }
    },
    "CANCEL_PROMPT": {
      "HEADER": "Er du sikker?",
      "BODY": "Kansellering av reservasjonen kan ikke angres, og tidsrommet blir umiddelbart tilgjengelig for andre å reserve."
    },
    "DESCRIPTION": "Beskrivelse",
    "MEETING_FOOD": "Dette rommet har møtemat tilgjengelig, <url>trykk her for å bestille <icon></icon></url>",
    "AVAILABILITY": {
      "HEADER": "Tilgjengelighet",
      "DESCRIPTION": "Her er en oversikt over tider dette rommet er opptatt. <bold>Klikk på, eller hold & dra over tilgjengelige tidsrom for å reservere.</bold>",
      "BANNER": {
        "COMPANY_ADMIN": "Dette rommet kan kun reserveres av selskapsadministratorer. Ta kontakt med <mailto>{{companyContact}}</mailto> for å reservere.",
        "BUILDING_ADMIN": "Dette rommet kan kun reserveres av byggadministratorer. Ta kontakt med resepsjon/byggets administrasjon for å reservere.",
        "NO_COMPANY_CONTACT": "en administrator i ditt selskap"
      }
    },
    "CALENDAR_BOOKED_SLOT": "Opptatt",
    "CALENDAR_BLOCKED_SLOT": "Blokkert av byggadministrator",
    "VALIDATION": {
      "NO_MULTI_DAY": "Reservasjoner kan ikke vare over midnatt",
      "NO_ALL_DAY": "Heldagsreservasjoner er ikke tillatt",
      "OVER_MAX_DURATION": "Reservasjoner kan ikke vare i over {{duration}} timer",
      "STARTING_IN_PAST": "Reservasjoner kan ikke starte mer enn 30 minutter tilbake i tid",
      "OVERLAPPING": "Ønsket tid overlapper med en eksisterende reservasjon",
      "OVERLAPPING_BUFFER": "Ønsket tid overlapper med buffertiden mellom reservasjoner",
      "BLOCKED_TIME": "Ønsket tid overlapper med et blokkert tidsrom",
      "CLOSED_DAY": "Ønsket tid er på en dag hvor rommet er stengt",
      "START_BEFORE_MIN_TIME": "Reservasjoner kan ikke starte før {{time}}",
      "END_AFTER_MAX_TIME": "Reservasjoner må ende før {{time}}",
      "LIMIT_REACHED": "Du har nådd grensen av mengde tillatte bookinger ({{count}} av gangen)",
      "NOTIFICATION_FAILED": "{{entity}} ble reservert, men vi kunne ikke opprette en påminnelse. Du blir derfor ikke varslet når reservasjonen nærmer seg. Rapporter denne feilen til din selskapsadministrator.",
      "EDIT_CUTOFF": "Kan ikke redigere innen 1 time før start",
      "CANCEL_CUTOFF": "Kan ikke kansellere innen 1 time før start"
    },
    "EDIT": "Rediger",
    "ACTIONS": "Handlinger",
    "EDIT_MODAL": {
      "HEADER": "Rediger reservasjon",
      "ORIGINAL_COST": "Opprinnelig kostnad",
      "NEW_COST": "Ny kostnad",
      "SAVE": "Lagre endringer",
      "CONFIRM_COST": "Jeg bekrefter at den oppdaterte kostnaden på {{cost}} (eks. MVA) blir fakturert til {{companyName}}",
      "FOOD_ORDER_WARNING_TITLE": "Bekreft endringer i bestillingen",
      "FOOD_ORDER_WARNING": "Har du bestilt mat eller drikke til møtet ditt? Vennligst kanseller, eller kontakt restauranten for endringer.",
      "FOOD_ORDER_WARNING_ADMIN": "Hvis personen som eier reservasjonen har bestilt mat eller drikke til dette møtet, må de kansellere det separat, eller kontakte restauranten for endringer. Pass på at vedkommende er klar over dette."
    }
  },
  "USERS": {
    "LANGUAGE_PREFERENCE": "Språkpreferanse",
    "SEARCH_PLACEHOLDER": "Søk etter brukere",
    "CONFIRM": "Bekreft",
    "BULK_UPLOAD": {
      "BULK_UPLOAD": "Last opp brukerliste",
      "HEADER": "Last opp brukere",
      "DESCRIPTION": "Her kan du importere brukere til bedriftens konto. Dette er dataene vi forventer:",
      "DESCRIPTION_SMALL": "(Du vil ha en sjanse til å gi nytt navn eller fjerne kolonner i neste trinn)",
      "OPTIONAL": "(Valgfritt)",
      "DROPZONE_TITLE": "Last opp .xlsx-, .xls- eller .csv-fil",
      "DROPZONE_BUTTON": "Velg fil",
      "EMAIL_UNIQUE": "E-post må være unik",
      "SELECT_HEADER_TITLE": "Velg overskriftsrad",
      "NEXT_BUTTON": "Neste",
      "MATCH_COLUMNS_TITLE": "Samsvarer med kolonner",
      "USER_TABLE_TITLE": "Din tabell",
      "TEMPLATE_TITLE": "Vil bli",
      "SELECT_PLACEHOLDER": "Velg kolonne...",
      "IGNORED_COLUMN_TEXT": "Kolonne ignorert",
      "DUPLICATE_COLUMN_WARNING_TITLE": "En annen kolonne er valgt bort",
      "DUPLICATE_COLUMN_WARNING_DESCRIPTION": "Kolonner kan ikke dupliseres",
      "UNMATCHED_REQUIRED_FIELDS_HEADER": "Ikke alle kolonner samsvarer",
      "UNMATCHED_REQUIRED_FIELDS_BODY": "Det er obligatoriske kolonner som ikke samsvarer eller ignoreres. Vil du fortsette?",
      "UNMATCHED_REQUIRED_FIELDS_LIST_TITLE": "Kolonner som ikke samsvarer: ",
      "VALIDATION_TITLE": "Valider data",
      "DISCARD_BUTTON": "Fjern valgte rader",
      "FILTER_SWITCH": "Vis kun rader med feil",
      "NO_ROWS_MESSAGE": "Ingen data funnet",
      "NO_ROWS_MESSAGE_WHEN_FILTERED": "Ingen data inneholder feil",
      "CONFIRM_CLOSE_HEADER": "Avslutt data import",
      "CONFIRM_CLOSE_BODY": "Er du sikker på at du vil avslutte dataimporten? Alle endringer vil gå tapt.",
      "SUBMIT_INCOMPLETE_HEADER": "Feil oppdaget",
      "SUBMIT_INCOMPLETE_BODY": "Det er fortsatt noen rader som inneholder feil. Rader med feil vil bli ignorert ved innsending.",
      "EMAIL_USED": "Bruker med denne e-posten eksisterer allerede. Vennligst fjern raden eller endre e-posten."
    },
    "ADD_USER": "Legg til bruker",
    "NO_USERS": "Ingen brukere å vise",
    "DELETE_USERS": "Slett valgte brukere",
    "CONFIRM_DELETION": "Er du sikker på at du vil slette <bold>{{selectedUsersCount}} brukere</bold>?<br/>All deres personlige data vil bli permanent slettet, og eventuelle tjenester som adgangskort, reservasjoner eller bestillinger vil bli umiddelbart kansellert.",
    "MAKE_USERS_VISIBLE": "Gjør valgte brukere synlige i besøksregisteret",
    "MAKE_USERS_HIDDEN": "Skjul valgte brukere fra besøksregisteret",
    "INTEGRATE_USERS": "Integrer valgte brukere med adgangskontrollsystem",
    "ASSIGN_FOOD_DEAL": "Tildel lunsjavtale til valgte brukere",
    "ASSIGN_SUBDIVISION": "Legg valgte brukere til i avdeling",
    "ASSIGN_SUBDIVISION_DESCRIPTION": "Alle valgte brukere vil bli en del av den valgte avdelingen. Eventuelle brukere som allerede er del av en avdeling vil bli overskrevet.",
    "ASSIGN_SUBDIVISION_BUTTON": "Legg {{count}} brukere til i avdeling",
    "FOOD": {
      "INTEGRATED": "Aktiv lunsjavtale",
      "NOT_INTEGRATED": "Ingen lunsjavtale",
      "DEACTIVATED": "Deaktivert lunsjavtale"
    },
    "TABLE_HEADERS": {
      "ATTRIBUTES": "Atributter",
      "COMPANY_CONTACT": "Kontaktperson for selskap",
      "COMPANY_VISITS": "Varsles ved besøk til selskap",
      "NAME": "Navn",
      "FIRST_NAME": "Fornavn",
      "LAST_NAME": "Etternavn",
      "EMAIL": "Epost",
      "PHONE": "Telefonnummer",
      "LANGUAGE": "Språk",
      "CUSTOM_EMPLOYEE_ID": "Ansatt nummer",
      "ACCESS_CARDS": "Adgangskort",
      "VISIBLE": "Besøksregister",
      "FOOD": "Mat",
      "LAST_LOGIN": "Siste login",
      "CREATED_AT": "Opprettet på",
      "COMPANY": "Selskap",
      "PROFILE_PIC": "Profilbilde",
      "BUILDING_ADMIN_NOTIFICATIONS": "Varsle ved endringer i adgangskort",
      "PART_OF_OPERATIONS": "Er del av driftsteamet",
      "COMPANY_ADMIN_ACCESS_NOTIFICATIONS": "Varsle ved deaktivering av adgangskort",
      "COMPANY_ADMIN": "Selskapets administrator",
      "ACCESS_ROLES": "Adgangsgrupper",
      "STATUS": "Brukerstatus"
    },
    "STATUS": {
      "ACTIVE": "Aktiv"
    },
    "USER_DISABLED": "Denne brukeren ble deaktivert<hasDate> på siste arbeidsdag den {{date}}</hasDate>, og har derfor mistet tilgangen til alle Welcome Workdays-tjenester.",
    "REACTIVATE_USER": "Reaktiver bruker",
    "DELETION_WARNING": {
      "SHORT": "Brukeren blir slettet {{deletionDate}}",
      "TOOLTIP": "Som del av vår kvartalvise revisjon blir denne brukeren slettet på oppgitt dato grunnet inaktivitet",
      "BANNER": "Som del av vår kvartalvise revisjon vil noen av brukerne bli <bold>slettet {{deletionDate}} grunnet inaktivitet</bold>. <button>Trykk her</button> for å se hvilke brukere dette gjelder.",
      "BANNER_INACTIVE_ONLY": "Som del av vår kvartalvise revisjon vil disse brukerne bli <bold>slettet {{deletionDate}} grunnet inaktivitet</bold>.",
      "BANNER_CURR_USER": "<bold>Denne brukeren har vært inaktiv siden {{lastActiveDate}}</bold>. Som del av vår kvartalvise revisjon vil brukeren derfor bli <bold>slettet {{deletionDate}}</bold>.",
      "DELAY_DELETION_BUTTON": "Utsett sletting til neste kvartal",
      "SHOW_ALL_BUTTON": "Vis alle brukere",
      "DELETION_EXTENDED": "Sletting av denne brukeren har blitt utsatt til {{newDeletionDate}}",
      "DELETION_EXTENSION_FAILED": "Kunne ikke utsette sletting av denne brukeren. Prøv igjen senere eller be brukeren logge inn selv!"
    },
    "ALSO_ADMIN": "Denne brukeren er også administrator for dette selskapet.",
    "PROVISIONED": {
      "LABEL": "SCIM",
      "DESCRIPTION": "Styres av selskapets brukersynkronisering (f.eks. Entra ID). Endringer gjort her kan bli overskrevet ved neste synkronisering."
    },
    "ASSIGN_COMPANY_CONTACT": {
      "LABEL": "Gjør til kontaktperson",
      "DISABLED": "Kun brukere som tilhører selskapet kan bli kontaktperson",
      "DISABLED_NOT_ADMIN": "Du må være administrator for dette selskapet for å gjøre noen til kontaktperson",
      "SUCCESS": "{{userName}} er nå selskapets kontaktperson",
      "ERROR": "Kunne ikke gjøre {{userName}} til kontaktperson. Prøv igjen senere!"
    },
    "NOTIFY_MODULE": {
      "TOGGLE_ON": "Skru PÅ varsler for {{moduleName}}",
      "TOGGLE_OFF": "Skru AV varsler for {{moduleName}}",
      "SUCCESS_TOGGLED_ON": "{{userName}} blir nå varslet ved {{moduleName}}!",
      "SUCCESS_TOGGLED_OFF": "{{userName}} blir ikke lenger varslet ved {{moduleName}}",
      "ERROR": "Kunne ikke oppdatere varselinnstillinger for {{userName}}. Prøv igjen senere!"
    },
    "CONFIRM_USER_UPLOAD": "Bekreft brukeropplasting",
    "SHOW_DISABLED_USERS": "Vis deaktiverte brukere",
    "CONFIRM_USER_UPLOAD_DESCRIPTION": "Du er i ferd med å invitere {{count}} brukere.",
    "SEND_EMAIL": "Send invitasjons-epost",
    "SEND_EMAIL_DESCRIPTION": "Alle brukere vil motta en e-postinvitasjon med en lenke for å sette opp kontoen sin.",
    "SEND_NO_EMAIL_DESCRIPTION": "Ingen invitasjons-e-post vil bli sendt til de opplastede brukerne. Du må varsle dem manuelt.",
    "SEND_EMAIL_OFF": "Når av, sendes ingen invitasjon. Varsle brukere manuelt",
    "MODULE_NAMES": {
      "COMPANY_VISITS": "besøk til selskap",
      "MEETING_ROOM_BOOKINGS": "møteromsreservasjon",
      "ACCESS_CARD_ORDERS": "adgangskortbestilling",
      "ACCESS_CARD_DEACTIVATIONS": "adgangskortdeaktivering",
      "BUILDING_ACCESS_CARDS": "bestilling og deaktivering av adgangskort",
      "ACCESS_CARD_ORDER_OR_DEACTIVATION": "adgangskortbestilling og/eller deaktivering"
    }
  },
  "SIDEBAR": {
    "MORE": "Mer",
    "WORKSPACES": {
      "ARIA_LABEL": "Arbeidsområder",
      "USER": "Meg",
      "COMPANY": "Selskap",
      "BUILDING": "Bygg",
      "SNACK": "Møtemat",
      "FOOD": "Lunsj",
      "RESTAURANT": "Oppsett",
      "SUPER": "Super",
      "OVERVIEW": "Oversikt",
      "SETTINGS": "Min profil"
    },
    "HOME": "Dashbord",
    "ACCESS": "Adgang",
    "BUILDING_ACCESS": "Adgang",
    "BUILDING_ACCESS_ROLE_MANAGEMENT": "Administrasjon av adgangsgrupper",
    "COMPANY_ADMIN_HEADING": "Selskap",
    "BUILDING_ADMIN_HEADING": "Bygning",
    "VISITORS": "Mine besøkende",
    "LOG_OUT": "Logg ut",
    "BOOKINGS": "Møterom",
    "LUNCH": "Lunsj",
    "MY_ORDERS": "Mine bestillinger",
    "ORDER": "Bestill mat",
    "BUILDING_BOOKINGS": "Alle reservasjoner",
    "INFO": "Om bygget",
    "HELP": "Hjelp",
    "CHANGELOG": "Hva er nytt?",
    "SETTINGS": "Profil",
    "CONSENTS": "Samtykker",
    "USERS": "Brukere",
    "SUBDIVISIONS": "Avdelinger",
    "NEWS": "Nyheter",
    "COMPANY_BOOKINGS": "Reservasjoner",
    "COMPANY_SETTINGS": "Selskapsinnstillinger",
    "COMPANY_VISITORS": "Besøkende",
    "BUILDING_SETTINGS": "Bygginnstillinger",
    "BUILDING_COMPANIES": "Selskaper",
    "BUILDING_VISITORS": "Besøkende i bygget",
    "BUILDING_COMMUNICATION": "Kommunikasjon",
    "SNACK_ORDERS": "Bestillingsoversikt",
    "SNACK_MENU": "Administrer meny",
    "SNACK_NEW_ITEM": "Nytt produkt",
    "SNACK_CATEGORIES": "Kategorier",
    "LUNCH_OVERVIEW": "Lunsjoversikt",
    "INSPECT_LUNCH_USERS": "Inspiser brukere",
    "FOOD_DEALS": "Selskaper & avtaler",
    "LUNCH_INSIGHTS": "Innsikter",
    "SNACK_SETTINGS": "Restaurantinnstillinger",
    "SUPER_SETTINGS": "Super settings",
    "SWITCH_TO": "Switch to {{language}}",
    "LOCKED": {
      "OPEN": "Menyen er nå låst i åpen tilstand",
      "CLOSED": "Menyen er nå skjult når den ikke er i bruk"
    }
  },
  "ADD_USER": {
    "ADD_USER": "Legg til bruker",
    "ADD_USER_DESCRIPTION": "Brukeren vil motta en invitasjon på e-post",
    "NAME": "Navn",
    "FIRST_NAME": "Fornavn",
    "LAST_NAME": "Etternavn",
    "EMAIL": "Epost",
    "PHONE": "Telefon",
    "JOB_TITLE": "Stillingstittel",
    "CUSTOM_EMPLOYEE_ID": "Ansatt nummer",
    "CUSTOM_EMPLOYEE_ID_DESCRIPTION": "Hvis du har en egen id for dine brukere kan du legge den til her. Hvis ikke kan du ignorere dette feltet",
    "SUBMIT": "Legg til",
    "VISIBLE": "Synlig i besøksregisteret",
    "HIDDEN": "Skjult i besøksregisteret",
    "ADMIN": "Legg til som administrator for {{companyName}}",
    "SUCCESS": "Bruker(e) ble lagt til",
    "FAILED": "Bruker(e) kunne ikke legges til",
    "ACS_INTEGRATED": "Bruker(e) integrert med adgangskontroll",
    "SKIPPED": "Bruker(e) eksisterte allerede og ble hoppet over",
    "ERROR": "Det oppsto en feil under tillegging av bruker(e)",
    "MISSING_COUNTRY_CODE": "Telefonnummer mangler landskode (eks. +47)",
    "CUSTOM_COUNTRY_CODE": "Landskoden er muligens ikke støttet, vurder å la feltet stå blankt",
    "EXISTING_USER_MATCHED": "En bruker med denne e-posten eksisterer allerede i dette selskapet under et annet bygg. Vi har koblet brukeren til den eksisterende kontoen og forhåndsutfylt informasjonen deres.",
    "AUTOPROVISIONING_DESCRIPTION": "Brukeren blir automatisk lagt til i adgangskontrollsystemet.",
    "DIGITAL_EMAIL_DESCRIPTION": "E-post med digitalt adgangskort blir sendt."
  },
  "EDIT_USER": {
    "EDIT_USER": "Rediger bruker",
    "DELETE": "Slett bruker permanent",
    "DELETE_MODAL": {
      "HEADER": "Bekreft sletting",
      "BODY": "Er du sikker på at du vil slette brukeren tilhørende <bold>{{userName}} ({{userEmail}})</bold>?<br/>All personlig data vil bli permanent slettet, og eventuelle tjenester som adgangskort, reservasjoner eller bestillinger tilhørende brukeren vil bli umiddelbart kansellert."
    },
    "DELETE_FROM_ACS": {
      "TITLE": "Slett bruker fra adgangskontroll",
      "MENU_LABEL": "Slett fra adgangskontroll",
      "WARNING_DESCRIPTION": "Er du sikker? Dette vil permanent slette brukerens kort, PIN-kode og alle adgangsgrupper fra adgangskontrollsystemet.",
      "WARNING_MULTI_BUILDING": "Hvis brukeren har tilgang til flere bygg, vil dette fjerne dem fra ALLE bygg.",
      "USER_LABEL": "Bruker:",
      "EMAIL_LABEL": "E-post:",
      "CONFIRM_BUTTON": "Slett fra adgangskontroll",
      "SUCCESS": "{{userName}} har blitt slettet fra adgangskontrollsystemet. Brukeren kan nå re-integreres.",
      "ERROR": "Kunne ikke slette {{userName}} fra adgangskontrollsystemet. Vennligst prøv igjen."
    },
    "DELETE_FROM_ACS_OR_REMOVE_LOCATION": {
      "MENU_LABEL": "Fjern lokasjon eller slett fra adgangskontroll",
      "WARNING_DESCRIPTION": "Er du sikker på at du vil fjerne denne lokasjonen fra brukerens adgangstillatelser? Hvis brukeren kun har adgang til denne ene lokasjonen, vil de bli fullstendig slettet fra adgangskontrollsystemet. Hvis brukeren har adgang til flere lokasjoner, vil kun den nåværende lokasjonen bli fjernet fra deres adgangstillatelser."
    },
    "VIEW_IN_SHARRY": "Vis i Sharry",
    "DELETE_DISABLED_PM": "Denne brukeren kan ikke slettes fordi hen er den nåværende byggansvarlige",
    "SAVE": "Lagre",
    "DANGER": "Permanente handlinger (fareområde)",
    "ADMIN": "Gjør til administrator for {{company}}",
    "ADMIN_SUCCESS": "{{userName}} er nå en administrator av {{companyName}}",
    "ADMIN_ERROR": "Kunne ikke gjøre {{userName}} til en administrator. Prøv igjen senere!",
    "INTEGRATE": "Integrer bruker med adgangskontrollsystem",
    "ACCESS_READ_ONLY_BANNER": "Som selskapsadministrator kan du se adgangsinformasjon, men bare administratorer med adgangsrettigheter kan administrere handlinger som integrering av brukere, tildeling av kort og endring av adgangsgrupper.",
    "INTEGRATE_SUCCESS": "{{userName}} er nå integrert med adgangskontrollsystemet",
    "INTEGRATE_ERROR": "Kunne ikke integrere {{userName}} med adgangskontrollsystemet. Prøv igjen senere!",
    "NO_DEFAULT_ROLES_WARNING": {
      "TITLE": "Ingen standard adgangsgrupper",
      "SUBTITLE": "Dette selskapet har ingen standard adgangsgrupper for dette bygget. Integrasjonen vil bli gjennomført uten noen adgangsgrupper, og adgangsgrupper må tildeles manuelt etter integrasjon. Vil du fortsette?",
      "CONFIRM": "Fortsett likevel",
      "CANCEL": "Avbryt"
    },
    "RESIGNATION_DATE": {
      "SET": "Sett siste arbeidsdag",
      "DESCRIPTION": "På slutten av denne datoen vil brukeren miste adgang til Welcome Workdays-plattformen, og eventuelle tjenester som adgangskort, reservasjoner eller bestillinger vil bli kansellert.",
      "MODAL_DESCRIPTION": "Datoen vil ikke være synlig for brukeren, og brukeren vil heller ikke varsles.",
      "MODAL_CONFIRMATION": "Brukeren vil bli deaktivert {{dateTime}}",
      "BANNER_DESCRIPTION": "Brukeren har siste arbeidsdag satt til {{date}}.",
      "LABEL": "Siste arbeidsdag",
      "CANCEL": "Avbryt sluttprosess",
      "EDIT": "Endre dato"
    }
  },
  "ACCESS_CARD": {
    "SEARCH": "Søk etter adgangskort",
    "REQUESTS_HEADER": "Forespørsler om adgangskort",
    "ALL_HEADER": "Aktive og deaktiverte adgangskort",
    "HEADER_COUNT_SEARCH": ", {{count}} matcher søket",
    "LAST_UPDATED": "Sist oppdatert",
    "EXPIRES_TODAY": "Utløper ved slutten av arbeidsdagen",
    "CARD_ORDER": "Bestilling av fysisk adgangskort",
    "ORDERED": "Bestilt",
    "COMPLETED_ORDERS_HEADER": "Fullførte kortbestillinger",
    "ARIA_DESCRIPTION": {
      "PHYSICAL": "Fysisk adgangskort",
      "DIGITAL": "Digitalt adgangskort",
      "PLASTIC": "Fysisk adgangskort",
      "VIRTUAL": "Digitalt adgangskort",
      "TEMPORARY": "Midlertidig adgangskort"
    },
    "TYPE": {
      "PLASTIC": "Fysisk kort",
      "VIRTUAL": "Digital lommebok",
      "TEMPORARY": "Midlertidig adgangskode"
    },
    "SUBTYPE": {
      "DEFAULT": "Mobilkort"
    },
    "DEVICE_TYPE": {
      "MOBILE": "mobil",
      "WATCH": "klokke"
    },
    "STATUS": {
      "ORDERED": {
        "LABEL": "Bestilt",
        "DESCRIPTION": "Kortet er bestilt men ikke produsert enda."
      },
      "ACTIVE": {
        "LABEL": "Aktivt",
        "DESCRIPTION": "Kortet er aktivt og kan brukes til byggets adgangskontroll."
      },
      "INACTIVE": {
        "LABEL": "Sperret",
        "DESCRIPTION": "Kortet er sperret og kan ikke brukes til byggets adgangskontroll."
      },
      "DEACTIVATED": {
        "LABEL": "Deaktivert",
        "DESCRIPTION": "Kortet har blitt deaktivert og må returneres til bygget ved tidligste anledning."
      },
      "CANCELLED": {
        "LABEL": "Kansellert",
        "DESCRIPTION": "Kortbestillingen ble kansellert og kortet vil derfor ikke bli produsert."
      },
      "AVAILABLE": {
        "LABEL": "Tilgjengelig",
        "DESCRIPTION": "Kortet er tilgjengelig og kan tildeles en bruker."
      },
      "ACTIVATING": {
        "LABEL": "Aktiverer",
        "DESCRIPTION": "Kortet aktiveres og vil være klart til bruk om kort tid."
      },
      "DEACTIVATING": {
        "LABEL": "Deaktiverer",
        "DESCRIPTION": "Kortet blir deaktivert og vil være ubrukelig om kort tid."
      },
      "COMPLETED": {
        "LABEL": "Fullført",
        "DESCRIPTION": "Bestillingen er fullført og kortet er klart til å tas i bruk i bygget."
      }
    },
    "NUMBER": "Kortnr.",
    "PIN": {
      "LABEL": "PIN",
      "DESCRIPTION": "Se PIN-koden",
      "YOUR_PIN": "Din PIN-kode er:",
      "TOO_LONG": "PIN-koden kan ikke være lengre enn 4 sifre",
      "PIN_INFO": "PIN-koden må være nøyaktig 4 sifre",
      "GENERATE_RANDOM": "Generer tilfeldig PIN-kode",
      "SUCCESS": "PIN-koden ble endret",
      "FAIL": "Kunne ikke endre PIN-kode. Prøv igjen senere!",
      "PIN_RULES": "Pinkoderegler",
      "RULES": {
        "INVALID_LENGTH": "PIN-koden må bestå av nøyaktig 4 sifre",
        "REPEATED_DIGITS": "PIN-koden kan ikke inneholde samme siffer gjentatt fire ganger (f.eks. 1111)",
        "CONSECUTIVE_NUMBERS": "PIN-koden kan ikke være en sekvens av påfølgende tall i stigende (f.eks. 1234) eller synkende (f.eks. 4321) rekkefølge",
        "KEYPAD_PATTERN": "PIN-koden kan ikke danne et rett linjemønster på tastaturet (f.eks. 2580 eller 0852)"
      },
      "RESET_PIN_LABEL": "Tilbakestill PIN-kode",
      "MANAGE_PIN_TITLE": "Administrer PIN",
      "APPLIES_TO_ALL_CARDS": "PIN-koden gjelder alle brukerens adgangskort i bygget, både fysiske og digitale.",
      "OVERWRITE_WARNING": "Hvis brukeren allerede har satt en PIN-kode, vil den bli overskrevet. Du kan ikke lese ut eksisterende PIN-kode – du kan bare sette en ny. Vær sikker på at du vet hva du gjør.",
      "NOTE_AND_SHARE_SECURELY": "Vi lagrer ikke PIN-koden – noter den og del den trygt med brukeren.",
      "RESET_SUCCESS_TITLE": "PIN-kode tilbakestilt for {{userName}}",
      "NEW_PIN_IS": "Ny PIN-kode er:"
    },
    "STARWATCH_BUILDING": {
      "TOOLTIP": "{{functionality}} er ikke klart enda på {{buildingName}}.",
      "CHANGE_PIN": "Endring av PIN-kode",
      "FORGOT_CARD": "Glemt kort funksjon"
    },
    "NO_CARD_NUMBER": "Ingen kortnummer",
    "NO_PIN": "Ingen PIN er satt",
    "MESSAGE": "Hentemelding",
    "NOTE": "Notat",
    "REASON_FOR_DEACTIVATION": "Grunnlag for deaktivering",
    "ACTIONS": {
      "ADD_NOTE": "Legg til notat",
      "ACTIVATE": "Aktiver kort",
      "BLOCK": {
        "LABEL": "Sperr kort",
        "TOOLTIP": "Sperr kun hvis kortet er mistet/stjålet eller trengs å deaktiveres"
      },
      "DEACTIVATE": "Deaktiver kort",
      "BLOCK_IN_ACS": {
        "LABEL": "Deaktiver kort",
        "TOOLTIP": "Deaktiver kortet permanent i adgangskontrollsystemet"
      },
      "CANCEL_ORDER": {
        "HEADER": "Er du sikker?",
        "BODY": "Kansellering av kortbestillingen kan ikke angres. Kortet vil bli kansellert og slettet fra systemet.",
        "CANCEL": "Kanseller kortbestilling",
        "TOOLTIP": "Kortet vil bli kansellert og slettet fra systemet.",
        "ERROR": "Kunne ikke kansellere kortbestilling. Prøv igjen senere!",
        "SUCCESS": "Kortbestilling kansellert"
      },
      "RESEND_PICKUP_EMAIL": {
        "BUTTON": "Varsle bruker",
        "HEADER": "Varsle bruker på nytt?",
        "BODY": "Dette vil sende brukeren en e-post om at adgangskortet er klart for henting, med den samme hentemeldingen som tidligere.",
        "SUCCESS": "Hentemelding sendt",
        "ERROR": "Kunne ikke sende hentemelding. Prøv igjen senere!"
      }
    },
    "BLOCK_MODAL": {
      "HEADER": "Er du sikker?",
      "BODY": "Hvis du sperrer kortet vil byggadministratorer umiddelbart bli varslet om at kortet må deaktiveres permanent. Du vil ikke kunne bruke kortet lenger."
    },
    "COMPANY_ADMIN_PLACEHOLDER": "Brukeren har ingen adgangskort, ønsker du å bestille ett?",
    "COMPANY_ADMIN_PLACEHOLDER_SHORT": "Brukeren har ingen adgangskort",
    "ORDER_PHYSICAL": "Bestill fysisk adgangskort",
    "ORDER_PHYSICAL_DISABLED": "Denne brukeren har allerede en ventende bestilling på fysisk adgangskort.",
    "ORDER_MESSAGE": {
      "TEXT": "Bestillingsmelding",
      "LABEL": "Bestillingsmelding (valgfritt)",
      "DESCRIPTION": "Legg ved en melding til personen som tar seg av kortbestillingen.",
      "APPLY_TO_ALL": "Denne meldingen vil bli brukt på alle kortene i denne bestillingen."
    },
    "TABLE_HEADERS": {
      "CARD_NUMBER": "Kortnummer",
      "ORDERED_AT": "Bestilt",
      "ACTIVATED_AT": "Aktivert",
      "INACTIVATED_AT": "Sperret",
      "DEACTIVATED_AT": "Deaktivert",
      "COMPANY": "Selskap",
      "ORDERED_BY": "Bestilt av",
      "RECIPIENT": "Mottaker",
      "STATUS": "Status",
      "FROZEN_CARDS": "Sperrede adgangskort",
      "CARD_HOLDER": "Kortinnehaver",
      "FROZEN_AT": "Sperret"
    },
    "DETAILS_MODAL": {
      "HEADER": "Adgangskortdetaljer",
      "PHONE_MISSING": "Ingen telefonnummer",
      "HISTORY": "Historikk",
      "NO_HISTORY": "Ingen historikk å vise",
      "ADD_A_COMMENT": "Legg til en kommentar",
      "CARD_ORDERED_BY": "Kortet ble bestilt av {{ name }} fra {{ company }}",
      "WITH_ORDER_MESSAGE": "med bestillingsmelding: \"{{ message }}\"",
      "CARD_ACTIVATED": "Kortet ble aktivert av {{ name }} fra {{ company }} ",
      "WITH_MESSAGE": "med hentemelding: \"{{ message }}\"",
      "CARD_INACTIVATED": "Kortet ble sperret av {{ name }} fra {{ company }} og en forespørsel om deaktivering er sendt",
      "CARD_DEACTIVATED": "Kortet ble deaktivert av {{ name }} fra {{ company }}",
      "ORDER_CANCELLED": "Kortbestillingen ble kansellert av {{ name }} fra {{ company }}",
      "WITH_REASON": " med grunn: \"{{ reason }}\"",
      "USERS_PREFFERED_LANGUAGE": "Mottakeren foretrekker {{ language }}",
      "CUSTOM_MESSAGE": "eller skriv en egendefinert melding",
      "CANCEL_CARD": "Kanseller kortbestilling",
      "DOWNLOAD_PIC": "Last ned bilde",
      "CARD_UPDATED": "Kortet ble oppdatert",
      "CARD_CREATED": "Kortet ble opprettet",
      "CARD_COMPLETED_BY": "Kortbestilling ble fullført av {{ name }} fra {{ company }}",
      "UNKNOWN_USER": "en ukjent bruker",
      "UNKNOWN_COMPANY": "et ukjent selskap"
    },
    "BLOCK_IN_ACCESS_CONTROL": "Deaktivering av kortet vil midlertidig sperre det for adgang. En administrator kan senere reaktivere eller slette det permanent.",
    "BLOCK_IN_ACCESS_CONTROL_MOBILE": "Deaktivering av det digitale adgangskortet vil permanent fjerne det fra adgangskontrollsystemet. Denne handlingen kan ikke angres.",
    "FORGOT_CARD": {
      "TITLE": "Glemt kortet?",
      "DESCRIPTION": "Du kan generere en adgangskode som åpner portene for deg. Koden vil være gyldig ut arbeidsdagen.",
      "GENERATE_CODE": "Generer kode",
      "CODE_GENERATED": "Adgangskode generert, vi vil også sende den til din e-post.",
      "CODE_GENERATION_FAILED": "Kunne ikke generere adgangskode. Prøv igjen senere!",
      "GENERATING": "Vi genererer din adgangskode",
      "GENERATING_IN_PROCESS": "Vi genererer din adgangskode. Dette kan ta noen sekunder, vennligst vent...",
      "CODE_READY": "Her er din midlertidige adgangskode for å få tilgang til bygningen:",
      "CODE_EXPIRES": "Vennligst merk at koden vil utløpe ved slutten av arbeidsdagen.",
      "DISABLED_DESCRIPTION": "Generering av adgangskode er utilgjengelig utenfor bygningens åpningstider."
    },
    "NEW_ACCESS_CARD": {
      "CREATE": "Nytt adgangskort",
      "HEADER": "Opprett nytt adgangskort",
      "DESCRIPTION": "Kortet blir aktivert og klart til bruk med en gang.",
      "SEND_EMAIL": "Send e-post med instruksjoner til brukeren",
      "SET_PIN_LABEL": "Sett PIN-kode (valgfritt)",
      "PIN_CODE_RECOMMENDATION": "Vi anbefaler generelt at brukere setter opp PIN-koden sin selv.",
      "CARD_FORMAT_LABEL": "Kortformat",
      "CARD_FORMAT_REQUIRED": "Velg et kortformat"
    },
    "ACTION_BUTTONS": {
      "ADD_CARD": "Legg til adgangskort",
      "PRINT_CARD": "Skriv ut adgangskort"
    },
    "TABS": {
      "REQUESTS": "Forespørseler",
      "COMPLETED": "Fullført"
    },
    "NO_FROZEN_CARDS": "Ingen sperrede kort å vise",
    "FROZEN_CARD": {
      "REACTIVATE": "Reaktiver kort",
      "DELETE": "Slett kort permanent",
      "DESCRIPTION": "Dette kortet er sperret og kan ikke brukes til å få adgang til bygningen. Du kan enten reaktivere kortet eller slette det permanent fra adgangskontrollsystemet.",
      "REACTIVATE_SUCCESS": "Kortet ble reaktivert",
      "REACTIVATE_FAIL": "Reaktivering av kortet feilet. Prøv igjen senere!",
      "DELETE_SUCCESS": "Kortet ble slettet fra adgangskontrollsystemet",
      "DELETE_FAIL": "Sletting av kortet feilet. Prøv igjen senere!",
      "BLOCK_SUCCESS": "Kortet ble sperret"
    },
    "ORDER": {
      "CREATE_BULK_ORDER_one": "Bestilling av adgangskort vil bli opprettet for {{count}} bruker",
      "CREATE_BULK_ORDER_other": "Bestilling av adgangskort vil bli opprettet for {{count}} brukere",
      "CREATE_BULK_ORDER_partial": "Bestilling av adgangskort vil bli opprettet for {{eligible}} av {{total}} brukere",
      "SKIPPED_NOT_INTEGRATED_one": "{{count}} bruker er ikke integrert med adgangskontrollsystemet",
      "SKIPPED_NOT_INTEGRATED_other": "{{count}} brukere er ikke integrert med adgangskontrollsystemet",
      "SKIPPED_HAS_PENDING_ORDER_one": "{{count}} bruker har allerede en ventende bestilling av adgangskort",
      "SKIPPED_HAS_PENDING_ORDER_other": "{{count}} brukere har allerede en ventende bestilling av adgangskort",
      "DISABLED_one": "{{count}} bruker er deaktivert",
      "DISABLED_other": "{{count}} brukere er deaktivert",
      "BULK_CARD_ORDER_SUCCESS": "Bestilling av adgangskort ble opprettet for {{count}} brukere",
      "BULK_CARD_ORDER_FAILURE": "Bestilling av adgangskort feilet for {{count}} brukere. Prøv igjen senere!"
    }
  },
  "DIGITAL_ACCESS": {
    "SEND": "Send e-post om digital adgang",
    "DESCRIPTION": "En e-post med instruksjoner for hvordan man genererer et digitalt adgangskort for {{building}} vil bli sendt til brukeren.",
    "SEND_SUCCESS": "E-post med instruksjoner ble sendt til brukeren.",
    "SEND_ERROR": "Kunne ikke sende e-post med instruksjoner til brukeren. Prøv igjen senere!"
  },
  "ACCESS_GROUPS": {
    "HEADER": "Adgangsgrupper",
    "DESCRIPTION": "Dette er adgangsgruppene du har blitt tildelt av ditt selskap. Hvis noe ser galt ut, ta kontakt med din administrator.",
    "DEFAULT": "Standard",
    "NO_GROUPS": "Ingen adgangsgrupper å vise",
    "DESCRIPTION_ADMIN": "Her kan du administrere adgangsgruppene for brukerne i selskapet ditt.",
    "UPDATE_SUCCESS": "Adgangsgrupper ble oppdatert",
    "UPDATE_ERROR": "Kunne ikke oppdatere adgangsgrupper. Prøv igjen senere!",
    "RESTRICTED_ROLE": "Denne adgangsgruppen kan kun administreres av selskapsadministratorer for: {{companies}}",
    "RESTRICTED_ROLE_OTHER_COMPANIES": "Denne adgangsgruppen kan kun administreres av selskapsadministratorer for andre selskaper"
  },
  "PAGE_LOADING": {
    "LOADING": "Laster inn",
    "TAKING_TOO_LONG": "Tar det for lang tid? Prøv å logge ut og laste siden på nytt."
  },
  "LOAD_ERROR": {
    "HEADER": "Noe gikk galt",
    "BODY": "Vi kunne ikke laste siden, ta kontakt om problemet vedvarer",
    "DETAILS": "Tekniske detaljer",
    "COPY": "Kopier feildetaljer",
    "COPIED": "Kopiert",
    "RETRY": "Prøv på nytt"
  },
  "NO_WORKSPACE": {
    "HEADER": "Ingen arbeidsplass tilknyttet",
    "BODY": "Kontoen din er ikke koblet til en bygning eller et selskap ennå. Kontakt administratoren din for å få tilgang."
  },
  "AUTH_ERROR": {
    "TITLE": "Oops! Det skjedde en feil under autentiseringen.",
    "DESCRIPTION": "Prøv å logge ut og laste siden på nytt. Påse at du prøver å logge inn med riktig bruker."
  },
  "LOGIN": {
    "BUTTON": "Logg inn",
    "RE_LOGIN_BUTTON": "Logg inn på nytt",
    "MAGIC_HELP": "<h2><b>Sjekk innboksen din</b></h2><linebreak />Hvis du er registrert, vil du motta en innloggingslenke.<linebreak />Hvis ikke, vennligst kontakt din selskapsadministrator.",
    "OTP_HELP": "Vi sendte en kode til din epost, vennligst skriv den inn her.",
    "NO_ACCESS": "Kunne ikke få tak i innloggingssystem, vennligst prøv igjen senere.",
    "USER_NOT_FOUND": "Fant ingen bruker med denne e-posten",
    "USER_DISABLED": "Kontoen er deaktivert. Vennligst kontakt din administrator.",
    "SEND_VIA_EMAIL_INSTEAD": "Send kode på e-post i stedet",
    "SEND_VIA_SMS_INSTEAD": "Send kode på SMS i stedet",
    "OTP_SENT_VIA_EMAIL": "En ny kode ble sendt til e-posten din",
    "OTP_SENT_VIA_SMS": "En ny kode ble sendt til mobilen din",
    "OTP_LOCKED": "For mange feil koder. Vent noen minutter, og be så om en ny kode.",
    "OTP_LOCKED_COUNTDOWN": "For mange feil koder. Du kan be om en ny kode om {{time}}.",
    "OTP_THROTTLED": "For mange forsøk. Vennligst vent litt før du prøver igjen.",
    "OTP_THROTTLED_COUNTDOWN": "For mange forsøk. Prøv igjen om {{time}}.",
    "OTP_CAPTCHA_REQUIRED": "Vi klarte ikke å bekrefte at forespørselen kom fra en ekte person. Last inn siden på nytt og prøv igjen.",
    "REQUEST_NEW_CODE": "Be om en ny kode",
    "SEND_CODE": "Send kode"
  },
  "VALIDATION": {
    "NUMBER": "{{field}} må være et tall",
    "EXACT_LENGTH": "{{field}} må være nøyaktig {{length}} {{type}}",
    "MIN_LENGTH": "{{field}} må være minst {{length}} {{type}}",
    "REQUIRED": "{{field}} er påkrevd",
    "INVALID": "{{field}} er ugyldig",
    "MAX_LENGTH": "{{field}} kan ikke være lengre enn {{length}} {{type}}",
    "FORBIDDEN_CHARACTERS": "Forbudte tegn. Bare bokstaver og enkelte tegn er tillatt",
    "FORBIDDEN_CHARACTERS_WITH_NUMBERS": "Forbudte tegn. Bare bokstaver, tall og enkelte tegn er tillatt",
    "INVALID_PHONE": "Telefonnummeret må inneholde landskode (f.eks. +47) og være mellom 7 og 15 tegn langt",
    "EMAIL_USED": "Bruker med denne e-posten eksisterer allerede i dette bygget",
    "EMAIL_DIFFERENT_COMPANY": "Denne brukeren eksisterer allerede og tilhører et annet selskap i en annen bygning.",
    "DOMAIN": "E-post må være fra selskapets domene(r): {{domain}}",
    "CONTRY_CODE_MISSING": "Landskode er påkrevd (f.eks. +47)",
    "SUBMIT_ERROR_TITLE": "Feil",
    "SUBMIT_ERROR_DEFAULT_MESSAGE": "Noe gikk galt. Vennligst prøv igjen senere.",
    "SUS_PHONE": "Dette ser ikke ut som et norsk telefonnummer, er du sikker på at det er riktig?",
    "VISITOR_COUNTRY_CODE_WARNING": "Vi kan ikke alltid nå utenlandske nummere. Vurder å ta kontakt med den besøkende på egenhånd.",
    "DUPLICATE_PHONE": "Du har allerede lagt til en deltaker med dette telefonnummeret",
    "DUPLICATE": "{{field}} finnes allerede. Bruk en unik verdi.",
    "INVALID_PHONE_FORMAT": "Ugyldig telefonnummerformat",
    "INVALID_EMAIL_FORMAT": "Ugyldig e-postformat",
    "CUSTOM_COUNTRY_CODE": "Landskoden du har oppgitt støttes ikke, så vi kan kanskje ikke kontakte deltakeren",
    "DATE_AFTER_X": "{{field}} må være etter {{x}}",
    "DATE_BEFORE_X": "{{field}} må være før {{x}}",
    "DATE_FUTURE": "{{field}} må være i fremtiden",
    "DATE_IN_RANGE": "{{field}} er utenfor det tillatte tidsrommet",
    "DATE": "{{field}} må være en gyldig dato",
    "EMOJIS_NOT_SUPPORTED": "Emojier er ikke støttet i SMS-meldinger"
  },
  "SYSTEM_MESSAGE_CONSENT": {
    "LABEL": "Samtykke til å motta systemmeldinger",
    "DESCRIPTION": "Du vil motta systemmeldinger via SMS og e-post fra Welcome Workdays AS. Disse meldingene er kun for driftsformål, ikke markedsføring. Dette samtykket er nødvendig for at applikasjonen skal fungere."
  },
  "COMPANY_SETTINGS": {
    "CHANGE_LOGO": "Trykk her for å laste opp en ny logo",
    "COMPANY_NAME": "Selskapsnavn",
    "ORG_NUMBER": "Organisasjonsnummer",
    "LARGE_FILE_UPLOAD": "Har du over 300 brukere å laste opp? Vennligst last opp en csv fil her så vil vi prosessere den for deg.",
    "CUSTOM_LET_IN_MESSAGE": "Egendefinert \"Slipp inn\"-melding",
    "CUSTOM_LET_IN_MESSAGE_DESCRIPTION": "Denne meldingen vil bli sendt til alle besøkende når de slippes inn. Kun ett språk støttes.",
    "CUSTOM_LET_IN_MESSAGE_PLACEHOLDER": "Eks. Ta heisen til 3. etasje",
    "ADMINS": {
      "HEADER": "Administratorer",
      "DESCRIPTION": "Husk å invitere den aktuelle brukeren inn i {{company}} før du legger dem til som administrator.",
      "ADD": "Legg til administrator",
      "ADD_BODY": "Søk etter brukerens e-post. Du må skrive inn hele e-post adressen for å finne brukeren. Husk at brukeren allerede må ha en profil i denne bygningen for å kunne legges til som administrator.",
      "NO_RESULTS": "Kontroller at e-posten du skrev inn er korrekt og at brukeren allerede er en del dette selskapet.",
      "CONTACT_DESCRIPTION": "Denne brukeren er spesielt ansvarlig for å håndtere henvendelser fra brukere. Deres navn og epost vil være lett tilgjengelig for alle brukere i selskapet.",
      "COMPANY_VISITS_DESCRIPTION": "Disse brukerne vil bli varslet ved besøk til selskap (besøk uten en spesifikk vert). Dersom ingen brukere er valgt, vil alle bli varslet ved besøk.",
      "ACTIONS": "Handlinger",
      "REMOVE_AS_ADMIN": "Ta vekk administrator rettigheter",
      "REMOVE_NOT_ALLOWED": "Du må sette en ny kontaktperson før du kan ta vekk administrator rettigheter",
      "REMOVE_SUCCESS": "Brukeren er ikke lenger administrator for dette selskapet",
      "REMOVE_ERROR": "Kunne ikke fjerne administrator. Prøv igjen senere!",
      "COMPANY_ACCESS_NOTIFICATIONS_DESCRIPTION": "Disse brukerne vil bli varslet når et adgangskort deaktiveres eller slettes for en bruker i dette selskapet. Hvis ingen brukere er valgt, vil alle brukere bli varslet.",
      "ADD_TO_NOTIFICATION_LIST": "Legg til i varslingslisten",
      "NONE_SELECTED_ALL_NOTIFIED": "Siden ingen administratorer er valgt, vil alle administratorer bli varslet.",
      "NONE_SELECTED_NONE_NOTIFIED": "Siden ingen administratorer er valgt, vil ingen administratorer bli varslet."
    },
    "VARIOUS": {
      "NOTIFY_USERS_BEFORE_DELETION": "Varsle inaktive brukere på e-post før sletting",
      "NOTIFY_USERS_BEFORE_DELETION_DESCRIPTION": "Brukere som har vært inaktive i lang tid vil bli slettet som en del av vår kvartalsvise revisjon. Når innstillingen er aktivert, vil inaktive brukere bli varslet to ganger, både en måned og to uker før sletting.",
      "SKIP_SAME_COMPANY_USER_DUPLICATION_CHECK": "Hopp over duplikatsjekk for samme selskap",
      "SKIP_SAME_COMPANY_USER_DUPLICATION_CHECK_DESCRIPTION": "Når den er aktivert, vil vi bare sjekke om brukeren allerede finnes i samme bygning når den nye brukeren legges til, og hoppe over sjekken for andre selskaper i andre bygninger.",
      "SCIM_ENABLED": "Aktiver API for brukerprovisjonering (SCIM)",
      "SCIM_ENABLED_DESCRIPTION": "Lar selskapets administratorer opprette API-tokens, slik at identitetsleverandøren eller HR-systemet deres kan administrere brukere automatisk. Gjelder selskapet i alle bygg. Slås det av, blokkeres eksisterende tokens uten at de slettes."
    },
    "SCIM": {
      "HEADER": "API for brukerprovisjonering (SCIM 2.0)",
      "DESCRIPTION": "La identitetsleverandøren (f.eks. Microsoft Entra ID) eller HR-systemet deres opprette, oppdatere, deaktivere og slette brukere i {{company}} automatisk. Nye brukere legges til i alle bygg selskapet er i.",
      "BASE_URL": "Tenant-URL",
      "CREATE": "Opprett token",
      "NO_TOKENS": "Ingen tokens er opprettet ennå.",
      "NAME": "Navn",
      "NAME_PLACEHOLDER": "F.eks. Entra ID eller HR-system",
      "EXPIRES_AT": "Utløper (valgfritt)",
      "EXPIRES_AT_HELP": "La stå tomt for et token som aldri utløper. Integrasjoner slutter å virke når tokenet utløper.",
      "CREATED": "Opprettet {{date}}",
      "LAST_USED": "Sist brukt {{date}}",
      "NEVER_USED": "Aldri brukt",
      "EXPIRES": "Utløper {{date}}",
      "STATUS_ACTIVE": "Aktiv",
      "STATUS_EXPIRED": "Utløpt",
      "STATUS_REVOKED": "Tilbakekalt",
      "ROTATE": "Forny",
      "REVOKE": "Tilbakekall",
      "COPY": "Kopier",
      "COPIED": "Kopiert til utklippstavlen",
      "TOKEN_TITLE": "Kopier tokenet nå",
      "TOKEN_WARNING": "Dette er eneste gang tokenet vises. Lagre det et trygt sted, f.eks. i en passordbehandler, og lim det inn i feltet «Secret token» hos identitetsleverandøren.",
      "ROTATE_CONFIRM_TITLE": "Forny «{{name}}»?",
      "ROTATE_CONFIRM_BODY": "Et nytt token opprettes. Det nåværende tokenet fortsetter å virke i 24 timer, slik at dere rekker å oppdatere integrasjonen.",
      "REVOKE_CONFIRM_TITLE": "Tilbakekall «{{name}}»?",
      "REVOKE_CONFIRM_BODY": "Tokenet slutter å virke umiddelbart. Brukere det har opprettet beholdes, og kan igjen administreres i portalen.",
      "REVOKED": "Token tilbakekalt",
      "DISABLED": "Brukerprovisjonering er slått av for {{company}}, så disse tokenene virker ikke. Du kan fortsatt tilbakekalle dem. Kontakt Welcome Workdays for å slå det på igjen.",
      "ERRORS": {
        "NAME_REQUIRED": "Skriv inn et navn",
        "NAME_TOO_LONG": "Navnet kan være maks 100 tegn",
        "EXPIRY_IN_PAST": "Utløpsdatoen må være i dag eller senere"
      }
    },
    "SSO_SETTINGS": "SSO Innstillinger",
    "SSO_SETTINGS_DESCRIPTION": "Ny til SSO? Lær mer om de forskjellige <ssoUrl>innloggingsmetodene</ssoUrl> vi tilbyr samt <azureUrl>SSO med Microsoft Azure</azureUrl>.",
    "CONTACT_ADMIN": "Vennligst kontakt <mailto>support@welcomeworkdays.com</mailto> for å redigere domener.",
    "SSO_DOMAIN": "SSO Domene",
    "SSO_PROVIDER": "SSO Leverandør",
    "VISIT_SETTINGS": "Welcome Visit Innstillinger",
    "BOOKING_SETTINGS": "Welcome Booking Innstillinger",
    "BOOKING_DESCRIPTION": "Welcome Booking er en modul som håndterer reservervasjoner i bygget. Her kan du tilpasse selskapets bookinginnstillinger. Les mer om <url>Welcome Booking</url>.",
    "BULK_FILE_UPLOAD": "Stor fil opplasting",
    "VISIT_DESC": "Welcome Visit er en modul som håndterer besøksregistrering på bygget. Her kan du tilpasse selskapets besøksinnstillinger. Les mer om <url>Welcome Visit</url>.",
    "ACCESS_SETTINGS": "Welcome Access Innstillinger",
    "ACCESS_DESCRIPTION": "Welcome Access er en modul som håndterer adgangskontroll i bygget. Her kan du tilpasse selskapets adgangsinnstillinger. Les mer om <url>Welcome Access</url>.",
    "SNACK_SETTINGS": "Welcome Snack Innstillinger",
    "SNACK_DESCRIPTION": "Welcome Snack er en modul som håndterer møtematbestillinger i bygget. Her kan du tilpasse selskapets bestillingsinnstillinger. Lær mer om <url>Welcome Snack</url>.",
    "SNACK_ALLOW_INVOICING": "Tillat at alle brukere kan betale med faktura",
    "SNACK_ALLOW_INVOICING_DESCRIPTION": "Når innstillingen er skrudd på, kan alle brukere i selskapet betale med faktura når de bestiller møtemat. Dersom innstillingen skrus av vil kun selskapsadministratorer kunne betale med faktura. Videre kan vanlige brukere oppleve degradert eller manglende funksjonalitet.",
    "FOOD_SETTINGS": "Welcome Food Innstillinger",
    "FOOD_SETTINGS_COMPANY": "Welcome Food Oversikt",
    "FOOD_SETTINGS_TOTAL_USERS": {
      "TEXT": "{{companyName}} har totalt <strong>{{usersCount}}</strong> brukere i Welcome Workdays",
      "SUBDIVISION_TEXT": "{{subdivisionName}} har totalt <strong>{{usersCount}}</strong> brukere i denne underavdelingen",
      "WARNING": "Det er for øyeblikket flere brukere integrert med restaurantsystemet enn som er til stede i selskapet. Dette betyr sannsynligvis at dataene i restaurantsystemet er utdaterte og bør revideres.",
      "NOT_BUILDING_ADMIN": "Vennligst rapporter dette til din bygningsadministrator."
    },
    "FOOD_SETTINGS_ACTIVE_USERS": "Aktiverte brukere",
    "FOOD_SETTINGS_DISABLED_USERS": "Deaktiverte brukere",
    "FOOD_SETTINGS_NOT_INTEGRATED_USERS": "Ikke integrerte brukere",
    "FOOD_MAX_USERS": {
      "STATS": {
        "LABEL": "{{companyName}} har en grense på <bold>{{total}}</bold> aktive lunsjavtaler (utenom gjesteavtaler), og har brukt <colored>{{percentage}}%</colored> av grensen"
      },
      "NO_LIMIT": "{{companyName}} har ingen grense på antall aktive lunsjavtaler.",
      "EDIT_LIMIT": "Rediger grense",
      "SUBDIVISION_NOTE": "Denne underavdelingen har {{activeCount}} aktive lunsjavtaler. Selskapets grense ({{companyLimit}} lunsjavtaler) gjelder for hele selskapet.",
      "SUBDIVISION_NOTE_NO_LIMIT": "Denne underavdelingen har {{activeCount}} aktive lunsjavtaler. Selskapet har ingen grense på antall lunsjavtaler."
    },
    "FOOD_DESCRIPTION": "Welcome Food er en modul som gir en sømløs matopplevelse i bygget. Her kan du tilpasse selskapets mat-relaterte innstillinger. Les mer om <url>Welcome Food</url>.",
    "FOOD_DESCRIPTION_COMPANY": "Welcome Food er en modul som gir en sømløs matopplevelse i bygget. Her kan du overvåke selskapets bruk av restaurantsystemet og se tilgjengelige avtaler. Les mer om <url>Welcome Food</url>.",
    "VISIT_MODE": {
      "LABEL": "Besøksregistrering",
      "ENABLED": {
        "LABEL": "Aktivert",
        "DESCRIPTION": "Når innstillingen er <bold>aktivert</bold> er både selskapet og ansatte synlig i besøksregistreringskiosken."
      },
      "LIMITED": {
        "LABEL": "Begrenset",
        "DESCRIPTION": "Når innstillingen er <bold>begrenset</bold> er selskapet synlig i besøksregistreringskiosken og brukeren vil få instruksjonene du setter her."
      },
      "DISABLED": {
        "LABEL": "Deaktivert",
        "DESCRIPTION": "Når innstillingen er <bold>deaktivert</bold> er selskapet helt skjult i besøksregistreringskiosken."
      }
    },
    "VISITOR_LABEL_PRINTING": {
      "LABEL": "Automatisk utskrift av besøksetikett",
      "DESCRIPTION": "Når innstillingen er aktivert, skrives besøksetikett ut automatisk ved innsjekk når labelutskrift er aktivert for bygget."
    },
    "FLOOR": "Etasje for besøksmottak",
    "VISITOR_INSTRUCTION": "Instrukser for besøkende",
    "EXPORT_VISITORS": {
      "BUTTON": "Eksporter alle besøkende",
      "DESCRIPTION": "Welcome Workdays lagrer kun besøksdata i 30 dager. Derfor inkluderer denne eksporten alle besøkende (både fra besøksregistreringskioskene og forhåndsregistrerte) til {{companyName}} fra {{fromDate}} - {{toDate}}."
    },
    "ADD_DOMAINS": "Legg til domener",
    "ACCESS": {
      "COMPANY_INTEGRATED": "Selskapet er integrert med adgangskontrollsystemet",
      "READ_ONLY_BANNER": "Du kan se disse adgangsinnstillingene, men du har ikke tilgang til å endre dem. Bare administratorer med adgangsrettigheter kan redigere innstillingene for adgangskontroll.",
      "INTEGRATE_COMPANY": "Integrer selskapet med adgangskontrollsystemet",
      "INTEGRATE_SUCCESS": "Integrert {{companyName}} med adgangskontrollsystemet",
      "INTEGRATE_ERROR": "Kunne ikke integrere {{companyName}} med adgangskontrollsystemet. Prøv igjen senere!",
      "AUTOMATIC_PROVISIONING_MODE": "Automatisk synkronisering med adgangssystemet",
      "AUTOMATIC_PROVISIONING_MODE_DESCRIPTION": "Nye brukere opprettes automatisk i adgangskontrollen når de inviteres",
      "DIGITAL_BADGE_MODE": "Digitalt adgangskort",
      "DIGITAL_BADGE_MODE_DESCRIPTION": "Gjør det mulig for brukere å generere digitale kort i adgangskontrollsystemet",
      "ENABLE_ACCESS_CODE_GENERATION": "Aktiver generering av adgangskoder",
      "ENABLE_ACCESS_CODE_GENERATION_DESCRIPTION": "Tillat generering av midlertidige adgangskoder for brukere og besøkende i dette selskapet",
      "COMPANY_ADMINS_CARD_CREATION": "Tillat selskapsadministratorer å administrere adgangskort",
      "COMPANY_ADMINS_CARD_CREATION_DESCRIPTION": "Når aktivert, kan selskapsadministratorer opprette og aktivere fysiske adgangskort for brukere i sitt selskap",
      "COMPANY_ADMINS_PIN_MANAGEMENT": "Tillat selskapsadministratorer å sette PIN-kode",
      "COMPANY_ADMINS_PIN_MANAGEMENT_DESCRIPTION": "Når aktivert, kan selskapsadministratorer sette eller tilbakestille PIN-kode for brukere i sitt selskap som aldri har logget inn",
      "SEND_DIGITAL_ACCESS_EMAIL_ON_INTEGRATION": {
        "TOGGLE": "Send digital adgangs-e-post ved integrering",
        "DESCRIPTION": "Når aktivert, vil en digital adgangs-e-post bli sendt til brukere ved integrering",
        "TOOLTIP": "Kan kun aktiveres hvis digitalt adgangskort er aktivert"
      },
      "ALLOW_CARD_PRINTING_BY_COMPANY_ADMINS": {
        "TOGGLE": "Tillat utskrift av adgangskort for selskapsadministratorer",
        "DESCRIPTION": "Når aktivert, kan selskapsadministratorer skrive ut fysiske adgangskort for brukere i sitt selskap"
      }
    },
    "FOOD": {
      "COMPANY_INTEGRATED": "Selskapet er lenket til restaurantsystemet med ID",
      "COMPANY_NOT_INTEGRATED": "Selskapet er ikke enda lenket til restaurantsystemet",
      "LINK_COMPANY": "Lenke selskap til restaurantsystem",
      "MAX_USERS": {
        "LABEL": "Antall tillatte aktive brukere",
        "PLACEHOLDER": "Ingen begrensning",
        "INFO": "Dette er en valgfri begrensning på antall aktive brukere {{companyName}} kan ha i restaurantsystemet"
      }
    },
    "ACCESS_CONTROL_SYSTEM": {
      "LABEL": "Adgangskontrollsystem",
      "INTEGRATED": "Integrert",
      "NOT_INTEGRATED": "Ikke integrert"
    },
    "ADMIN_NOTIFICATIONS": {
      "HEADER": "Administratorvarsler",
      "DESCRIPTION": "Velg hvilke selskapadministratorer som skal varsles om {{moduleName}}."
    },
    "ACCESS_GROUPS": {
      "HEADER": "Tilgangsgrupper",
      "DESCRIPTION": "Tilgangsroller som er tildelt dette selskapet i adgangskontrollsystemet.",
      "EMPTY_STATE": "Ingen tilgangsgrupper er tildelt dette selskapet enda.",
      "MANAGE_LINK": "Administrer tilgangsgrupper",
      "ALLOWED_BY_OTHERS_HEADER": "Kan tildeles av andre selskaper",
      "ALLOWED_BY_OTHERS_DESCRIPTION": "Disse tilgangsgruppene administreres av andre selskaper, men kan likevel tildeles brukere i dette selskapet.",
      "VISITOR_ROLES_HEADER": "Tilgangsgrupper for besøkende",
      "VISITOR_ROLES_DESCRIPTION": "Tilgangsgrupper tildelt dette selskapets besøkende.",
      "VISITOR_ROLES_EMPTY_STATE": "Ingen tilgangsgrupper for besøkende er tildelt dette selskapet enda."
    }
  },
  "COMPANIES_TABLE": {
    "ACTIVATED_USERS": "Aktiverte brukere",
    "TOTAL_USERS": "Totale brukere",
    "USERS": "Brukere (Aktivert/Totalt)",
    "FOOD_ACTIVE": "Restaurant brukere",
    "FOOD_LIMIT": "Restaurant grense",
    "FOOD_USERS": "Restaurant brukere (Aktive/Grense)",
    "EXPORT_USERS": "Eksporter brukere",
    "EXPORT_ALL_USERS": "Eksporter alle brukere",
    "DELETE_COMPANY": "Slett selskap",
    "TOTAL_ACTIVE_USERS": "Det er <strong><green>{{value}}</green> / {{total}}</strong> <grey>({{percentage}}%)</grey> brukere som har aktivert kontoen sin"
  },
  "COMPANY_DETAILS": {
    "DELETE": {
      "NOT_ALLOWED": "Kun selskaper uten brukere kan slettes",
      "BUTTON": "Slett selskap permanent"
    },
    "BECOME_ADMIN": "Bli selskapsadministrator",
    "NOTIFICATIONS": {
      "ADMIN_SUCCESS": "Du er nå administrator i {{companyName}}",
      "ADMIN_ERROR": "Kunne ikke legge deg til som administrator. Prøv igjen senere!"
    }
  },
  "SUBDIVISIONS": {
    "HEADER": "Avdelinger",
    "SUBHEADER": "Her kan du administrere avdelinger i {{companyName}}. Avdelinger hjelper med å organisere brukere for å gjøre det enklere å administrere fakturering for tjenester som møterom og mat.",
    "NO_SUBDIVISIONS": "Ingen avdelinger å vise",
    "SUBDIVISION": "Avdeling",
    "ADD": "Ny avdeling",
    "CREATE": "Opprett avdeling",
    "EDIT_SUBDIVISION": "Rediger avdeling \"{{name}}\"",
    "NAME": "Avdelingsnavn",
    "ASSIGNED_USERS_COUNT": "Brukere i avdeling",
    "NO_ASSIGNED_USERS": "Ingen brukere har blitt tildelt denne avdelingen ennå.",
    "ORG_NUMBER_INFO": "Hvis avdelingen har sitt eget organisasjonsnummer, vil det brukes på fakturaer i stedet for selskapets.",
    "INVOICE_REFERENCES": "Fakturareferanser",
    "INVOICE_REFERENCES_INFO": "Hvis avdelingen har egne fakturareferanser, vil eventuelle fakturareferanser som legges inn ved betaling for tjenester måtte velges fra denne listen.",
    "NEW_INVOICE_REFERENCE": "Ny fakturareferanse",
    "NO_INVOICE_REFERENCES": "Ingen fakturareferanser lagt til ennå...",
    "CHOOSE": "Velg avdeling...",
    "NOTIFICATIONS": {
      "SUBDIVISION_ASSIGNED_SUCCESS": "{{count}} bruker(e) ble lagt til avdeling \"{{name}}\""
    }
  },
  "ADD_COMPANY": {
    "HEADER": "Inviter selskap til {{buildingName}}",
    "COMPANY_SEARCH_BUTTON": "Søk etter selskap",
    "COMPANY_MANUAL_BUTTON": "Fyll ut selskap manuelt",
    "COMPANY_SEARCH": {
      "LABEL": "Selskap",
      "PLACEHOLDER": "Søk etter navn eller org.nummer..."
    },
    "COMPANY_TYPE": {
      "LABEL": "Selskapstype",
      "TENANT": "Leietaker",
      "OWNER": "Eier",
      "SERVICE_PROVIDER": "Tjenesteleverandør",
      "EXTERNAL": "Ekstern",
      "SUPPLIER": "Matleverandør",
      "PLACEHOLDER": "Velg selskapstype"
    },
    "ORG_NUMBER_REQUIRED_FOR_SUPPLIER": "Organisasjonsnummer er påkrevd når selskapstypen er \"Matleverandør\"",
    "ENTRANCES": "Innganger",
    "LOGIN_METHOD": {
      "LABEL": "Velg innloggingsmetode",
      "DESCRIPTION": "<ul><li><blue>SSO (Single Sign-On):</blue> Kun brukere med e-postadresser som samsvarer med domenene du legger til, kan logge inn. Standard og anbefalt for sikkerhet og enkel administrasjon.</li><li><blue>Passordfri e-postinnlogging:</blue> Brukere kan logge inn med en magisk lenke eller en engangskode (OTP), uansett e-postdomene.</li></ul>",
      "LEARN_MORE": "Les mer om de ulike innloggingsalternativene.",
      "EMAIL": "E-post/Engangskode (OTP)"
    },
    "DOMAINS": {
      "HEADER": "Tillatte domener til innlogging med SSO",
      "NO_DOMAINS": "Ingen domener er lagt til enda",
      "DOMAIN": "Domene",
      "PROVIDER": "Leverandør",
      "ADD": "Enda et domene",
      "ALREADY_EXISTS": "Dette domenet er allerede lagt til",
      "REQUIRED": "Du må legge til minst ett domene når innlogginsmetode er satt til \"SSO\"",
      "INVALID": "Ett eller flere domener er ugyldige",
      "GENERIC_DOMAIN": "Må være et firma mail domene"
    },
    "ADMIN": {
      "HEADER": "Selskapsadministrator",
      "BODY": "Dette blir selskapets første bruker og administrator."
    },
    "SUBMIT": "Inviter selskap",
    "SUCCESS": "Selskap ble lagt til",
    "SUCCESS_WITH_GOOGLE_SSO_HELP": "Selskap ble lagt til, merk at det kan ta inntil 24 timer før innlogging med SSO er funksjonelt.",
    "ADMIN_ERROR": "Kunne ikke legge deg til som administrator for selskapet",
    "ADMIN_NOT_INVITED": "Selskapet ble opprettet men administratoren ble ikke invitert.",
    "ORG_NUMBER_ALREADY_EXISTS_IN_BUILDING": "Selskap med dette organisasjonsnummeret eksisterer allerede i bygget.",
    "COMPANY_NAME_ALREADY_EXISTS_IN_BUILDING": "Dette selskapet eksisterer allerede i bygget.",
    "STEPS": {
      "STEP_ONE": "Generell informasjon",
      "STEP_TWO": "Selskapsdetaljer",
      "STEP_THREE": "Selskapsadministrator"
    },
    "ORG_NUMBER_9_DIGITS": "Organisasjonsnummer må være 9 sifre langt.",
    "NO_MATCHES_FOUND": "Ingen treff, prøv å søke med et annet begrep eller gå til neste steg for å opprette selskapet manuelt.",
    "LINK_TO_THIS_COMPANY": "Link til dette selskapet",
    "NO_MATCHES_FOUND_QUESTION": "Ingen treff funnet? Gå til neste steg for å opprette selskapet manuelt.",
    "NAME_MATCHES_FOUND": "Vi fant følgende selskaper i vår database som samsvarer med søkeordet. Hvis selskapet du ønsker å legge til allerede er oppført, vennligst koble det til dette bygget i stedet for å opprette en ny oppføring.",
    "ORG_NUMBER_MATCH_FOUND": "Selskapet med dette organisasjonsnummeret eksisterer allerede i vår database. For å fortsette, vennligst koble det til dette bygget.",
    "GLOBAL_MATCH_OVERRIDE": "Vi fant et selskap med dette organisasjonsnummeret i et annet bygg. Selskapsdetaljene ble oppdatert for å koble samme selskap på tvers av bygg.",
    "BRONNOYSUND_ORG_NUMBER_MATCH_FOUND": "Fant treff i Brønnøysundregistrene. For å fortsette, vennligst koble det til dette bygget.",
    "BRONNOYSUND_NAME_MATCHES_FOUND": "Vi fant følgende selskaper i Brønnøysundregistrene som samsvarer med søkeordet. Hvis selskapet du ønsker å legge til allerede er oppført, vennligst koble det til dette bygget i stedet for å opprette en ny oppføring.",
    "USE_THIS_COMPANY": "Bruk dette selskapet"
  },
  "BUILDING_SETTINGS": {
    "DISPLAY_NAME": "Visningsnavn",
    "DISPLAY_NAME_RECOMMENDATION": "Anbefalt lengde er 16 tegn eller mindre.",
    "LEGAL_NAME": "Juridisk navn",
    "ADDRESS": "Adresse",
    "TEAM_PHOTO": {
      "HEADER": "Gruppebilde av driftsteamet",
      "DESCRIPTION": "Et gruppebilde av alle byggadministratorer involvert i daglig drift i bygget. Bildet vil brukes på \"Dashbord\"-siden for å sette navn og ansikt på de som holder bygningen gående!"
    },
    "OWNER": "Eierselskap",
    "OWNER_LOGO": "Eiers logo",
    "WELCOME_SETTINGS": "Velkomstskjerm",
    "WELCOME_DESCRIPTION": "Disse innstillingene brukes på velkomstskjermen alle brukere ser første gang de logger inn i portalen.",
    "SEE_PREVIEW": "Forhåndsvisning",
    "BACK_TO_EDIT": "Redigering",
    "BANNER": "Bannerbilde",
    "BANNER_INFO": "Bildet bør være minst 2000px bredt og 300px høyt. Det er midtseksjonen av bildet som vil være synlig dersom bildet er større.",
    "MANAGER": {
      "LABEL": "Byggansvarlig",
      "DESCRIPTION": "Dette er personen som er ansvarlig for bygget og som skal ønske alle nye brukere velkommen.",
      "POSITION_NB": "Stillingstittel (Norsk)",
      "POSITION_EN": "Stillingstittel (Engelsk)",
      "PROFILE_IMG": "Profilbilde",
      "PROFILE_IMG_INFO": "Profilbildet bør være kvadratisk og minst 150px X 150px stort."
    },
    "ADMIN_SETTINGS": "Byggadministratorer",
    "ADMIN_NOTIFICATIONS": {
      "HEADER": "Byggadministrator varsler",
      "DESCRIPTION": "Velg hvilke byggadministratorer som skal varsles om {{moduleName}}."
    },
    "ADMIN_AND_RECEPTIONIST_NOTIFICATIONS": {
      "HEADER": "Byggadministratorer og resepsjonisters varsler",
      "DESCRIPTION": "Velg hvilke byggadministratorer og resepsjonister som skal varsles om {{moduleName}}."
    },
    "ADMIN_INFO": "Husk å invitere den aktuelle brukeren inn i et selskap før du legger dem til som administrator.",
    "ADD_ADMIN": "Legg til administrator",
    "ADD_ADMIN_MODAL": {
      "HEADER": "Legg til byggadministrator",
      "BODY": "Søk etter brukerens e-post. Du må skrive inn hele e-post adressen for å finne brukeren. Husk at brukeren allerede må være en del av et selskap for å kunne legges til som byggadministrator.",
      "ADD": "Legg til",
      "NO_RESULTS": {
        "HEADER": "Fant ingen brukere",
        "BODY": "Kontroller at e-posten du skrev inn er korrekt og at brukeren allerede er en del av et selskap."
      },
      "SUCCESS": "{{userName}} ble lagt til som administrator",
      "ALREADY_ADMIN": "{{userName}} er allerede en administrator",
      "ERROR": "Kunne ikke legge til {{userName}} som administrator. Prøv igjen senere!"
    },
    "ADMINS": {
      "REMOVE_AS_ADMIN": "Ta vekk byggadministrator rettigheter",
      "REMOVE_NOT_ALLOWED_WLCM": "Du kan ikke ta vekk Welcome Workdays ansatte som byggadministratorer",
      "REMOVE_NOT_ALLOWED_PM": "Du må sette en ny byggansvarlig før du kan ta vekk byggadministrator rettigheter",
      "REMOVE_SUCCESS": "Brukeren er ikke lenger byggadministrator",
      "REMOVE_ERROR": "Kunne ikke fjerne byggadministrator. Prøv igjen senere!"
    },
    "RECEPTIONISTS": {
      "HEADER": "Byggresepsjonister",
      "DESCRIPTION": "Som byggresepsjonist vil brukeren ha tilgang til Besøks-, Bookings- og Kommunikasjonsmoduler, samt informasjon om selskaper i bygget.",
      "ADD": "Legg til resepsjonist",
      "ADD_BODY": "Søk ved å bruke målbrukerens e-post. Merk at brukeren allerede må tilhøre et selskap før vedkommende kan tildeles som resepsjonist i bygningen. Bygningsadministratorer kan ikke tildeles som resepsjonister.",
      "REMOVE_AS_RECEPTIONIST": "Fjern som resepsjonist",
      "REMOVE_SUCCESS": "Brukeren ble fjernet som resepsjonist",
      "REMOVE_ERROR": "Kunne ikke fjerne brukeren som resepsjonist. Prøv igjen senere.",
      "NO_RECEPTIONISTS": "Ingen resepsjonister å vise",
      "ADMINS_NOT_ALLOWED_TO_BE_RECEPTIONISTS": "Byggadministratorer kan ikke være resepsjonister. Fjern administratorrollen fra brukeren først.",
      "SUCCESS": "{{userName}} ble lagt til som resepsjonist",
      "ALREADY_RECEPTIONIST": "{{userName}} er allerede en resepsjonist",
      "ERROR": "Kunne ikke legge til {{userName}} som resepsjonist. Prøv igjen senere!"
    },
    "VISIT": {
      "PRINT_ISSUE_NOTIFICATIONS": {
        "HEADER": "Varsling ved skriverproblem",
        "DESCRIPTION": "Velg hvem som skal få e-post når en besøkende rapporterer at etiketten ikke ble skrevet ut.",
        "FALLBACK": "Disse brukerne vil bli varslet når et skriverproblem rapporteres. Hvis listen er tom, varsles alle nåværende byggadministratorer.",
        "SUCCESS": "Mottakere for skriverproblem-varsling ble oppdatert.",
        "ERROR": "Kunne ikke oppdatere mottakere for skriverproblem-varsling. Prøv igjen senere."
      },
      "OPENING_HOURS": {
        "HEADER": "Åpningstider",
        "DESCRIPTION": "Angi tidene når midlertidige koder kan genereres. Besøkskoder og koder for glemte kort kan bare opprettes i disse tidsrommene.",
        "OPENS_AT": "Åpner kl",
        "CLOSES_AT": "Stenger kl",
        "SUBMIT_TEXT": "Oppdater åpningstider"
      }
    },
    "CUSTOM_MENU_ITEMS": {
      "HEADER": "Egendefinerte menypunkt",
      "BODY": "Her kan du konfigurere menypunkt som lenker til eksterne tjenester. Du kan legge til opptil {{limit}} menypunkt.",
      "ENTITY": "Menypunkt",
      "ADD": "Legg til menypunkt",
      "EDIT": "Rediger menypunkt ({{label}})",
      "CHECK_URL": "Sjekk URL",
      "PUBLISH": "Publiser",
      "PUBLISH_CHANGES": "Publser endringer",
      "DELETE_MODAL": {
        "HEADER": "Er du sikker?",
        "BODY": "Du er i ferd med å slette menypunktet som lenker til:<linebreak/><link/><linebreak/>Dette er en permanent handling som vil påvirke alle brukere i bygget."
      },
      "TABLE": {
        "NO_ITEMS": "Ingen egendefinerte menypunkt har blitt lagt til ennå!",
        "LABEL": "Tekst",
        "VISIBILITY": {
          "HEADER": "Menyseksjon",
          "USER": "Personlig",
          "COMPANY_ADMIN": "Selskapsadministratorer"
        }
      }
    },
    "BOOKING": {
      "DISABLED": {
        "HEADER": "Welcome Booking er <bold>ikke aktivert</bold> i {{buildingName}}",
        "BODY": "Ta kontakt med oss på <mailto>{{supportEmail}}</mailto> dersom du ønsker å aktivere dette produktet. Les mer på <help>Welcome Booking hjelpesidene</help>."
      },
      "HEADER": "Reservasjon innstillinger",
      "DESCRIPTION": "Disse innstillingene vil påvirke alle reservasjoner som gjøres i bygget. Les mer på <help>Welcome Booking hjelpesidene</help>.",
      "MAX_DAYS_AHEAD": {
        "LABEL": "Maks reservasjonsdato",
        "DESCRIPTION": "Bestemmer hvor langt fram i tid en reservasjon kan gjøres."
      },
      "MAX_DURATION": {
        "LABEL": "Varighet",
        "DESCRIPTION": "Bestemmer hvor lenge hver reservasjon kan vare."
      },
      "MAX_SIMULTANEOUS": {
        "LABEL": "Reservasjoner per person",
        "DESCRIPTION": "Bestemmer hvor mange aktive reservasjoner hver bruker kan ha av gangen."
      },
      "NOTES": {
        "LABEL": "Tillat kommentarer på reservasjoner",
        "DESCRIPTION": "Bestemmer om brukere kan legge til kommentarer på reservasjonene sine. Vi anbefaler å holde funksjonen deaktivert med mindre det er et spesifikt behov for det."
      },
      "ROOMS_SECTION": {
        "HEADER": "Alle reserverbare ressurser",
        "DESCRIPTION": "Her kan du se og redigere alle felles reserverbare ressurser i bygget.",
        "CREATE_MEETING_ROOM": "Legg til ressurs"
      },
      "EDIT_ROOM": {
        "COMBINED_ROOM": {
          "SELECT_ROOMS_TITLE": "Velg rom",
          "SELECT_ROOMS_HEADER": "Velg hvilke rom som skal lenkes sammen",
          "MIN_ROOMS_ERROR": "Du må velge minst 2 rom for å kombinere dem",
          "INFO_TEXT_1": "Det er foreløpig ikke mulig å lenke det samme møterommet til flere kombinerte rom. Du kan heller ikke lenke allerede kombinerte rom sammen.",
          "INFO_TEXT_BOLD": "Nedenfor er alle rommene som fortsatt er mulig å lenke sammen.",
          "ONLY_ONE_ROOM_WARNING": "Det er kun ett rom igjen som er tilgjengelig for sammenkobling. Det er derfor ikke mulig å opprette et nytt kombinert rom.",
          "NO_ROOMS": "Ingen møterom å vise",
          "NO_MORE_ROOMS": "Det er ingen flere rom som kan lenkes sammen.",
          "FETCH_ERROR": "Vi kunne ikke hente møterommene. Prøv igjen senere!",
          "CREATE_INFO": "Kombinerte møterom består av to eller flere andre rom, men fremstår som et eget rom. Når en bruker reserverer et kombinert rom, blir alle under-rommene reservert samtidig."
        },
        "CHANGE_INFO": "Eventuelle endringer vil kun påvirke reservasjoner som gjøres etter at endringene er publisert",
        "THUMBNAIL": "Forsidebilde",
        "MAKE_THUMBNAIL": "Gjør til forsidebilde",
        "REMOVE_IMG": "Fjern bilde",
        "BOOKING_PERMISSION": "Hvem kan reservere dette rommet?",
        "BOOKING_PERMISSION_INFO": "Byggadministratorer kan alltid reservere på vegne av andre uavhengig av innstillingen",
        "HIDE_EVENT_TITLES": "Skjul reservasjonstitler i romkalenderen (anbefalt)",
        "HIDE_EVENT_TITLES_INFO": "Hvis boksen er huket av, vil brukeren kun se tittelen på egne reservasjoner i kalenderen på detaljsiden til rommet. Andre reservasjoner vil vise navnet på selskapet reservasjonen tilhører.",
        "FEATURES_PLACEHOLDER": "Velg fasiliteter...",
        "BUFFER": {
          "TITLE": "Buffertid etter hver reservasjon",
          "INFO": "Blokkerer automatisk tidsrommet etter hver reservasjon. Byggadministratorer kan overstyre buffertiden."
        },
        "PRICING": {
          "TOGGLE": {
            "LABEL": "Prissetting",
            "FREE": "Gratis",
            "HOURLY": "Timepris"
          },
          "HOURLY_RATE": "Timepris",
          "MAX_PRICE_PER_BOOKING": {
            "LABEL": "Makspris",
            "PLACEHOLDER": "Ingen makspris"
          },
          "ENABLE_FIXED_FEE": "Aktiver fast avgift",
          "FIXED_FEE": "Fast avgift",
          "PER_BOOKING": "per reservasjon"
        },
        "MEETING_FOOD": {
          "HEADER": "Møtemat",
          "DESCRIPTION": "En valgfri lenke til system for bestilling av møtemat. Lenken vil vises på detaljsiden for dette rommet og inkluderes i bekreftelses e-post sendt til brukeren når de reserverer rommet.",
          "LABEL": "Møtemat URL"
        },
        "FORMATTED_INFO": "Vil vises som: \"{{formattedValue}}\"",
        "LOCATION": {
          "HEADER": "Beliggenhet",
          "DESCRIPTION": "Dette er en valgfri beskrivelse av hvor rommet ligger. Den vises etter etasjen, for eksempel: \"2. etasje, til høyre for personalkjøkkenet\"."
        },
        "REMINDER_MESSAGE": {
          "HEADER": "Egendefinert reservasjonspåminnelse",
          "DESCRIPTION": "Dette er en valgfri tekst som vil inkluderes i påminnelsen som sendes til brukeren på SMS/e-post 1 time før reservasjonen.",
          "LABEL": "Reservasjonspåminnelse"
        },
        "DESCRIPTION": {
          "HEADER": "Beskrivelse",
          "DESCRIPTION": "Dette er en lengre fritekst beskrivelse av rommet. Den vises på detalj-siden for hvert rom og kan brukes for å gi ekstra informasjon til brukere.",
          "CONTENT_CHANGED": "Den originale beskrivelsen er endret."
        },
        "OPENING_HOURS": {
          "HEADER": "Åpningstider",
          "DESCRIPTION": "Åpningstidene vises på detalj-siden for hvert rom og begrenser når rommet kan reserveres, altså kan rommet ikke reserveres utenom åpningstidene. Du kan også stenge rommet hele dagen eller kun i visse tidsrom per ukedag.",
          "OPENS_AT": "Åpner kl",
          "CLOSES_AT": "Stenger kl",
          "WEEKDAYS": "Åpent på",
          "WEEKDAYS_CLOSED": "Stengt på"
        },
        "EXTERNAL_OPENING_HOURS": {
          "HEADER": "Åpningstider for eksterne selskap",
          "DESCRIPTION": "Gjelder brukere i selskap av typen \"ekstern\", i stedet for åpningstidene over.",
          "ADD": "Egne åpningstider for eksterne selskap",
          "REMOVE": "Fjern egne åpningstider for eksterne selskap"
        },
        "WEEKDAYS": {
          "HEADER": "Innstillinger per ukedag",
          "DISCLAIMER": "Byggadministratorer kan fortsatt gjøre reservasjoner under stengte tidsrom men ikke på helt stengte dager.",
          "CLOSED": "Stengt i tidsrom",
          "FROM": "Fra",
          "TO": "Til",
          "REMOVE": "Fjern stengt tidsrom",
          "COPY": "Kopier til alle dager",
          "ADD": "Stengt tidsrom"
        },
        "VALIDATION": {
          "NAME": "Et annet rom bruker allerede dette navnet",
          "LOCATION": "Beliggenhet kan ikke være tom på kun ett språk",
          "OPENS_AT": "Åpningstid må være før stengetid",
          "CLOSES_AT": "Stengetid må være etter åpningstid",
          "BLOCK_FROM": "Må være minst 30 minutter før sluttid",
          "BLOCK_TO": "Må være minst 30 minutter etter starttid",
          "BLOCK_STEP": "Må være hel eller halv time",
          "WEEKDAYS": "Rommet må være åpent minst én dag i uken",
          "REMINDER_MESSAGE": "Reservasjonspåminnelse kan ikke være tom på kun ett språk"
        }
      }
    },
    "ACCESS_CONTROL": {
      "DISABLED": {
        "HEADER": "Welcome Access er <bold>ikke aktivert</bold> i {{buildingName}}",
        "BODY": "Ta kontakt med oss på <mailto>{{supportEmail}}</mailto> dersom du ønsker å aktivere dette produktet. Les mer på <help>Welcome Access hjelpesidene</help>."
      },
      "ENABLED": {
        "HEADER": "{{buildingName}} er <bold>integrert</bold> med Welcome Access Premium",
        "BODY": "Ingen innstillinger kreves. Les mer på <help>Welcome Access hjelpesidene</help>."
      },
      "HEADER": "Adgangskontroll",
      "DESCRIPTION": "Disse innstillingene påvirker adgangskontrollen til alle selskapene i bygget.",
      "READ_ONLY_BANNER": "Som bygningsadministrator kan du se denne informasjonen. Bare administratorer med rollen Adgangsadministrator kan gjøre endringer i disse innstillingene.",
      "PICKUP_MESSAGE": {
        "LABEL": "Hentemelding for adgangskort",
        "DESCRIPTION": "Her kan du sette en standard hentemelding som brukeren skal motta når adgangskort er klare for å hentes.",
        "MESSAGE_NB": "Hentemelding (Norsk)",
        "MESSAGE_EN": "Hentemelding (Engelsk)"
      },
      "PLACEHOLDER_ALT": "Welcome {{product}} plassholderbilde",
      "PLASTIC_CARD_ORDERING": {
        "HEADER": "Bestilling av plastkort",
        "DESCRIPTION": "Når innstillingen er skrudd på, kan selskapsadministratorer bestille fysiske adgangskort til sine ansatte. Du som byggadministrator må behandle bestillingene manuelt.",
        "TOGGLE": "Aktiver bestilling av plastkort",
        "TOGGLE_ON": "Bestilling av plastkort er aktivert",
        "TOGGLE_OFF": "Bestilling av plastkort er deaktivert"
      }
    },
    "VISIT_MODULE": {
      "DISABLED": {
        "HEADER": "Welcome Visit er <bold>deaktivert</bold> i {{buildingName}}",
        "BODY": "Vennligst kontakt <mailto>{{supportEmail}}</mailto> dersom du ønsker å aktivere dette produktet. Les mer på <help>Welcome Visit hjelpesidene</help>."
      }
    },
    "COMPLIANCE": {
      "DISABLED": {
        "HEADER": "Welcome Compliance er <bold>deaktivert</bold> i {{buildingName}}",
        "BODY": "Vennligst kontakt <mailto>{{supportEmail}}</mailto> hvis du ønsker å aktivere dette produktet."
      },
      "ENABLED": {
        "HEADER": "Compliance innstillinger",
        "BODY": "Disse innstillingene gjelder for alle compliance-sjekker i bygget."
      }
    },
    "FOOD": {
      "DISABLED": {
        "HEADER": "Welcome Food er <bold>deaktivert</bold> i {{buildingName}}",
        "BODY": "Vennligst kontakt <mailto>{{supportEmail}}</mailto> hvis du ønsker å aktivere dette produktet."
      },
      "ENABLED": {
        "HEADER": "Welcome Food er <bold>aktivert</bold> i {{buildingName}}",
        "BODY": "Welcome Food består av 2 under-moduler. Vennligst kontakt <mailto>{{supportEmail}}</mailto> hvis du ønsker å aktivere en eller begge produkter."
      }
    },
    "COMMUNICATION": {
      "DISABLED": {
        "HEADER": "Welcome Communication er <bold>ikke aktivert</bold> i {{buildingName}}",
        "BODY": "Ta kontakt med oss på <mailto>{{supportEmail}}</mailto> dersom du ønsker å aktivere dette produktet. Les mer på <help>Welcome Communication hjelpesidene</help>."
      },
      "ENABLED": {
        "HEADER": "Kommunikasjon innstillinger",
        "BODY": "Disse innstillingene påvirker alle nyhetssaker i bygget. Les mer på <help>Welcome Communication hjelpesidene</help>."
      },
      "CUSTOM_AI_INSTRUCTIONS": {
        "HEADER": "Byggspesifikke KI-instruksjoner",
        "DESCRIPTION": "Disse instruksjonene vil brukes av KI-modellen når den genererer innholdet i nyhetssaker. Du kan for eksempel legge til detaljer om bygget eller ønsket skrivestil og tonefall.",
        "LABEL": "Instruksjoner",
        "INFO": "Instruksjonene kan enten skrives på norsk eller engelsk"
      }
    },
    "ENTRANCES": {
      "HEADER": "Innganger",
      "DESCRIPTION": "Dette er alle inngangene til bygget. Hvert selskap i bygget er knyttet til minst én inngang.",
      "ADD": "Legg til inngang",
      "EDIT": "Rediger inngang ({{name}})",
      "DELETE": "Slett inngang permanent",
      "DOWNLOAD_QR": "Last ned QR-kode for inngangen",
      "REGENERATE_QR": "Generer ny QR-kode for inngangen",
      "NO_DATA": "Ingen innganger å vise",
      "TABLE_HEADERS": {
        "NAME": "Navn",
        "ADDRESS": "Adresse",
        "WELCOME_URL": "URL til besøksregistrering"
      },
      "NAME_NB": "Navn (Norsk)",
      "NAME_EN": "Navn (Engelsk)"
    },
    "ORDER_COMPANIES": {
      "HEADER": "Rekkefølge på selskap",
      "DESCRIPTION": "Dette er alle selskapene som er synlige i besøksregistreringskioskene. Her kan du bestemme rekkefølgen de skal vises i ved å holde- og dra selskap dit du vil. Rekkefølgen forblir den samme for alle innganger i bygget.",
      "PRO_TIP": "Visste du at du kan trykke 10 ganger raskt hvor som helst på \"hjem\"-siden til besøksregistreringskiosken for å avdekke en skjult \"omstart\"-knapp? Prøv det for å se den nye rekkefølgen ta effekt umiddelbart! Ellers vil endringen ta effekt automatisk i løpet av et par timer.",
      "NOTIFICATIONS": {
        "SUCCESS": "Rekkefølgen på selskapene ble endret!",
        "ERROR": "Kunne ikke endre rekkefølgen på selskapene. Prøv igjen senere!"
      }
    },
    "NOTIFICATIONS": {
      "ON": "Skru AV varsler",
      "OFF": "Skru PÅ varsler",
      "DESCRIPTION": "Disse brukerne vil bli varslet på e-post ved bestilling og kansellering av adgangskort. Hvis ingen bruker er valgt, vil alle byggsadministratorer bli varslet.",
      "SUCCESS": "Varslingspreferansen er lagret",
      "ERROR": "Det oppsto en feil under lagring av varslingspreferansen"
    },
    "OPS_TEAM": {
      "ADD": "Legg til bruker i driftsteamet",
      "REMOVE": "Fjern bruker fra driftsteamet",
      "DESCRIPTION": "Disse brukerne er del av driftsteamet, ansvarlig for daglig drift i bygget. Hvis ingen brukere er valgt, vil alle byggadministratorer bli ansett som del av driftsteamet.",
      "SUCCESS": "Driftsteamet ble oppdatert",
      "ERROR": "Kunne ikke oppdatere driftsteamet. Prøv igjen senere!"
    },
    "BOOKING_NOTIFICATIONS": "Disse brukerne vil bli varslet når et møterom bestilles i bygningen. Hvis ingen brukere er valgt, vil ingen administrator bli varslet.",
    "ROLE_ASSIGNMENT_NOT_ALLOWED_FALLBACK_MESSAGE": "Du kan ikke tildele denne rollen til brukeren."
  },
  "COMMUNICATION": {
    "HEADER": "Administrer nyheter",
    "SUBHEADER": "Her kan du se, opprette og administrere nyhetssaker i {{buildingName}}.",
    "CATEGORY": "Kategori",
    "PUBLISHED_AT": "Publisert",
    "UPDATED_AT": "Oppdatert",
    "ARCHIVED_AT": "Arkivert",
    "AUTHOR": "Forfatter",
    "TITLE": "Tittel",
    "READ_BY": "Lest av",
    "STATUS": "Status",
    "NEW_ARTICLE": "Ny artikkel",
    "MORE_NEWS": "Se flere nyheter",
    "OPERATIONAL": "Driftsmelding",
    "NEWS": "Nyhet",
    "PUBLISH": "Publiser",
    "UNPUBLISH": "Avpubliser",
    "NEW_NOTIFICATION": "Ny epost varsling",
    "SEND_NOTIFICATION": "Send varsling",
    "NOTIFICATION_METHODS": {
      "EMAIL": "E-post",
      "SMS": "SMS",
      "EMAIL_AND_SMS": "E-post og SMS"
    },
    "STATUSES": {
      "draft": "Utkast",
      "planned": "Planlagt",
      "published": "Publisert",
      "archived": "Arkivert"
    },
    "READ_STATS": "Nyheten er lest av <strong><colored>{{value}}</colored> / {{total}}</strong> <grey>({{percentage}}%)</grey> mottakere",
    "READ_STATS_PER_COMPANY": "Se leserstatistikk per selskap",
    "RECIPIENTS_STATS": "Nyheten {{tense}} publisert til <strong><colored>{{value}}</colored> / {{total}}</strong> <grey>({{percentage}}%)</grey> personer i bygget",
    "NOTIFICATION_STATS": "<strong><colored>{{value}}</colored> / {{total}}</strong> <grey>({{percentage}}%)</grey> av mottakerne vil bli varslet",
    "COMPANY_ADMINS": "Selskapsadministratorer",
    "REGULAR_USERS": "Brukere",
    "NON_RECIPIENTS": "Utenfor mottakerliste",
    "CANNOT_BE_NOTIFIED": "Kan ikke varsles",
    "HIDDEN_FOR_USERS_INFO": "Welcome Communication er kun skrudd på for byggadministratorer. Denne siden er derfor for øyeblikket uilgjengelig for andre brukergrupper.",
    "HIDDEN_FOR_USERS_NOTIFICATION_INFO": "Siden Welcome Communication kun er skrudd på for byggadministratorer, vil andre brukergrupper bli eksludert fra varslinger om denne saken."
  },
  "ARTICLE": {
    "REACH_LOADING": "Beregner mottakere…",
    "REACH_ERROR": "Kunne ikke beregne mottakere.",
    "REACH_RETRY": "Prøv igjen",
    "NO_RECIPIENTS": "Ingen mottakere kan varsles med gjeldende utvalg.",
    "NO_NOTIFICATIONS_YET": "Ingen brukere har blitt varslet enda.",
    "CREATE_NOTIFICATION_HERE": "Her kan du varsle mottakerene på e-post!",
    "STILL_A_DRAFT": "Artikkelen er fortsatt kun et utkast.",
    "REMEMBER_TO_PUBLISH": "Husk å publisere artikkelen når den er klar!",
    "CONTENT": "Innhold",
    "CONTENT_LONG": "Artikkelinnhold",
    "CONTENT_CHANGED": "Det originale innholdet har endret seg.",
    "RECIPIENTS": "Mottakere",
    "RECIPIENTS_WERE_NOTIFIED": "Mottakere ble varslet",
    "COULD_NOT_BE_NOTIFIED": "{{count}} brukere ble ikke varslet da de ikke har samtykket til å bli varslet. De kan fortsatt se artikkelen, men har ikke blitt varslet om den.",
    "CANNOT_BE_NOTIFIED": "{{count}} brukere kan ikke varsles fordi de ikke har gitt samtykke til kommunikasjon som ikke er driftskritisk.",
    "NOTIFICATIONS": "Epost varslinger",
    "OVERVIEW": "Se over og lagre",
    "BANNER_IMAGE": "Bannerbilde",
    "AUTHOR": "Forfatter",
    "PLANNED_PUBLISH": {
      "LABEL": "Publiseringstid",
      "UNKNOWN": "Ikke satt",
      "SCHEDULED": "Planlagt",
      "INFO": "Planlegg når saken skal publiseres. La stå tom for å publisere umiddelbart når du trykker Publiser."
    },
    "PLANNED_ARCHIVATION": {
      "LABEL": "Avpubliseringstid",
      "INFO": "Planlegg når saken blir avpublisert (arkivert). La stå tom for å holde nyheten synlig til du arkiverer den manuelt."
    },
    "TITLE": "Tittel",
    "ATTACHMENTS": "Vedlegg",
    "ALL_COMPANIES": "Alle selskap i bygget",
    "HAS_NOTIFICATIONS": "Siden det allerede er sendt ut varsler for denne nyheten, kan du ikke redigere mottakerinnstillingene.",
    "DISREGARD_CONSENT": "Nyheten inneholder kun driftskritisk informasjon",
    "DISREGARD_CONSENT_INFO": "Driftskritiske meldinger er informasjon som er essensiell for sikkerheten, funksjonaliteten og den grunnleggende driften av bygget eller brukernes tilgang til nødvendige fasiliteter og tjenester.",
    "DISREGARD_CONSENT_AFTER_CONTENT_CHANGED": "Husk å huke av på nytt dersom nyheten fortsatt kun inneholder driftskritisk informasjon.",
    "SEARCH_PLACEHOLDER": "Søk etter forfatter eller tittel",
    "ACTIONS": {
      "ARCHIVE": "Arkiver nyhet",
      "EDIT": "Rediger nyhet",
      "DUPLICATE": "Dupliser nyhet",
      "REPUBLISH": "Republiser",
      "CANCEL_PUBLISH": "Kanseller publisering",
      "PUBLISH_NOW": "Publiser nå",
      "PUBLISH_CHANGES": "Publiser endringer",
      "DELETE_DRAFT": "Slett utkast",
      "PIN": "Fest nyhet til toppen",
      "UNPIN": "Løsne nyhet fra toppen",
      "ATTACH_FILE": "Legg til vedlegg"
    },
    "IS_PINNED": "Denne artikkelen er festet til toppen",
    "ARCHIVED_INFO": "Denne nyheten er arkivert og er derfor ikke lenger tilgjengelig for brukere i portalen.",
    "REPUBLISH_INFO": "Dersom du republiserer nyheten <bold>\"{{articleTitle}}\"</bold> vil den igjen bli synlig for <bold>{{articleReach}}</bold> mottakere. Vi vil ikke sende ut en ny varsling.",
    "PUBLISH_NOW_INFO": "Dersom du publiserer blir nyheten <bold>\"{{articleTitle}}\"</bold> umiddelbart synlig for <bold>{{articleReach}}</bold> mottakere.",
    "NOTIFICATION_MESSAGES": {
      "ARCHIVATION_SUCCESS": "Nyheten ble arkivert! Den er nå skjult for alle brukere.",
      "ARCHIVATION_ERROR": "Kunne ikke arkivere nyhet. Prøv igjen senere!",
      "CANCEL_PUBLISH_SUCCESS": "Planlagt publisering av artikkelen er avbrutt! Den vil ikke bli automatisk publisert.",
      "CANCEL_PUBLISH_ERROR": "Kunne ikke avbryte planlagt publisering av artikkelen. Prøv igjen senere!",
      "PUBLISH_SUCCESS": "Artikkelen ble publisert! Den er nå synlig i portalen for alle mottakere.",
      "PUBLISH_ERROR": "Kunne ikke publisere artikkelen. Prøv igjen senere!",
      "SAVE_DRAFT_SUCCESS": "Utkastet ble lagret! Den er kun synlig for deg og andre byggadministratorer.",
      "SAVE_DRAFT_ERROR": "Kunne ikke lagre utkast. Prøv igjen senere!",
      "SAVE_CHANGES_SUCCESS": "Endringene ble lagret! Det oppdaterte innholdet er nå synlig for alle mottakere.",
      "SAVE_CHANGES_ERROR": "Kunne ikke lagre endringene. Prøv igjen senere!",
      "PIN_SUCCESS": "Nyheten ble festet til toppen! Endringen er nå synlig for alle mottakere.",
      "PIN_ERROR": "Kunne ikke feste nyheten til toppen. Prøv igjen senere!",
      "UNPIN_SUCCESS": "Nyheten ble løsnet fra toppen! Endringen er nå synlig for alle mottakere.",
      "UNPIN_ERROR": "Kunne ikke løsne nyheten fra toppen. Prøv igjen senere!",
      "PARTIAL_ATTACHMENT_SUCCESS": "{{count}} vedlegg ble ikke lastet opp. Prøv igjen senere!",
      "ATTACHMENT_OPEN_FAILED": "Kunne ikke åpne/laste ned vedlegget. Prøv igjen senere!",
      "RAW_ATTACHMENT": "Vedlegget er ikke behandlet enda og kan derfor ikke åpnes eller lastes ned."
    },
    "RECIPIENT_COMPANIES": "Mottakerselskap",
    "ALL_RECIPIENT_COMPANIES": "Alle mottakerselskap",
    "SINGLE_RECIPIENT_INFO": "Siden artikkelen kun er publisert til ett selskap kan du ikke endre denne innstillingen.",
    "RECIPIENT_GROUP": "Mottakergruppe",
    "RECIPIENT_GROUPS": {
      "ALL_USERS": "Alle brukere",
      "ONLY_COMPANY_ADMINS": "Kun selskapsadministratorer"
    },
    "NOTIFICATION_INFO": "Varsling er valgfritt. Velger du \"Ingen varsling\" nå kan du likevel sende ut varslinger på et senere tidspunkt.",
    "NOTIFICATION_METHOD": "Varsle mottakere",
    "NOTIFICATION_METHODS": {
      "NO_NOTIFICATION": "Ingen varsling",
      "EMAIL": "På e-post",
      "SMS": "På SMS",
      "EMAIL_AND_SMS": "Både e-post og SMS"
    },
    "NOTIFICATION_COMPANIES": "Send epost varsel til",
    "NOTIFICATION_GROUP": "Brukergruppe",
    "NOTIFICATION_GROUPS": {
      "ALL_USERS": "Alle brukere",
      "ONLY_ADMINS": "Kun selskapsadministratorer"
    },
    "NO_NOTIFICATIONS_PLACEHOLDER": "Ingen varslinger enda...",
    "PREVIEW": {
      "LANGUAGE": {
        "NO": "No",
        "EN": "En"
      },
      "MOBILE": "Mobil",
      "DESKTOP": "Desktop",
      "SUBMIT": "Publiser artikkel",
      "SAVE_DRAFT": "Lagre utkast og lukk"
    },
    "GENERATE_CONTENT": {
      "TRY_AI_TOOLS": "Der du ser <icon/> ikonet kan du prøve å bruke våre KI verktøy til tekst- og bildegenerering",
      "TRY_WRITING_WITH_AI": "Prøv å skrive nyhetssaken med kunstig intelligens (KI)",
      "GENERATE_WITH_AI": "Skriv med KI",
      "MODAL": {
        "HEADER": "Generer artikkelinnhold med KI",
        "DESCRIPTION": "Her kan du generere artikkelinnholdet ved hjelp av kunstig intelligens (KI).",
        "DISCLAIMER": "KI kan gjøre feil. Husk å kvalitetssikre innholdet før du publiserer det.",
        "OVERRIDE_WARNING": "Du har allerede fylt ut noen felt som vil bli overskrevet ved generering.",
        "PROMPT": {
          "LABEL": "Hva skal nyheten handle om?",
          "PLACEHOLDER": "Beskriv kort hva nyheten skal handle om"
        },
        "SUBMIT": "Generer",
        "TEMPLATES": {
          "LABEL": "Start med en mal:",
          "OPERATIONS": {
            "LABEL": "Driftsmelding",
            "PROMPT": "Driftsmelding:\nHva skjer: \nNår: \nHvordan påvirker det leietakerne: \nHva bør de gjøre: "
          },
          "EVENT": {
            "LABEL": "Arrangement",
            "PROMPT": "Arrangement:\nHva: \nNår: \nHvor: \nHvem kan delta: \nPåmelding: "
          },
          "NEWS": {
            "LABEL": "Nyhet",
            "PROMPT": "Nyhet:\nHva er nytt: \nHvorfor er dette relevant for de som jobber i bygget: "
          },
          "HSE": {
            "LABEL": "HMS",
            "PROMPT": "HMS-melding:\nHva gjelder det: \nHva må ansatte gjøre: \nHvem kan de kontakte ved spørsmål: "
          }
        },
        "PROGRESS": {
          "WRITING": "Skriver artikkel...",
          "TRANSLATING": "Oversetter...",
          "ALMOST_DONE": "Snart ferdig..."
        }
      },
      "NOTIFICATIONS": {
        "PARTIAL": "Deler av innholdet kunne ikke genereres. Husk å fylle ut feltene det gjelder manuelt."
      }
    }
  },
  "CONTEXT": {
    "BUILDING": "Bygning",
    "COMPANY": "Selskapskontekst",
    "SWITCH": "Bytt selskap",
    "SWITCH_BUILDING": "Bytt bygning",
    "OPEN_COMPANY_WORKSPACE": "Åpne selskapets arbeidsområde"
  },
  "ERROR_BOUNDARY": {
    "HEADER": "Oops! Her gikk noe galt.",
    "BODY": "En feil har oppstått. Ta kontakt med din administrator for å rapportere feilen.",
    "MESSAGE": "Feilmelding",
    "RELOAD": "Last inn siden på nytt"
  },
  "BUILDING_VISITORS": {
    "TIME": "Tid",
    "VISITOR": "Besøkende",
    "VISITORS": "Besøkende",
    "PRE_REG": "Forhåndsregistrerte",
    "HOST": "Vert",
    "THE_RECEPTION": "Resepsjonen",
    "HOST_COMPANY": "Vertsselskap",
    "LOCATION": "Lokasjon",
    "NO_VISITORS": "Ingen besøkende å vise",
    "SEARCH_PLACEHOLDER": "Søk etter besøkende",
    "LET_IN": "Slipp inn",
    "HOST_REPLIED": "Vert svarte",
    "ACCESS_GRANTED": "Adgang gitt kl {{timestamp}}",
    "ACCESS_CODE_SENT": "Sendte adgangskoden til den besøkende",
    "COMMENTS_OR_MESSAGES": "Den besøkende har kommentarer eller meldinger",
    "ATTENDEE_ARRIVED": "Forhåndsregistrert deltaker har ankommet",
    "CHECK_IN": "Sjekk inn",
    "ACTIONS": "Handlinger",
    "CHECKED_IN_AT": "Sjekket inn kl {{timestamp}}",
    "NO_ATTENDEES": "Ingen forhåndsregistrerte deltakere å vise",
    "PREREG_SEARCH_PLACEHOLDER": "Søk etter deltaker",
    "SEND_SMS_PLACEHOLDER": "Ta heisen til 3. etasje",
    "CHECK_IN_SUCCESS": "Besøkende ble sjekket inn"
  },
  "401": {
    "HEADER": "Du har ikke adgang til den siden",
    "BODY": "Hvis du mener dette er en feil, ta kontakt med din administrator."
  },
  "404": {
    "HEADER": "Den siden finnes ikke",
    "BODY": "Vennligst sjekk at du har skrevet inn riktig URL og kontakt din administrator om du mener at dette er en feil."
  },
  "PREREGISTRATION": {
    "HEADER": "Ny forhåndsregistrering",
    "DESCRIPTION": "Her registrerer du en gruppe besøkende for fremtidig dato. Alle deltakere vil motta en SMS med instruksjoner om arrangementet.",
    "EVENT_NAME": "Arrangementets navn",
    "EVENT_DESCRIPTION": "Instruksjoner rundt arrangementet",
    "DATE": "Dato",
    "START_DATE": "Dato",
    "START_TIME": "Klokkeslett",
    "ATTENDEE_LANGUAGE": "Deltaker språk",
    "NOTIFY_ON": {
      "HOST": "Varsle verten ved",
      "MYSELF": "Jeg ønsker å bli varslet ved",
      "CHOICE": "Du vil bli varslet ved",
      "FIRST_AND_LAST_ARRIVAL": "Første og siste ankomst",
      "EVERY_ARRIVAL": "Hver ankomst"
    },
    "ADD_ATTENDEES": "Legg til deltakere",
    "ADD_ANOTHER": "Legg til deltaker",
    "DELETE_ATTENDEE": "Slett deltaker",
    "NO_ATTENDEES": "Ingen deltakere lagt til ennå",
    "NOTIFICATION_INFO": {
      "TODAY": "Siden arrangementet starter i dag, vil alle deltakere med telefonnummer bli varslet på SMS umiddelbart ved invitasjon.",
      "FUTURE": "Alle deltakere med telefonnummer vil bli varslet på SMS kl. 07:00 samme dag som arrangementet.",
      "FUTURE_BEFORE_7AM": "Alle deltakere med telefonnummer vil bli varslet på SMS 30 minutter før arrangementet starter."
    },
    "INVITE": "Inviter {{number}} deltakere",
    "ADD_HOST": "Søk etter verten med e-postadresse.",
    "NO_RESULTS_COMPANY": "Sjekk at e-posten er korrekt og at brukeren er en del av selskapet",
    "NO_RESULTS_BUILDING": "Sjekk at e-posten er korrekt og at brukeren finnes i denne bygningen",
    "HOST": "Vert",
    "HOST_EMAIL": "Vertens e-post",
    "DELETE_HOST": "Slett vert",
    "EVENT_DESCRIPTION_INFO": "Her kan du oppgi ytterligere informasjon om arrangementet. Instruksjonene vil bli inkludert i SMS-varslingen til deltakerne.",
    "EVENT_DESCRIPTION_PLACEHOLDER": "Arrangementet avholdes i 3. etasje...",
    "PREREGISTRATION_SUCCESS": "Vellykket opprettet arrangement og inviterte deltakere",
    "ATTENDEES": "Deltakere",
    "SEE_ATTENDEES": "Se deltakere",
    "ENTRANCE": "Inngang",
    "SEARCH_ATTENDEES": "Søk etter deltakere",
    "NO_SEARCH_RESULTS": "Ingen deltakere funnet",
    "NO_PREREGRISTRATIONS": "{{entity}} har ingen kommende gruppeforhåndsregistreringer",
    "CANCEL": {
      "HEADER": "Kanseller \"{{ eventName }}\"",
      "BODY": "Er du sikker på at du vil kansellere denne forhåndsregistrerte gruppen? Alle deltakere som har mottatt invitasjonen på SMS vil også bli varslet om kansellasjonen. Ellers sendes ingen varsling ut til deltakerne. Dersom du kansellerer minst 24 timer i forveien er det garantert at ingen deltakere har mottatt invitasjonen på SMS enda.",
      "CONFIRM": "Kanseller",
      "DISMISS": "Behold",
      "SUCCESS": "\"{{ eventName }}\" ble kansellert. Husk å kommunisere kansellasjonen til alle deltakerne.",
      "ERROR": "Kunne ikke kansellere \"{{ eventName }}\". Prøv igjen senere og gi beskjed til deltakerne manuelt."
    },
    "EDIT_PREREG": "Rediger forhåndsregistrering",
    "EDIT_SUBMIT": "Oppdater forhåndsregistrering",
    "EDIT_PREREG_SUCCESS": "Forhåndsregistreringen ble oppdatert",
    "EDIT_PREREG_ERROR": "Kunne ikke oppdatere forhåndsregistreringen. Prøv igjen senere!",
    "UNRECOGNIZED_COUNTRY_CODE": "Vi kan ikke alltid nå utenlandske nummere. Kommuniser med deltakeren på egenhånd.",
    "ARE_YOU_SURE": "Er du sikker på at du vil fortsette uten telefonnumre?",
    "ARE_YOU_SURE_DESCRIPTION": "Noen deltakere mangler telefonnummer, så vi kan ikke varsle dem eller gi en forenklet registrering i bygget.",
    "BULK_UPLOAD_ATTENDEES": "Last opp deltakere",
    "BULK_UPLOAD_HEADER": "Last opp deltakere",
    "BULK_UPLOAD_DESCRIPTION": "Her kan du importere deltakere til arrangementet ditt. Dette er dataene vi forventer:",
    "ERROR_SENDING_ACCESS_CODE": "Noen av deltakerne mottok ikke adgangskoden.",
    "ASSUME_LENGTH_INFO": "For å visualisere forhåndsregistrerte arrangement antar systemet en varighet på 2 timer. Dette reflekterer derimot ikke arrangementenes faktiske varighet."
  },
  "VISIT_DETAILS": {
    "VISIT_DETAILS": "Besøksdetaljer",
    "EVENT_NAME": "Arrangementets navn",
    "EVENT_DESCRIPTION": "Arrangementets beskrivelse",
    "VISITOR_DETAILS": "Besøkende",
    "HOST_DETAILS": "Verten",
    "MESSAGE_TO_HOST": "Melding til vert",
    "START_TIME": "Starttid",
    "SMS_FROM_HOST": "SMS fra",
    "COMMENT_FROM": "Kommentar fra",
    "ACCESS_GRANTED": "Tilgang gitt",
    "VISIT_REQUEST": "Registrert besøk",
    "CHECKED_IN": "Sjekket inn av {{name}}",
    "SELF_CHECK_IN": "Selvinnsjekking"
  },
  "EMPLOYEE_ID": "Ansatt ID",
  "SIGN_IN_ERROR": {
    "HEADER": "Påloggingslenke utløpt eller ugyldig",
    "BODY": "Økten din har utløpt eller lenken er ikke lenger gyldig. Vennligst prøv å logge inn på nytt.",
    "ALIAS_HEADER": "Påloggingen returnerte en annen e-postadresse",
    "ALIAS_BODY": "Organisasjonens pålogging returnerte en annen e-postadresse enn den du oppga, så vi fant ingen konto som matchet. Dette betyr som regel at kontoen din bruker et e-postalias. Be IT-administratoren din om å registrere adressen organisasjonen logger deg inn med.",
    "ALIAS_OTP_BUTTON": "Send en innloggingskode i stedet?"
  },
  "BADGE_PRINTING": {
    "TEMPLATES": {
      "HEADER": "Plastkortmaler",
      "DESCRIPTION": "Her kan du administrere malene som brukes for å skrive ut plastkort. Du kan legge til, redigere og slette maler.",
      "NEW_TEMPLATE": "Ny mal",
      "NEW_TEMPLATE_DESCRIPTION": "Last opp en ny HTML-mal for utskrift av plastkort. Du kan legge til variabler i malen som vil bli erstattet med de faktiske verdiene ved utskrift. Du kan eventuelt laste opp et CSS-stilark og en bakgrunn som skal brukes i malen.",
      "TEMPLATE": "Mal",
      "TEST_TEMPLATE": "Test malvariabler",
      "ENTER_PLACEHOLDER": "Skriv inn {{variable}}",
      "ASSIGN_COMPANIES_REQUIRED": "Du må tildele minst ett selskap til malen"
    },
    "TEMPLATE_FORM": {
      "NAME": "Malnavn",
      "NAME_PLACEHOLDER": "Min mal",
      "ASSIGNED_TO_COMPANIES": "Tildelt selskaper",
      "ASSIGNED_TO_COMPANIES_PLACEHOLDER": "Velg selskaper",
      "ALL_COMPANIES": "Alle selskaper (inkluderer fremtidige selskaper som legges til bygget)",
      "FRONT_HTML": "Forside (HTML-mal)",
      "BACK_HTML": "Bakside (HTML-mal)",
      "HTML": "Legg til HTML-mal",
      "HTML_PLACEHOLDER": "Last opp HTML-mal",
      "BACKGROUND_IMAGE_FRONT": "Bakgrunnsbilde på forsiden",
      "BACKGROUND_IMAGE_BACK": "Bakgrunnsbilde på baksiden",
      "CSS": "CSS-stilark",
      "ADD_CSS": "Legg til CSS-stilark",
      "CSS_PLACEHOLDER": "Last opp CSS-stilark",
      "ADD_IMAGE": "Legg til bilde",
      "HTML_INFO_TITLE": "Bruk av variabler i malen din",
      "HTML_INFO_NAME": "Bruk {{userFirstName}} og {{userLastName}} eller {{userFullName}} for å vise brukerens navn.",
      "HTML_INFO_EMPLOYEE_ID": "Bruk {{employeeId}} for å vise brukerens ansatt-ID.",
      "HTML_INFO_JOB_TITLE": "Bruk {{jobTitle}} for å vise brukerens stillingstittel (Valgfritt - vil være tomt hvis ikke oppgitt).",
      "HTML_INFO_PROFILE_PHOTO": "Bruk {{profilePhoto}} for å vise brukerens profilbilde.",
      "HTML_INFO_BACKGROUND_IMAGES": "Bruk {{backgroundImageFront}} og {{backgroundImageBack}} for å vise bakgrunnsbilder for forside og bakside.",
      "HTML_INFO_COMPANY": "Bruk {{companyName}} for å vise firmanavn og {{companyLogo}} for firmalogo.",
      "HTML_INFO_NOTE": "Disse variablene er valgfrie, men hvis du vil vise bruker- eller selskapsinformasjon i malen, må de være med.",
      "PREVIEW": "Forhåndsvis mal",
      "SAVE": "Lagre mal",
      "TEMPLATE_PREVIEW": "Forhåndsvisning av mal",
      "SUCCESS": "Mal opprettet",
      "ERROR": "Kunne ikke opprette mal. Prøv igjen senere!",
      "UPDATED_SUCCESSFULLY": "Mal oppdatert",
      "UPDATE_FAILED": "Kunne ikke oppdatere mal. Prøv igjen senere!"
    },
    "TABLE": {
      "ALL_COMPANIES": "Alle selskaper",
      "SIDES": "Sider",
      "FRONT_AND_BACK": "Foran og bak",
      "FRONT_ONLY": "Kun foran",
      "MORE_COMPANIES": "selskaper til",
      "DOWNLOAD": "Last ned mal",
      "DELETE": "Slett mal",
      "NO_DATA": "Ingen maler tilgjengelig. Vennligst kontakt Welcome Workdays for å opprette en mal.",
      "FAILED_FETCH_ASSETS": "Kunne ikke hente malressurser. Prøv igjen senere!",
      "FAILED_DELETE_TEMPLATE": "Kunne ikke slette mal. Prøv igjen senere!",
      "FAILED_DOWNLOAD_TEMPLATE": "Kunne ikke laste ned mal. Prøv igjen senere!",
      "CREATED_AT": "Opprettet",
      "CREATED_BY": "Opprettet av"
    },
    "PRINT": {
      "NO_TEMPLATES": "{{companyName}} har ingen maler tilgjengelig for utskrift av plastkort. Vennligst ta kontakt med Welcome Workdays for å lage en mal først.",
      "NO_TEMPLATES_MULTI_COMPANY": "Det finnes ingen maler som er tilgjengelige for alle selskapene. Vennligst skriv ut kortene individuelt eller tildel en mal til alle selskapene i bygget.",
      "SELECT_TEMPLATE": "Velg en mal",
      "FRONT": "Forside",
      "BACK": "Bakside",
      "PRINT_CARD_one": "Skriv ut kort",
      "PRINT_CARD_other": "Skriv ut {{count}} kort",
      "MISSING_GENERIC": "{{entity}} mangler {{variable}}, som er nødvendig i denne malen. Legg til {{variable}} før du skriver ut kortet.",
      "USER": "Brukeren",
      "COMPANY": "Selskapet",
      "PROFILE_PHOTO": "profilbilde",
      "LOGO": "logo",
      "EMPLOYEE_ID": "ansatt-ID",
      "PRINT_MULTIPLE": "Skriv ut kort for valgte brukere",
      "PREVIOUS": "Forrige",
      "NEXT": "Neste",
      "MISSING_MULTIPLE_USERS": "{{count}} av {{total}} brukere mangler informasjon som kreves i denne malen:",
      "AND": "og",
      "MISSING_USER_VARIABLES": "<to>{{fullName}}</to> mangler {{variables}}.",
      "PARTIAL_WARNING": "Ikke alle brukere har den nødvendige informasjonen. Bare {{validCount}} av {{totalCount}} kort vil bli skrevet ut.",
      "MULTIPLE_USERS_DESCRIPTION": "Valgte {{count}} brukere for kortutskrift.",
      "REMOVE_FROM_PRINT_QUEUE": "Fjern {{fullName}} fra utskriftskøen.",
      "CARD_POSITION": "Kort {{current}} av {{total}}",
      "MISSING_REQUIRED_INFO": "Mangler nødvendig informasjon"
    }
  },
  "NOTIFICATIONS": {
    "DOCUMENT_CREATED": "Ny {{entity}} ble opprettet",
    "DOCUMENT_UPDATED": "Endringene gjort på {{entity}} ble lagret",
    "SUBDIVISION_LINKED_TO_MUNU": "Avdelingen er koblet til restaurantsystemet.",
    "LINK_FAILED": "Kunne ikke koble til. Prøv igjen.",
    "FILE_UPLOAD_SUCCESS": "Filen ble lastet opp",
    "DOCUMENT_DELETED": "{{entity}} ble slettet",
    "ACCESS_GRANTED": "Adgang er gitt",
    "BOOKING_SUCCESS": "Ny reservasjon av {{entity}} ble opprettet",
    "CANCELLATION_SUCCESS": "{{entity}} ble kansellert",
    "CREATE_FAILED": "Kunne ikke opprette {{entity}}. Prøv igjen senere!",
    "UPDATE_FAILED": "Kunne ikke oppdatere {{entity}}. Prøv igjen senere!",
    "MISSING_OR_INVALID_PARAMS": "Feil eller mangler i data. Hvis problemet vedvarer, ta kontakt med din administrator.",
    "SERVER_ERROR": "En ukjent feil har oppstått. Prøv igjen senere!",
    "DELETE_FAILED": "Kunne ikke slette {{entity}}. Prøv igjen senere!",
    "UPLOAD_IMAGE_FAILED": "Bildeopplasting feilet",
    "IMAGE_PROCESSING_FAILED": "Kunne ikke behandle bilde(r). Prøv å laste opp et annet format!",
    "MAX_FILES_EXCEEDED": "Du kan kun laste opp {{count}} filer",
    "INVALID_FILE_TYPE": "Den filtypen er ikke tillatt",
    "INVALID_IMAGE": "Bildeopplasting feilet på grunn av ugyldig bildedata",
    "INVALID_IMAGE_FORMAT": "Bildeopplasting feilet på grunn av ugyldig bildeformat",
    "IMAGE_TOO_BIG": "Bildet du forsøkte å laste opp er for stort",
    "WITH_FILES": "{{message}}: {{files}}",
    "INVALID_FILE_PATH": "Kunne ikke hente fil grunnet feil i filnavn. Hvis problemet vedvarer, ta kontakt med din administrator.",
    "FILE_NOT_FOUND": "Filen som ble etterspurt finnes ikke. Hvis problemet vedvarer, ta kontakt med din administrator.",
    "FILE_TOO_BIG": "Filen du forsøkte å laste opp er for stor",
    "UPLOAD_FILE_FAILED": "Filopplasting feilet",
    "SMS_FAILED": "Kunne ikke sende SMS. Prøv igjen senere!",
    "COMMENT_FAILED": "Kunne ikke legge til kommentar. Prøv igjen senere!",
    "ACCESS_FAILED": "Kunne ikke gi adgang. Prøv igjen senere!",
    "BOOKING_FAILED": "Kunne ikke reservere {{entity}}. Prøv igjen senere!",
    "CANCELLATION_FAILED": "Kunne ikke kansellere {{entity}}. Prøv igjen senere!",
    "EMAIL_ALREADY_IN_USE": "E-posten er allerede i bruk, vennligst velg en annen e-postadresse",
    "INVALID_EMAIL_FORMAT": "Ugyldig e-postformat. Vennligst sjekk og prøv igjen.",
    "UNAUTHORIZED_MISSING_USER_ID": "Forbudt: bruker ID mangler",
    "UNAUTHORIZED_MISSING_USER_OR_COMPANY_ID": "Forbudt: bruker- eller selskaps ID mangler",
    "UNAUTHORIZED_USER_NOT_FOUND": "Kunne ikke autentisere brukeren. Prøv å logge ut og inn igjen!",
    "UNAUTHORIZED_BUILDING_NOT_FOUND": "Kunne ikke autentisere din tilgang til bygget. Prøv å logge ut og inn igjen!",
    "FORBIDDEN_INSUFFICIENT_PERMISSIONS": "Du har ikke tillatelse til å utføre denne handlingen. Ta kontakt med din administrator om du mener dette er en feil.",
    "INTEGRATION_FAILED": "Kunne ikke integrere med adgangskontrollsystemet. Prøv igjen senere!",
    "INTEGRATION_SUCCESS": "Integrert {{entity}} med adgangskontrollsystemet",
    "INTEGRATION_PARTIAL_FAILURE": "{{entity}} ble ikke integrert med adgangskontrollsystemet. Prøv igjen senere!",
    "NEW_VERSION_AVAILABLE": {
      "MESSAGE": "En ny versjon av appen er tilgjengelig. Last inn siden på nytt for å oppdatere.",
      "ACTION": "Last inn på nytt"
    },
    "ERROR_CHANGING_PIN_CODE": "Kunne ikke endre PIN-kode. Prøv igjen senere!",
    "ERROR_BLOCKING_ACCESS_CARD": "Kunne ikke blokkere adgangskort. Prøv igjen senere, men ta umiddelbart kontakt med resepsjonen og/eller din primære kontaktperson for å si ifra at adgangskortet må blokkeres.",
    "CLOUD_TASK_FAILED": "Det oppsto en feil i opprettelsen av en planlagt hendelse. Vennligst rapporter denne feilen til din administrator.",
    "FUNCTIONALITY_NOT_SUPPORTED_AT_POSTHUSET": "Funksjonaliteten er ikke tilgjengelig hos Posthuset. Kontakt administratoren din for å få hjelp.",
    "ERROR_CREATING_ACCESS_CARD": "Kunne ikke opprette adgangskort. Prøv igjen senere!",
    "CARD_FORMAT_ERROR": "Feil format på adgangskort. Vennligst endre kortnummeret og prøv igjen.",
    "CARD_ALREADY_EXISTS": "Adgangskortet eksisterer allerede. Vennligst endre kortnummeret og prøv igjen.",
    "USER_NOT_FOUND_IN_ACS": "Brukeren ble ikke funnet i adgangskontrollsystemet. Vennligst ta kontakt med din administrator.",
    "DELETE_PARTIAL_FAILURE": "Kunne ikke slette {{entity}}. Prøv igjen senere!",
    "REQUEST_BLOCKED": "Denne handlingen er ikke tillatt. Vennligst ta kontakt med din administrator.",
    "EXPORT_FAILED": "Kunne ikke eksportere {{entity}}. Prøv igjen senere!",
    "TRANSLATION_FAILED": "Kunne ikke oversette teksten. Prøv igjen senere!",
    "ERROR_SENDING_EMAIL": "Det oppstod en feil under sending av e-posten.",
    "GENERATE_AI_CONTENT_ERROR": "Det oppstod en feil i genereringen av innholdet. Prøv igjen senere!",
    "SEND_OTP_FAILED": "Kunne ikke sende bekreftelseskode på SMS. Prøv igjen senere!",
    "VALIDATION_ERROR": "En eller flere verdier er ugyldige. Vennligst se over skjemaet og prøv igjen.",
    "AUTHENTICATION_ERROR": "Autentisering feilet. Vennligst logg inn på nytt.",
    "DESCRIPTION_TOO_LONG": "Beskrivelsen er for lang. Vennligst forkort den og prøv igjen.",
    "IMAGES_LIMIT_EXCEEDED": "For mange bilder er forsøkt lastet opp. Vennligst last opp færre bilder og prøv igjen.",
    "RESOURCE_NOT_FOUND": "Vi kunne ikke finne den ressursen. Prøv igjen senere!",
    "BUILDING_NOT_FOUND": "Vi kunne ikke finne bygget. Vennligst sjekk byggets ID og prøv igjen.",
    "ROOM_NOT_FOUND": "Vi kunne ikke finne rommet. Vennligst sjekk rommets ID og prøv igjen.",
    "BOOKING_NOT_FOUND": "Vi kunne ikke finne reservasjonen. Vennligst sjekk reservasjonens ID og prøv igjen.",
    "FLOOR_NOT_FOUND": "Valgt etasje er ikke registrert i systemet. Vennligst påse at etasjen er riktig og prøv igjen.",
    "ROOM_NOT_AVAILABLE": "Dette rommet er ikke ledig til valgt tid. Vennligst velg et annet rom eller tid.",
    "ROOM_BLOCKED": "Dette rommet er blokkert for reservasjoner i valgt tidsrom. Vennligst velg et annet rom eller tid.",
    "ENTITY_ALREADY_EXISTS": "Entiteten eksisterer allerede. Vennligst velg et annet navn eller ID.",
    "MEETING_ROOM_ALREADY_EXISTS": "Et møterom med dette navnet eksisterer allerede. Vennligst velg et annet navn.",
    "BUILDING_ALREADY_EXISTS": "Dette bygget er allerede registrert og kan ikke integreres på nytt.",
    "FOOD_MAX_USERS_REACHED": "Du har ikke tilgang til å legge til flere brukere i henhold til avtalen med kantinedriver. Ta kontakt med kantinen for å utvide denne.",
    "ACCESS_CODE_GENERATION_FAILED": "Det oppstod en feil under genereringen av adgangskoden. Vennligst prøv igjen senere.",
    "ONLY_ONE_SUPPLIER_ALLOWED": "Bygget kan kun ha én aktiv leverandør om gangen. Vennligst endre selskapstypen til den nåværende leverandøren før du legger til en ny.",
    "FORGOT_CARD_CODE_GENERATION_DISABLED": "Generering av midlertidig adgangskode er deaktivert for dette bygget.",
    "FETCH_FAILED": "Det oppstod en feil under henting av data. Vennligst prøv igjen senere.",
    "SSO_REMOVED": "SSO domene {{domain}} slettet.",
    "LOW_FOOD_BALANCE": {
      "CRITICAL": "Du kan ikke lenger spise lunsj!",
      "LOW": "Du begynner å få lav lunsj-saldo!",
      "MESSAGE": "Husk å fylle på din saldo for å fortsette å bruke personalrestauranten.",
      "ACTION": "Fyll på din saldo her"
    },
    "PIN_MANAGEMENT_NOT_ALLOWED": "PIN-administrasjon er ikke aktivert for denne bygningen",
    "PIN_MANAGEMENT_NOT_ALLOWED_USER_ALREADY_SIGNED_IN": "Som bedriftsadministrator kan du kun sette PIN-kode for brukere som aldri har logget inn",
    "USER_NOT_FOUND": "Fant ikke brukeren. Prøv igjen senere!",
    "INVALID_PIN_CODE_FORMAT": "PIN-kode må være nøyaktig 4 sifre",
    "STARWATCH_USER_NOT_PROVISIONED": "Brukeren er ikke opprettet i adgangskontrollsystemet ennå. Prøv igjen senere.",
    "USER_DELETED_FROM_ACS": "Bruker slettet fra adgangskontrollsystemet",
    "ERROR_DELETING_USER_FROM_ACS": "Kunne ikke slette bruker fra adgangskontrollsystemet",
    "BOOKING_UPDATED": "{{entity}} ble oppdatert",
    "BOOKING_UPDATE_FAILED": "Kunne ikke oppdatere {{entity}}. Prøv igjen senere!",
    "ALREADY_EXISTS_IN_ACS": "Bruker med denne e-posten eksisterer allerede i adgangskontrollsystemet",
    "IMAGE_UPLOAD_SUCCESS": "Bildet ble lastet opp",
    "ALREADY_EXISTS_IN_ACS_NOTIFICATION": "Bruker med denne e-posten eksisterer allerede i adgangskontrollsystemet. Dupliserte brukere er ikke tillatt — kontakt support for å løse dette.",
    "INVALID_EMAIL_IN_ACS": "Adgangskontrollsystemet godtar ikke denne e-postadressen. Kontroller at brukerens e-post tilhører et eksisterende domene.",
    "ACS_CONNECTIVITY_LOST": "Tilkoblingen til adgangskontrollsystemet er tapt. Denne funksjonaliteten er utilgjengelig til tilkoblingen er gjenopprettet.",
    "FAILED_TO_DOWNLOAD": "Kunne ikke laste ned filen. Vennligst prøv igjen senere!",
    "WALLET_NOT_DISABLED": "Brukerens lommebok må deaktiveres før den kan refunderes.",
    "REFUND_REQUIRES_SUPPORT": "Denne refusjonen må håndteres av Welcome support. Vennligst kontakt support for å fortsette.",
    "REFUND_ALREADY_PENDING": "En refusjon behandles allerede for denne brukeren. Vennligst vent til den er fullført.",
    "REFUND_PENDING": "En refusjon behandles fortsatt for denne brukeren. Du kan reaktivere dem når den er fullført.",
    "WALLET_DISABLED": "Denne brukeren er deaktivert i lunsjsystemet. Reaktiver brukeren før du endrer avtalen.",
    "REFUND_FAILED": "Refusjonen kunne ikke opprettes hos betalingsleverandøren. Vennligst prøv igjen senere.",
    "NO_REFUNDABLE_TOPUP": "Det finnes ingen kvalifisert innbetaling å refundere mot for denne brukeren.",
    "INSUFFICIENT_BALANCE": "Refusjonsbeløpet overstiger brukerens tilgjengelige saldo.",
    "INVALID_AMOUNT": "Beløpet er ugyldig. Vennligst oppgi et beløp mellom 0,01 og 100 000 NOK.",
    "STARWATCH_INTEGRATION_NOT_ENABLED": "Starwatch-integrasjonen er ikke aktivert for dette bygget.",
    "STARWATCH_ACCESS_GROUP_NOT_FOUND": "Fant ikke gruppen i Starwatch. Synkroniser med Starwatch og prøv igjen.",
    "STARWATCH_ACCESS_GROUP_REMOVED": "Denne gruppen er fjernet i Starwatch og kan ikke velges.",
    "STARWATCH_ROLE_NOT_FOUND": "Adgangsgruppen finnes ikke lenger. Last inn siden på nytt og prøv igjen.",
    "ACCESS_ROLE_MANAGEMENT_NOT_ENABLED": "Administrasjon av adgangsgrupper er ikke aktivert for dette bygget."
  },
  "FOOD_LOGIN": {
    "COMPLETING_TITLE": "Kobler til kiosken…",
    "COMPLETING_BODY": "Vennligst vent.",
    "DONE_TITLE": "Du er nå innlogget på kiosken!",
    "NO_ACCESS_TITLE": "Ingen tilgang",
    "NO_ACCESS_BODY": "Denne kontoen har ikke tilgang til matkiosken. Ta kontakt med administrator av kantineselskapet.",
    "EXPIRED_TITLE": "QR-koden er utløpt",
    "EXPIRED_BODY": "Prøv å skanne QR-koden på nytt.",
    "ERROR_TITLE": "Noe gikk galt",
    "ERROR_BODY": "Prøv å skanne QR-koden på nytt.",
    "REDIRECT_COUNTDOWN": "Ellers videresendes du til portalen om {{seconds}} sekunder.",
    "GO_TO_DASHBOARD": "Gå til portalen nå",
    "CLOSE_TAB": "Du kan trygt lukke denne fanen."
  },
  "ACS_CONNECTIVITY": {
    "BANNER_TEXT": "Tilkoblingen til adgangskontrollsystemet er nede. Endringer i adgangsgrupper og kort er midlertidig deaktivert.",
    "BUTTON_TOOLTIP": "Tilkoblingen til adgangskontrollsystemet er nede."
  },
  "SNACK_CUTOFF": {
    "COMMON": {
      "CURRENT_SETTING": "Nåværende innstilling:",
      "UNSAVED_SETTING": "Ny innstilling (ikke lagret):",
      "TYPES": {
        "NONE": {
          "LABEL": "Ingen begrensing"
        },
        "ROLLING": {
          "LABEL": "Løpende frist",
          "DESCRIPTION": "Regnes fra bestillingstidspunktet."
        },
        "FIXED": {
          "LABEL": "Fast tidsfrist",
          "DESCRIPTION": "Et fast klokkeslett hver dag avgjør fristen."
        }
      },
      "ROLLING": {
        "AT_LEAST": "Minst",
        "BEFORE_DELIVERY": "før ønsket leveringstidspunkt",
        "EARLIEST_ORDER": "Tidligste bestilling",
        "COUNTS_WEEKENDS": "Løpende frister teller alle timer, også i helgene."
      },
      "FIXED": {
        "ORDERS_PLACED_BEFORE": "Bestillinger lagt inn før",
        "DEADLINE": "Tidsfrist",
        "CAN_BE_COMPLETED_IN": "kan fullføres om",
        "WEEKDAYS_one": "hverdag",
        "WEEKDAYS_other": "hverdager"
      },
      "TIMELINE": {
        "ORDERED_BEFORE": "Bestilt <strong>før {{time}}</strong>",
        "ORDERED_AFTER": "Bestilt <strong>etter {{time}}</strong>"
      },
      "SUMMARY": {
        "MONDAY_EXAMPLE": "For levering på mandag: bestill før {{weekday}} {{time}} ({{calendarDays}} dager før)."
      },
      "WEEKDAYS": {
        "MONDAY": "mandag",
        "TUESDAY": "tirsdag",
        "WEDNESDAY": "onsdag",
        "THURSDAY": "torsdag",
        "FRIDAY": "fredag"
      }
    },
    "RESTAURANT": {
      "TITLE": "Begrens når bestillinger kan gjøres",
      "GENERAL_SETTING_INFO": "Dette er en generell innstilling for restauranten, men kan bli overskrevet av enkelte menygjenstander.",
      "SUMMARY": {
        "NONE": "Ingen begrensing. Bestillinger kan fullføres med én gang.",
        "ROLLING": "Bestillinger må legges inn minst {{amount}} {{unit}} før ønsket leveringstidspunkt.",
        "FIXED_SAME_DAY": "Bestillinger lagt inn før {{time}} kan fullføres samme dag.",
        "FIXED_NEXT_DAY": "Bestillinger lagt inn før {{time}} kan fullføres ved åpningstid dagen etter.",
        "FIXED_LATER": "Bestillinger lagt inn før {{time}} kan fullføres ved åpningstid {{days}} dager senere.",
        "FIXED_NEXT_WEEKDAY": "Bestillinger lagt inn før {{time}} kan fullføres ved åpningstid neste hverdag.",
        "FIXED_WEEKDAYS_LATER": "Bestillinger lagt inn før {{time}} kan fullføres ved åpningstid {{days}} hverdager senere."
      },
      "TYPES": {
        "NONE": {
          "DESCRIPTION": "Bestillinger kan legges inn når som helst."
        },
        "ROLLING": {
          "DESCRIPTION": "Regnes fra bestillingstidspunktet."
        }
      }
    },
    "ITEM": {
      "TITLE": "Begrens når produktet kan bestilles",
      "INHERITING_INFO": "Produktet følger restaurantens standard innstilling. Tilpass for å sette en egen begrensning for dette produktet.",
      "OVERRIDING_INFO": "Produktet har en egen begrensning som erstatter restaurantens standard innstilling.",
      "CUSTOMISE": "Tilpass",
      "RESET": "Tilbakestill til standard",
      "SUMMARY": {
        "NONE": "Ingen begrensing. Varen kan leveres med én gang.",
        "ROLLING": "Varen må bestilles minst {{amount}} {{unit}} før ønsket leveringstidspunkt.",
        "FIXED_SAME_DAY": "Dersom produktet bestilles før {{time}} kan det leveres samme dag.",
        "FIXED_NEXT_DAY": "Dersom produktet bestilles før {{time}} kan det leveres ved åpningstid dagen etter.",
        "FIXED_LATER": "Dersom produktet bestilles før {{time}} kan det leveres ved åpningstid {{days}} dager senere.",
        "FIXED_NEXT_WEEKDAY": "Dersom produktet bestilles før {{time}} kan det leveres ved åpningstid neste hverdag.",
        "FIXED_WEEKDAYS_LATER": "Dersom produktet bestilles før {{time}} kan det leveres ved åpningstid {{days}} hverdager senere."
      },
      "TYPES": {
        "NONE": {
          "DESCRIPTION": "Produktet kan bestilles når som helst."
        }
      }
    },
    "ITEMS": {
      "ACTION": "Sett bestillingsfrist for alle produkter",
      "TITLE": "Begrens når produktene kan bestilles",
      "INFO_one": "Begrensningen du lagrer erstatter nåværende begrensning på produktet i denne kategorien.",
      "INFO_other": "Begrensningen du lagrer erstatter nåværende begrensning på alle produktene i denne kategorien.",
      "INFO_SELECTED_one": "Begrensningen du lagrer erstatter nåværende begrensning på det valgte produktet.",
      "INFO_SELECTED_other": "Begrensningen du lagrer erstatter nåværende begrensning på alle valgte produkter.",
      "ACTION_SELECTED": "Sett bestillingsfrist for valgte produkter",
      "SELECTED": "Valgte",
      "RESET": "Tilbakestill alle til restaurantens standard",
      "RESET_INFO": "Fjerner produktenes egne begrensninger slik at de følger restaurantens standard innstilling.",
      "TOO_MANY": "Du kan endre bestillingsfristen for maks {{max}} produkter om gangen. Velg færre produkter og prøv igjen.",
      "TYPES": {
        "NONE": {
          "DESCRIPTION": "Produktene kan bestilles når som helst."
        }
      },
      "OVERRIDE_INFO": "Alle produktene har samme egne frist",
      "DEFAULT_INFO": "Alle produktene følger restaurantens standard frist",
      "SUMMARY": {
        "NONE": "Ingen begrensning. Produktene kan leveres med én gang.",
        "ROLLING": "Produktene må bestilles minst {{amount}} {{unit}} før ønsket leveringstidspunkt.",
        "FIXED_SAME_DAY": "Dersom produktene bestilles før {{time}} kan de leveres samme dag.",
        "FIXED_NEXT_DAY": "Dersom produktene bestilles før {{time}} kan de leveres ved åpningstid dagen etter.",
        "FIXED_LATER": "Dersom produktene bestilles før {{time}} kan de leveres ved åpningstid {{days}} dager senere.",
        "FIXED_NEXT_WEEKDAY": "Dersom produktene bestilles før {{time}} kan de leveres ved åpningstid neste hverdag.",
        "FIXED_WEEKDAYS_LATER": "Dersom produktene bestilles før {{time}} kan de leveres ved åpningstid {{days}} hverdager senere."
      }
    }
  }
}
